var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlaystoreQr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 145,
    viewBox: "0 0 145 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_795_83251",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 145,
    height: 145
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clip-path-dot-color"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.24556 38.9169C3.12763 38.9169 3.84269 38.2018 3.84269 37.3198C3.84269 36.4377 3.12763 35.7227 2.24556 35.7227C1.36349 35.7227 0.648438 36.4377 0.648438 37.3198C0.648438 38.2018 1.36349 38.9169 2.24556 38.9169Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M2.24556 58.0819C3.12763 58.0819 3.84269 57.3669 3.84269 56.4848C3.84269 55.6028 3.12763 54.8877 2.24556 54.8877C1.36349 54.8877 0.648438 55.6028 0.648438 56.4848C0.648438 57.3669 1.36349 58.0819 2.24556 58.0819Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M2.24556 61.2763C3.12763 61.2763 3.84269 60.5612 3.84269 59.6792C3.84269 58.7971 3.12763 58.082 2.24556 58.082C1.36349 58.082 0.648438 58.7971 0.648438 59.6792C0.648438 60.5612 1.36349 61.2763 2.24556 61.2763Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M2.24556 64.4706C3.12763 64.4706 3.84269 63.7556 3.84269 62.8735C3.84269 61.9914 3.12763 61.2764 2.24556 61.2764C1.36349 61.2764 0.648438 61.9914 0.648438 62.8735C0.648438 63.7556 1.36349 64.4706 2.24556 64.4706Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M2.24556 70.8593C3.12763 70.8593 3.84269 70.1442 3.84269 69.2622C3.84269 68.3801 3.12763 67.665 2.24556 67.665C1.36349 67.665 0.648438 68.3801 0.648438 69.2622C0.648438 70.1442 1.36349 70.8593 2.24556 70.8593Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M2.24556 74.0536C3.12763 74.0536 3.84269 73.3386 3.84269 72.4565C3.84269 71.5744 3.12763 70.8594 2.24556 70.8594C1.36349 70.8594 0.648438 71.5744 0.648438 72.4565C0.648438 73.3386 1.36349 74.0536 2.24556 74.0536Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M2.24556 77.248C3.12763 77.248 3.84269 76.5329 3.84269 75.6508C3.84269 74.7688 3.12763 74.0537 2.24556 74.0537C1.36349 74.0537 0.648438 74.7688 0.648438 75.6508C0.648438 76.5329 1.36349 77.248 2.24556 77.248Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M2.24556 86.831C3.12763 86.831 3.84269 86.1159 3.84269 85.2338C3.84269 84.3518 3.12763 83.6367 2.24556 83.6367C1.36349 83.6367 0.648438 84.3518 0.648438 85.2338C0.648438 86.1159 1.36349 86.831 2.24556 86.831Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M2.24556 90.0253C3.12763 90.0253 3.84269 89.3102 3.84269 88.4282C3.84269 87.5461 3.12763 86.8311 2.24556 86.8311C1.36349 86.8311 0.648438 87.5461 0.648438 88.4282C0.648438 89.3102 1.36349 90.0253 2.24556 90.0253Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M2.24556 93.2187C3.12763 93.2187 3.84269 92.5036 3.84269 91.6215C3.84269 90.7395 3.12763 90.0244 2.24556 90.0244C1.36349 90.0244 0.648438 90.7395 0.648438 91.6215C0.648438 92.5036 1.36349 93.2187 2.24556 93.2187Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M2.24556 96.413C3.12763 96.413 3.84269 95.6979 3.84269 94.8159C3.84269 93.9338 3.12763 93.2188 2.24556 93.2188C1.36349 93.2188 0.648438 93.9338 0.648438 94.8159C0.648438 95.6979 1.36349 96.413 2.24556 96.413Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M2.24556 99.6073C3.12763 99.6073 3.84269 98.8923 3.84269 98.0102C3.84269 97.1281 3.12763 96.4131 2.24556 96.4131C1.36349 96.4131 0.648438 97.1281 0.648438 98.0102C0.648438 98.8923 1.36349 99.6073 2.24556 99.6073Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M2.24556 102.802C3.12763 102.802 3.84269 102.087 3.84269 101.205C3.84269 100.322 3.12763 99.6074 2.24556 99.6074C1.36349 99.6074 0.648438 100.322 0.648438 101.205C0.648438 102.087 1.36349 102.802 2.24556 102.802Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M2.24556 105.996C3.12763 105.996 3.84269 105.281 3.84269 104.399C3.84269 103.517 3.12763 102.802 2.24556 102.802C1.36349 102.802 0.648438 103.517 0.648438 104.399C0.648438 105.281 1.36349 105.996 2.24556 105.996Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M2.24556 109.19C3.12763 109.19 3.84269 108.475 3.84269 107.593C3.84269 106.711 3.12763 105.996 2.24556 105.996C1.36349 105.996 0.648438 106.711 0.648438 107.593C0.648438 108.475 1.36349 109.19 2.24556 109.19Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M2.24556 118.773C3.12763 118.773 3.84269 118.058 3.84269 117.176C3.84269 116.294 3.12763 115.579 2.24556 115.579C1.36349 115.579 0.648438 116.294 0.648438 117.176C0.648438 118.058 1.36349 118.773 2.24556 118.773Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M5.43892 38.9169C6.32099 38.9169 7.03605 38.2018 7.03605 37.3198C7.03605 36.4377 6.32099 35.7227 5.43892 35.7227C4.55685 35.7227 3.8418 36.4377 3.8418 37.3198C3.8418 38.2018 4.55685 38.9169 5.43892 38.9169Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M5.43892 42.1112C6.32099 42.1112 7.03605 41.3962 7.03605 40.5141C7.03605 39.632 6.32099 38.917 5.43892 38.917C4.55685 38.917 3.8418 39.632 3.8418 40.5141C3.8418 41.3962 4.55685 42.1112 5.43892 42.1112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M5.43892 45.3056C6.32099 45.3056 7.03605 44.5905 7.03605 43.7085C7.03605 42.8264 6.32099 42.1113 5.43892 42.1113C4.55685 42.1113 3.8418 42.8264 3.8418 43.7085C3.8418 44.5905 4.55685 45.3056 5.43892 45.3056Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M5.43892 48.4999C6.32099 48.4999 7.03605 47.7849 7.03605 46.9028C7.03605 46.0207 6.32099 45.3057 5.43892 45.3057C4.55685 45.3057 3.8418 46.0207 3.8418 46.9028C3.8418 47.7849 4.55685 48.4999 5.43892 48.4999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M5.43892 58.0819C6.32099 58.0819 7.03605 57.3669 7.03605 56.4848C7.03605 55.6028 6.32099 54.8877 5.43892 54.8877C4.55685 54.8877 3.8418 55.6028 3.8418 56.4848C3.8418 57.3669 4.55685 58.0819 5.43892 58.0819Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M5.43892 61.2763C6.32099 61.2763 7.03605 60.5612 7.03605 59.6792C7.03605 58.7971 6.32099 58.082 5.43892 58.082C4.55685 58.082 3.8418 58.7971 3.8418 59.6792C3.8418 60.5612 4.55685 61.2763 5.43892 61.2763Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M5.43892 64.4706C6.32099 64.4706 7.03605 63.7556 7.03605 62.8735C7.03605 61.9914 6.32099 61.2764 5.43892 61.2764C4.55685 61.2764 3.8418 61.9914 3.8418 62.8735C3.8418 63.7556 4.55685 64.4706 5.43892 64.4706Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M5.43892 70.8593C6.32099 70.8593 7.03605 70.1442 7.03605 69.2622C7.03605 68.3801 6.32099 67.665 5.43892 67.665C4.55685 67.665 3.8418 68.3801 3.8418 69.2622C3.8418 70.1442 4.55685 70.8593 5.43892 70.8593Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M5.43892 80.4423C6.32099 80.4423 7.03605 79.7272 7.03605 78.8452C7.03605 77.9631 6.32099 77.248 5.43892 77.248C4.55685 77.248 3.8418 77.9631 3.8418 78.8452C3.8418 79.7272 4.55685 80.4423 5.43892 80.4423Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M5.43892 83.6366C6.32099 83.6366 7.03605 82.9216 7.03605 82.0395C7.03605 81.1574 6.32099 80.4424 5.43892 80.4424C4.55685 80.4424 3.8418 81.1574 3.8418 82.0395C3.8418 82.9216 4.55685 83.6366 5.43892 83.6366Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M5.43892 90.0253C6.32099 90.0253 7.03605 89.3102 7.03605 88.4282C7.03605 87.5461 6.32099 86.8311 5.43892 86.8311C4.55685 86.8311 3.8418 87.5461 3.8418 88.4282C3.8418 89.3102 4.55685 90.0253 5.43892 90.0253Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M5.43892 93.2187C6.32099 93.2187 7.03605 92.5036 7.03605 91.6215C7.03605 90.7395 6.32099 90.0244 5.43892 90.0244C4.55685 90.0244 3.8418 90.7395 3.8418 91.6215C3.8418 92.5036 4.55685 93.2187 5.43892 93.2187Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M5.43892 102.802C6.32099 102.802 7.03605 102.087 7.03605 101.205C7.03605 100.322 6.32099 99.6074 5.43892 99.6074C4.55685 99.6074 3.8418 100.322 3.8418 101.205C3.8418 102.087 4.55685 102.802 5.43892 102.802Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M5.43892 105.996C6.32099 105.996 7.03605 105.281 7.03605 104.399C7.03605 103.517 6.32099 102.802 5.43892 102.802C4.55685 102.802 3.8418 103.517 3.8418 104.399C3.8418 105.281 4.55685 105.996 5.43892 105.996Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M5.43892 109.19C6.32099 109.19 7.03605 108.475 7.03605 107.593C7.03605 106.711 6.32099 105.996 5.43892 105.996C4.55685 105.996 3.8418 106.711 3.8418 107.593C3.8418 108.475 4.55685 109.19 5.43892 109.19Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M5.43892 115.579C6.32099 115.579 7.03605 114.864 7.03605 113.982C7.03605 113.1 6.32099 112.385 5.43892 112.385C4.55685 112.385 3.8418 113.1 3.8418 113.982C3.8418 114.864 4.55685 115.579 5.43892 115.579Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M8.63423 29.3339C9.5163 29.3339 10.2314 28.6188 10.2314 27.7368C10.2314 26.8547 9.5163 26.1396 8.63423 26.1396C7.75217 26.1396 7.03711 26.8547 7.03711 27.7368C7.03711 28.6188 7.75217 29.3339 8.63423 29.3339Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M8.63423 32.5282C9.5163 32.5282 10.2314 31.8132 10.2314 30.9311C10.2314 30.049 9.5163 29.334 8.63423 29.334C7.75217 29.334 7.03711 30.049 7.03711 30.9311C7.03711 31.8132 7.75217 32.5282 8.63423 32.5282Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M8.63423 35.7226C9.5163 35.7226 10.2314 35.0075 10.2314 34.1254C10.2314 33.2434 9.5163 32.5283 8.63423 32.5283C7.75217 32.5283 7.03711 33.2434 7.03711 34.1254C7.03711 35.0075 7.75217 35.7226 8.63423 35.7226Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M8.63423 42.1112C9.5163 42.1112 10.2314 41.3962 10.2314 40.5141C10.2314 39.632 9.5163 38.917 8.63423 38.917C7.75217 38.917 7.03711 39.632 7.03711 40.5141C7.03711 41.3962 7.75217 42.1112 8.63423 42.1112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M8.63423 45.3056C9.5163 45.3056 10.2314 44.5905 10.2314 43.7085C10.2314 42.8264 9.5163 42.1113 8.63423 42.1113C7.75217 42.1113 7.03711 42.8264 7.03711 43.7085C7.03711 44.5905 7.75217 45.3056 8.63423 45.3056Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M8.63423 48.4999C9.5163 48.4999 10.2314 47.7849 10.2314 46.9028C10.2314 46.0207 9.5163 45.3057 8.63423 45.3057C7.75217 45.3057 7.03711 46.0207 7.03711 46.9028C7.03711 47.7849 7.75217 48.4999 8.63423 48.4999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M8.63423 51.6942C9.5163 51.6942 10.2314 50.9792 10.2314 50.0971C10.2314 49.2151 9.5163 48.5 8.63423 48.5C7.75217 48.5 7.03711 49.2151 7.03711 50.0971C7.03711 50.9792 7.75217 51.6942 8.63423 51.6942Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M8.63423 54.8886C9.5163 54.8886 10.2314 54.1735 10.2314 53.2915C10.2314 52.4094 9.5163 51.6943 8.63423 51.6943C7.75217 51.6943 7.03711 52.4094 7.03711 53.2915C7.03711 54.1735 7.75217 54.8886 8.63423 54.8886Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M8.63423 67.665C9.5163 67.665 10.2314 66.9499 10.2314 66.0678C10.2314 65.1858 9.5163 64.4707 8.63423 64.4707C7.75217 64.4707 7.03711 65.1858 7.03711 66.0678C7.03711 66.9499 7.75217 67.665 8.63423 67.665Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M8.63423 77.248C9.5163 77.248 10.2314 76.5329 10.2314 75.6508C10.2314 74.7688 9.5163 74.0537 8.63423 74.0537C7.75217 74.0537 7.03711 74.7688 7.03711 75.6508C7.03711 76.5329 7.75217 77.248 8.63423 77.248Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M8.63423 83.6366C9.5163 83.6366 10.2314 82.9216 10.2314 82.0395C10.2314 81.1574 9.5163 80.4424 8.63423 80.4424C7.75217 80.4424 7.03711 81.1574 7.03711 82.0395C7.03711 82.9216 7.75217 83.6366 8.63423 83.6366Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    d: "M8.63423 99.6073C9.5163 99.6073 10.2314 98.8923 10.2314 98.0102C10.2314 97.1281 9.5163 96.4131 8.63423 96.4131C7.75217 96.4131 7.03711 97.1281 7.03711 98.0102C7.03711 98.8923 7.75217 99.6073 8.63423 99.6073Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    d: "M8.63423 105.996C9.5163 105.996 10.2314 105.281 10.2314 104.399C10.2314 103.517 9.5163 102.802 8.63423 102.802C7.75217 102.802 7.03711 103.517 7.03711 104.399C7.03711 105.281 7.75217 105.996 8.63423 105.996Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    d: "M8.63423 109.19C9.5163 109.19 10.2314 108.475 10.2314 107.593C10.2314 106.711 9.5163 105.996 8.63423 105.996C7.75217 105.996 7.03711 106.711 7.03711 107.593C7.03711 108.475 7.75217 109.19 8.63423 109.19Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_47",
    d: "M8.63423 115.579C9.5163 115.579 10.2314 114.864 10.2314 113.982C10.2314 113.1 9.5163 112.385 8.63423 112.385C7.75217 112.385 7.03711 113.1 7.03711 113.982C7.03711 114.864 7.75217 115.579 8.63423 115.579Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_48",
    d: "M11.8276 38.9169C12.7097 38.9169 13.4247 38.2018 13.4247 37.3198C13.4247 36.4377 12.7097 35.7227 11.8276 35.7227C10.9455 35.7227 10.2305 36.4377 10.2305 37.3198C10.2305 38.2018 10.9455 38.9169 11.8276 38.9169Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_49",
    d: "M11.8276 48.4999C12.7097 48.4999 13.4247 47.7849 13.4247 46.9028C13.4247 46.0207 12.7097 45.3057 11.8276 45.3057C10.9455 45.3057 10.2305 46.0207 10.2305 46.9028C10.2305 47.7849 10.9455 48.4999 11.8276 48.4999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_50",
    d: "M11.8276 51.6942C12.7097 51.6942 13.4247 50.9792 13.4247 50.0971C13.4247 49.2151 12.7097 48.5 11.8276 48.5C10.9455 48.5 10.2305 49.2151 10.2305 50.0971C10.2305 50.9792 10.9455 51.6942 11.8276 51.6942Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_51",
    d: "M11.8276 58.0819C12.7097 58.0819 13.4247 57.3669 13.4247 56.4848C13.4247 55.6028 12.7097 54.8877 11.8276 54.8877C10.9455 54.8877 10.2305 55.6028 10.2305 56.4848C10.2305 57.3669 10.9455 58.0819 11.8276 58.0819Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_52",
    d: "M11.8276 83.6366C12.7097 83.6366 13.4247 82.9216 13.4247 82.0395C13.4247 81.1574 12.7097 80.4424 11.8276 80.4424C10.9455 80.4424 10.2305 81.1574 10.2305 82.0395C10.2305 82.9216 10.9455 83.6366 11.8276 83.6366Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_53",
    d: "M11.8276 93.2187C12.7097 93.2187 13.4247 92.5036 13.4247 91.6215C13.4247 90.7395 12.7097 90.0244 11.8276 90.0244C10.9455 90.0244 10.2305 90.7395 10.2305 91.6215C10.2305 92.5036 10.9455 93.2187 11.8276 93.2187Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_54",
    d: "M11.8276 102.802C12.7097 102.802 13.4247 102.087 13.4247 101.205C13.4247 100.322 12.7097 99.6074 11.8276 99.6074C10.9455 99.6074 10.2305 100.322 10.2305 101.205C10.2305 102.087 10.9455 102.802 11.8276 102.802Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_55",
    d: "M11.8276 115.579C12.7097 115.579 13.4247 114.864 13.4247 113.982C13.4247 113.1 12.7097 112.385 11.8276 112.385C10.9455 112.385 10.2305 113.1 10.2305 113.982C10.2305 114.864 10.9455 115.579 11.8276 115.579Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_56",
    d: "M11.8276 118.773C12.7097 118.773 13.4247 118.058 13.4247 117.176C13.4247 116.294 12.7097 115.579 11.8276 115.579C10.9455 115.579 10.2305 116.294 10.2305 117.176C10.2305 118.058 10.9455 118.773 11.8276 118.773Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_57",
    d: "M15.021 29.3339C15.903 29.3339 16.6181 28.6188 16.6181 27.7368C16.6181 26.8547 15.903 26.1396 15.021 26.1396C14.1389 26.1396 13.4238 26.8547 13.4238 27.7368C13.4238 28.6188 14.1389 29.3339 15.021 29.3339Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_58",
    d: "M15.021 35.7226C15.903 35.7226 16.6181 35.0075 16.6181 34.1254C16.6181 33.2434 15.903 32.5283 15.021 32.5283C14.1389 32.5283 13.4238 33.2434 13.4238 34.1254C13.4238 35.0075 14.1389 35.7226 15.021 35.7226Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_59",
    d: "M15.021 45.3056C15.903 45.3056 16.6181 44.5905 16.6181 43.7085C16.6181 42.8264 15.903 42.1113 15.021 42.1113C14.1389 42.1113 13.4238 42.8264 13.4238 43.7085C13.4238 44.5905 14.1389 45.3056 15.021 45.3056Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_60",
    d: "M15.021 54.8886C15.903 54.8886 16.6181 54.1735 16.6181 53.2915C16.6181 52.4094 15.903 51.6943 15.021 51.6943C14.1389 51.6943 13.4238 52.4094 13.4238 53.2915C13.4238 54.1735 14.1389 54.8886 15.021 54.8886Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_61",
    d: "M15.021 58.0819C15.903 58.0819 16.6181 57.3669 16.6181 56.4848C16.6181 55.6028 15.903 54.8877 15.021 54.8877C14.1389 54.8877 13.4238 55.6028 13.4238 56.4848C13.4238 57.3669 14.1389 58.0819 15.021 58.0819Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_62",
    d: "M15.021 67.665C15.903 67.665 16.6181 66.9499 16.6181 66.0678C16.6181 65.1858 15.903 64.4707 15.021 64.4707C14.1389 64.4707 13.4238 65.1858 13.4238 66.0678C13.4238 66.9499 14.1389 67.665 15.021 67.665Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_63",
    d: "M15.021 70.8593C15.903 70.8593 16.6181 70.1442 16.6181 69.2622C16.6181 68.3801 15.903 67.665 15.021 67.665C14.1389 67.665 13.4238 68.3801 13.4238 69.2622C13.4238 70.1442 14.1389 70.8593 15.021 70.8593Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_64",
    d: "M15.021 74.0536C15.903 74.0536 16.6181 73.3386 16.6181 72.4565C16.6181 71.5744 15.903 70.8594 15.021 70.8594C14.1389 70.8594 13.4238 71.5744 13.4238 72.4565C13.4238 73.3386 14.1389 74.0536 15.021 74.0536Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_65",
    d: "M15.021 77.248C15.903 77.248 16.6181 76.5329 16.6181 75.6508C16.6181 74.7688 15.903 74.0537 15.021 74.0537C14.1389 74.0537 13.4238 74.7688 13.4238 75.6508C13.4238 76.5329 14.1389 77.248 15.021 77.248Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_66",
    d: "M15.021 80.4423C15.903 80.4423 16.6181 79.7272 16.6181 78.8452C16.6181 77.9631 15.903 77.248 15.021 77.248C14.1389 77.248 13.4238 77.9631 13.4238 78.8452C13.4238 79.7272 14.1389 80.4423 15.021 80.4423Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_67",
    d: "M15.021 86.831C15.903 86.831 16.6181 86.1159 16.6181 85.2338C16.6181 84.3518 15.903 83.6367 15.021 83.6367C14.1389 83.6367 13.4238 84.3518 13.4238 85.2338C13.4238 86.1159 14.1389 86.831 15.021 86.831Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_68",
    d: "M15.021 99.6073C15.903 99.6073 16.6181 98.8923 16.6181 98.0102C16.6181 97.1281 15.903 96.4131 15.021 96.4131C14.1389 96.4131 13.4238 97.1281 13.4238 98.0102C13.4238 98.8923 14.1389 99.6073 15.021 99.6073Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_69",
    d: "M15.021 102.802C15.903 102.802 16.6181 102.087 16.6181 101.205C16.6181 100.322 15.903 99.6074 15.021 99.6074C14.1389 99.6074 13.4238 100.322 13.4238 101.205C13.4238 102.087 14.1389 102.802 15.021 102.802Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_70",
    d: "M15.021 109.19C15.903 109.19 16.6181 108.475 16.6181 107.593C16.6181 106.711 15.903 105.996 15.021 105.996C14.1389 105.996 13.4238 106.711 13.4238 107.593C13.4238 108.475 14.1389 109.19 15.021 109.19Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_71",
    d: "M15.021 112.385C15.903 112.385 16.6181 111.67 16.6181 110.788C16.6181 109.905 15.903 109.19 15.021 109.19C14.1389 109.19 13.4238 109.905 13.4238 110.788C13.4238 111.67 14.1389 112.385 15.021 112.385Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_72",
    d: "M15.021 115.579C15.903 115.579 16.6181 114.864 16.6181 113.982C16.6181 113.1 15.903 112.385 15.021 112.385C14.1389 112.385 13.4238 113.1 13.4238 113.982C13.4238 114.864 14.1389 115.579 15.021 115.579Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_73",
    d: "M15.021 118.773C15.903 118.773 16.6181 118.058 16.6181 117.176C16.6181 116.294 15.903 115.579 15.021 115.579C14.1389 115.579 13.4238 116.294 13.4238 117.176C13.4238 118.058 14.1389 118.773 15.021 118.773Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_74",
    d: "M18.2163 29.3339C19.0983 29.3339 19.8134 28.6188 19.8134 27.7368C19.8134 26.8547 19.0983 26.1396 18.2163 26.1396C17.3342 26.1396 16.6191 26.8547 16.6191 27.7368C16.6191 28.6188 17.3342 29.3339 18.2163 29.3339Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_75",
    d: "M18.2163 32.5282C19.0983 32.5282 19.8134 31.8132 19.8134 30.9311C19.8134 30.049 19.0983 29.334 18.2163 29.334C17.3342 29.334 16.6191 30.049 16.6191 30.9311C16.6191 31.8132 17.3342 32.5282 18.2163 32.5282Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_76",
    d: "M18.2163 38.9169C19.0983 38.9169 19.8134 38.2018 19.8134 37.3198C19.8134 36.4377 19.0983 35.7227 18.2163 35.7227C17.3342 35.7227 16.6191 36.4377 16.6191 37.3198C16.6191 38.2018 17.3342 38.9169 18.2163 38.9169Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_77",
    d: "M18.2163 45.3056C19.0983 45.3056 19.8134 44.5905 19.8134 43.7085C19.8134 42.8264 19.0983 42.1113 18.2163 42.1113C17.3342 42.1113 16.6191 42.8264 16.6191 43.7085C16.6191 44.5905 17.3342 45.3056 18.2163 45.3056Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_78",
    d: "M18.2163 54.8886C19.0983 54.8886 19.8134 54.1735 19.8134 53.2915C19.8134 52.4094 19.0983 51.6943 18.2163 51.6943C17.3342 51.6943 16.6191 52.4094 16.6191 53.2915C16.6191 54.1735 17.3342 54.8886 18.2163 54.8886Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_79",
    d: "M18.2163 64.4706C19.0983 64.4706 19.8134 63.7556 19.8134 62.8735C19.8134 61.9914 19.0983 61.2764 18.2163 61.2764C17.3342 61.2764 16.6191 61.9914 16.6191 62.8735C16.6191 63.7556 17.3342 64.4706 18.2163 64.4706Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_80",
    d: "M18.2163 67.665C19.0983 67.665 19.8134 66.9499 19.8134 66.0678C19.8134 65.1858 19.0983 64.4707 18.2163 64.4707C17.3342 64.4707 16.6191 65.1858 16.6191 66.0678C16.6191 66.9499 17.3342 67.665 18.2163 67.665Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_81",
    d: "M18.2163 80.4423C19.0983 80.4423 19.8134 79.7272 19.8134 78.8452C19.8134 77.9631 19.0983 77.248 18.2163 77.248C17.3342 77.248 16.6191 77.9631 16.6191 78.8452C16.6191 79.7272 17.3342 80.4423 18.2163 80.4423Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_82",
    d: "M18.2163 86.831C19.0983 86.831 19.8134 86.1159 19.8134 85.2338C19.8134 84.3518 19.0983 83.6367 18.2163 83.6367C17.3342 83.6367 16.6191 84.3518 16.6191 85.2338C16.6191 86.1159 17.3342 86.831 18.2163 86.831Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_83",
    d: "M18.2163 90.0253C19.0983 90.0253 19.8134 89.3102 19.8134 88.4282C19.8134 87.5461 19.0983 86.8311 18.2163 86.8311C17.3342 86.8311 16.6191 87.5461 16.6191 88.4282C16.6191 89.3102 17.3342 90.0253 18.2163 90.0253Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_84",
    d: "M18.2163 93.2187C19.0983 93.2187 19.8134 92.5036 19.8134 91.6215C19.8134 90.7395 19.0983 90.0244 18.2163 90.0244C17.3342 90.0244 16.6191 90.7395 16.6191 91.6215C16.6191 92.5036 17.3342 93.2187 18.2163 93.2187Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_85",
    d: "M18.2163 105.996C19.0983 105.996 19.8134 105.281 19.8134 104.399C19.8134 103.517 19.0983 102.802 18.2163 102.802C17.3342 102.802 16.6191 103.517 16.6191 104.399C16.6191 105.281 17.3342 105.996 18.2163 105.996Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_86",
    d: "M21.4116 29.3339C22.2936 29.3339 23.0087 28.6188 23.0087 27.7368C23.0087 26.8547 22.2936 26.1396 21.4116 26.1396C20.5295 26.1396 19.8145 26.8547 19.8145 27.7368C19.8145 28.6188 20.5295 29.3339 21.4116 29.3339Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_87",
    d: "M21.4116 35.7226C22.2936 35.7226 23.0087 35.0075 23.0087 34.1254C23.0087 33.2434 22.2936 32.5283 21.4116 32.5283C20.5295 32.5283 19.8145 33.2434 19.8145 34.1254C19.8145 35.0075 20.5295 35.7226 21.4116 35.7226Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_88",
    d: "M21.4116 42.1112C22.2936 42.1112 23.0087 41.3962 23.0087 40.5141C23.0087 39.632 22.2936 38.917 21.4116 38.917C20.5295 38.917 19.8145 39.632 19.8145 40.5141C19.8145 41.3962 20.5295 42.1112 21.4116 42.1112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_89",
    d: "M21.4116 48.4999C22.2936 48.4999 23.0087 47.7849 23.0087 46.9028C23.0087 46.0207 22.2936 45.3057 21.4116 45.3057C20.5295 45.3057 19.8145 46.0207 19.8145 46.9028C19.8145 47.7849 20.5295 48.4999 21.4116 48.4999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_90",
    d: "M21.4116 54.8886C22.2936 54.8886 23.0087 54.1735 23.0087 53.2915C23.0087 52.4094 22.2936 51.6943 21.4116 51.6943C20.5295 51.6943 19.8145 52.4094 19.8145 53.2915C19.8145 54.1735 20.5295 54.8886 21.4116 54.8886Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_91",
    d: "M21.4116 61.2763C22.2936 61.2763 23.0087 60.5612 23.0087 59.6792C23.0087 58.7971 22.2936 58.082 21.4116 58.082C20.5295 58.082 19.8145 58.7971 19.8145 59.6792C19.8145 60.5612 20.5295 61.2763 21.4116 61.2763Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_92",
    d: "M21.4116 67.665C22.2936 67.665 23.0087 66.9499 23.0087 66.0678C23.0087 65.1858 22.2936 64.4707 21.4116 64.4707C20.5295 64.4707 19.8145 65.1858 19.8145 66.0678C19.8145 66.9499 20.5295 67.665 21.4116 67.665Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_93",
    d: "M21.4116 74.0536C22.2936 74.0536 23.0087 73.3386 23.0087 72.4565C23.0087 71.5744 22.2936 70.8594 21.4116 70.8594C20.5295 70.8594 19.8145 71.5744 19.8145 72.4565C19.8145 73.3386 20.5295 74.0536 21.4116 74.0536Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_94",
    d: "M21.4116 80.4423C22.2936 80.4423 23.0087 79.7272 23.0087 78.8452C23.0087 77.9631 22.2936 77.248 21.4116 77.248C20.5295 77.248 19.8145 77.9631 19.8145 78.8452C19.8145 79.7272 20.5295 80.4423 21.4116 80.4423Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_95",
    d: "M21.4116 86.831C22.2936 86.831 23.0087 86.1159 23.0087 85.2338C23.0087 84.3518 22.2936 83.6367 21.4116 83.6367C20.5295 83.6367 19.8145 84.3518 19.8145 85.2338C19.8145 86.1159 20.5295 86.831 21.4116 86.831Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_96",
    d: "M21.4116 93.2187C22.2936 93.2187 23.0087 92.5036 23.0087 91.6215C23.0087 90.7395 22.2936 90.0244 21.4116 90.0244C20.5295 90.0244 19.8145 90.7395 19.8145 91.6215C19.8145 92.5036 20.5295 93.2187 21.4116 93.2187Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_97",
    d: "M21.4116 99.6073C22.2936 99.6073 23.0087 98.8923 23.0087 98.0102C23.0087 97.1281 22.2936 96.4131 21.4116 96.4131C20.5295 96.4131 19.8145 97.1281 19.8145 98.0102C19.8145 98.8923 20.5295 99.6073 21.4116 99.6073Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_98",
    d: "M21.4116 105.996C22.2936 105.996 23.0087 105.281 23.0087 104.399C23.0087 103.517 22.2936 102.802 21.4116 102.802C20.5295 102.802 19.8145 103.517 19.8145 104.399C19.8145 105.281 20.5295 105.996 21.4116 105.996Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_99",
    d: "M21.4116 112.385C22.2936 112.385 23.0087 111.67 23.0087 110.788C23.0087 109.905 22.2936 109.19 21.4116 109.19C20.5295 109.19 19.8145 109.905 19.8145 110.788C19.8145 111.67 20.5295 112.385 21.4116 112.385Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_100",
    d: "M21.4116 118.773C22.2936 118.773 23.0087 118.058 23.0087 117.176C23.0087 116.294 22.2936 115.579 21.4116 115.579C20.5295 115.579 19.8145 116.294 19.8145 117.176C19.8145 118.058 20.5295 118.773 21.4116 118.773Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_101",
    d: "M24.6049 45.3056C25.487 45.3056 26.2021 44.5905 26.2021 43.7085C26.2021 42.8264 25.487 42.1113 24.6049 42.1113C23.7229 42.1113 23.0078 42.8264 23.0078 43.7085C23.0078 44.5905 23.7229 45.3056 24.6049 45.3056Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_102",
    d: "M24.6049 48.4999C25.487 48.4999 26.2021 47.7849 26.2021 46.9028C26.2021 46.0207 25.487 45.3057 24.6049 45.3057C23.7229 45.3057 23.0078 46.0207 23.0078 46.9028C23.0078 47.7849 23.7229 48.4999 24.6049 48.4999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_103",
    d: "M24.6049 51.6942C25.487 51.6942 26.2021 50.9792 26.2021 50.0971C26.2021 49.2151 25.487 48.5 24.6049 48.5C23.7229 48.5 23.0078 49.2151 23.0078 50.0971C23.0078 50.9792 23.7229 51.6942 24.6049 51.6942Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_104",
    d: "M24.6049 58.0819C25.487 58.0819 26.2021 57.3669 26.2021 56.4848C26.2021 55.6028 25.487 54.8877 24.6049 54.8877C23.7229 54.8877 23.0078 55.6028 23.0078 56.4848C23.0078 57.3669 23.7229 58.0819 24.6049 58.0819Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_105",
    d: "M24.6049 64.4706C25.487 64.4706 26.2021 63.7556 26.2021 62.8735C26.2021 61.9914 25.487 61.2764 24.6049 61.2764C23.7229 61.2764 23.0078 61.9914 23.0078 62.8735C23.0078 63.7556 23.7229 64.4706 24.6049 64.4706Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_106",
    d: "M24.6049 67.665C25.487 67.665 26.2021 66.9499 26.2021 66.0678C26.2021 65.1858 25.487 64.4707 24.6049 64.4707C23.7229 64.4707 23.0078 65.1858 23.0078 66.0678C23.0078 66.9499 23.7229 67.665 24.6049 67.665Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_107",
    d: "M24.6049 80.4423C25.487 80.4423 26.2021 79.7272 26.2021 78.8452C26.2021 77.9631 25.487 77.248 24.6049 77.248C23.7229 77.248 23.0078 77.9631 23.0078 78.8452C23.0078 79.7272 23.7229 80.4423 24.6049 80.4423Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_108",
    d: "M24.6049 83.6366C25.487 83.6366 26.2021 82.9216 26.2021 82.0395C26.2021 81.1574 25.487 80.4424 24.6049 80.4424C23.7229 80.4424 23.0078 81.1574 23.0078 82.0395C23.0078 82.9216 23.7229 83.6366 24.6049 83.6366Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_109",
    d: "M24.6049 86.831C25.487 86.831 26.2021 86.1159 26.2021 85.2338C26.2021 84.3518 25.487 83.6367 24.6049 83.6367C23.7229 83.6367 23.0078 84.3518 23.0078 85.2338C23.0078 86.1159 23.7229 86.831 24.6049 86.831Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_110",
    d: "M24.6049 90.0253C25.487 90.0253 26.2021 89.3102 26.2021 88.4282C26.2021 87.5461 25.487 86.8311 24.6049 86.8311C23.7229 86.8311 23.0078 87.5461 23.0078 88.4282C23.0078 89.3102 23.7229 90.0253 24.6049 90.0253Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_111",
    d: "M24.6049 102.802C25.487 102.802 26.2021 102.087 26.2021 101.205C26.2021 100.322 25.487 99.6074 24.6049 99.6074C23.7229 99.6074 23.0078 100.322 23.0078 101.205C23.0078 102.087 23.7229 102.802 24.6049 102.802Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_112",
    d: "M24.6049 105.996C25.487 105.996 26.2021 105.281 26.2021 104.399C26.2021 103.517 25.487 102.802 24.6049 102.802C23.7229 102.802 23.0078 103.517 23.0078 104.399C23.0078 105.281 23.7229 105.996 24.6049 105.996Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_113",
    d: "M24.6049 109.19C25.487 109.19 26.2021 108.475 26.2021 107.593C26.2021 106.711 25.487 105.996 24.6049 105.996C23.7229 105.996 23.0078 106.711 23.0078 107.593C23.0078 108.475 23.7229 109.19 24.6049 109.19Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_114",
    d: "M24.6049 112.385C25.487 112.385 26.2021 111.67 26.2021 110.788C26.2021 109.905 25.487 109.19 24.6049 109.19C23.7229 109.19 23.0078 109.905 23.0078 110.788C23.0078 111.67 23.7229 112.385 24.6049 112.385Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_115",
    d: "M24.6049 118.773C25.487 118.773 26.2021 118.058 26.2021 117.176C26.2021 116.294 25.487 115.579 24.6049 115.579C23.7229 115.579 23.0078 116.294 23.0078 117.176C23.0078 118.058 23.7229 118.773 24.6049 118.773Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_116",
    d: "M27.8002 6.97452C28.6823 6.97452 29.3974 6.25947 29.3974 5.3774C29.3974 4.49533 28.6823 3.78027 27.8002 3.78027C26.9182 3.78027 26.2031 4.49533 26.2031 5.3774C26.2031 6.25947 26.9182 6.97452 27.8002 6.97452Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_117",
    d: "M27.8002 16.5575C28.6823 16.5575 29.3974 15.8425 29.3974 14.9604C29.3974 14.0783 28.6823 13.3633 27.8002 13.3633C26.9182 13.3633 26.2031 14.0783 26.2031 14.9604C26.2031 15.8425 26.9182 16.5575 27.8002 16.5575Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_118",
    d: "M27.8002 22.9452C28.6823 22.9452 29.3974 22.2302 29.3974 21.3481C29.3974 20.466 28.6823 19.751 27.8002 19.751C26.9182 19.751 26.2031 20.466 26.2031 21.3481C26.2031 22.2302 26.9182 22.9452 27.8002 22.9452Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_119",
    d: "M27.8002 29.3339C28.6823 29.3339 29.3974 28.6188 29.3974 27.7368C29.3974 26.8547 28.6823 26.1396 27.8002 26.1396C26.9182 26.1396 26.2031 26.8547 26.2031 27.7368C26.2031 28.6188 26.9182 29.3339 27.8002 29.3339Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_120",
    d: "M27.8002 32.5282C28.6823 32.5282 29.3974 31.8132 29.3974 30.9311C29.3974 30.049 28.6823 29.334 27.8002 29.334C26.9182 29.334 26.2031 30.049 26.2031 30.9311C26.2031 31.8132 26.9182 32.5282 27.8002 32.5282Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_121",
    d: "M27.8002 35.7226C28.6823 35.7226 29.3974 35.0075 29.3974 34.1254C29.3974 33.2434 28.6823 32.5283 27.8002 32.5283C26.9182 32.5283 26.2031 33.2434 26.2031 34.1254C26.2031 35.0075 26.9182 35.7226 27.8002 35.7226Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_122",
    d: "M27.8002 38.9169C28.6823 38.9169 29.3974 38.2018 29.3974 37.3198C29.3974 36.4377 28.6823 35.7227 27.8002 35.7227C26.9182 35.7227 26.2031 36.4377 26.2031 37.3198C26.2031 38.2018 26.9182 38.9169 27.8002 38.9169Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_123",
    d: "M27.8002 42.1112C28.6823 42.1112 29.3974 41.3962 29.3974 40.5141C29.3974 39.632 28.6823 38.917 27.8002 38.917C26.9182 38.917 26.2031 39.632 26.2031 40.5141C26.2031 41.3962 26.9182 42.1112 27.8002 42.1112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_124",
    d: "M27.8002 54.8886C28.6823 54.8886 29.3974 54.1735 29.3974 53.2915C29.3974 52.4094 28.6823 51.6943 27.8002 51.6943C26.9182 51.6943 26.2031 52.4094 26.2031 53.2915C26.2031 54.1735 26.9182 54.8886 27.8002 54.8886Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_125",
    d: "M27.8002 64.4706C28.6823 64.4706 29.3974 63.7556 29.3974 62.8735C29.3974 61.9914 28.6823 61.2764 27.8002 61.2764C26.9182 61.2764 26.2031 61.9914 26.2031 62.8735C26.2031 63.7556 26.9182 64.4706 27.8002 64.4706Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_126",
    d: "M27.8002 67.665C28.6823 67.665 29.3974 66.9499 29.3974 66.0678C29.3974 65.1858 28.6823 64.4707 27.8002 64.4707C26.9182 64.4707 26.2031 65.1858 26.2031 66.0678C26.2031 66.9499 26.9182 67.665 27.8002 67.665Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_127",
    d: "M27.8002 70.8593C28.6823 70.8593 29.3974 70.1442 29.3974 69.2622C29.3974 68.3801 28.6823 67.665 27.8002 67.665C26.9182 67.665 26.2031 68.3801 26.2031 69.2622C26.2031 70.1442 26.9182 70.8593 27.8002 70.8593Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_128",
    d: "M27.8002 74.0536C28.6823 74.0536 29.3974 73.3386 29.3974 72.4565C29.3974 71.5744 28.6823 70.8594 27.8002 70.8594C26.9182 70.8594 26.2031 71.5744 26.2031 72.4565C26.2031 73.3386 26.9182 74.0536 27.8002 74.0536Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_129",
    d: "M27.8002 77.248C28.6823 77.248 29.3974 76.5329 29.3974 75.6508C29.3974 74.7688 28.6823 74.0537 27.8002 74.0537C26.9182 74.0537 26.2031 74.7688 26.2031 75.6508C26.2031 76.5329 26.9182 77.248 27.8002 77.248Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_130",
    d: "M27.8002 80.4423C28.6823 80.4423 29.3974 79.7272 29.3974 78.8452C29.3974 77.9631 28.6823 77.248 27.8002 77.248C26.9182 77.248 26.2031 77.9631 26.2031 78.8452C26.2031 79.7272 26.9182 80.4423 27.8002 80.4423Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_131",
    d: "M27.8002 83.6366C28.6823 83.6366 29.3974 82.9216 29.3974 82.0395C29.3974 81.1574 28.6823 80.4424 27.8002 80.4424C26.9182 80.4424 26.2031 81.1574 26.2031 82.0395C26.2031 82.9216 26.9182 83.6366 27.8002 83.6366Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_132",
    d: "M27.8002 86.831C28.6823 86.831 29.3974 86.1159 29.3974 85.2338C29.3974 84.3518 28.6823 83.6367 27.8002 83.6367C26.9182 83.6367 26.2031 84.3518 26.2031 85.2338C26.2031 86.1159 26.9182 86.831 27.8002 86.831Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_133",
    d: "M27.8002 90.0253C28.6823 90.0253 29.3974 89.3102 29.3974 88.4282C29.3974 87.5461 28.6823 86.8311 27.8002 86.8311C26.9182 86.8311 26.2031 87.5461 26.2031 88.4282C26.2031 89.3102 26.9182 90.0253 27.8002 90.0253Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_134",
    d: "M27.8002 96.413C28.6823 96.413 29.3974 95.6979 29.3974 94.8159C29.3974 93.9338 28.6823 93.2188 27.8002 93.2188C26.9182 93.2188 26.2031 93.9338 26.2031 94.8159C26.2031 95.6979 26.9182 96.413 27.8002 96.413Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_135",
    d: "M27.8002 99.6073C28.6823 99.6073 29.3974 98.8923 29.3974 98.0102C29.3974 97.1281 28.6823 96.4131 27.8002 96.4131C26.9182 96.4131 26.2031 97.1281 26.2031 98.0102C26.2031 98.8923 26.9182 99.6073 27.8002 99.6073Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_136",
    d: "M27.8002 105.996C28.6823 105.996 29.3974 105.281 29.3974 104.399C29.3974 103.517 28.6823 102.802 27.8002 102.802C26.9182 102.802 26.2031 103.517 26.2031 104.399C26.2031 105.281 26.9182 105.996 27.8002 105.996Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_137",
    d: "M27.8002 109.19C28.6823 109.19 29.3974 108.475 29.3974 107.593C29.3974 106.711 28.6823 105.996 27.8002 105.996C26.9182 105.996 26.2031 106.711 26.2031 107.593C26.2031 108.475 26.9182 109.19 27.8002 109.19Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_138",
    d: "M27.8002 115.579C28.6823 115.579 29.3974 114.864 29.3974 113.982C29.3974 113.1 28.6823 112.385 27.8002 112.385C26.9182 112.385 26.2031 113.1 26.2031 113.982C26.2031 114.864 26.9182 115.579 27.8002 115.579Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_139",
    d: "M27.8002 121.968C28.6823 121.968 29.3974 121.253 29.3974 120.371C29.3974 119.488 28.6823 118.773 27.8002 118.773C26.9182 118.773 26.2031 119.488 26.2031 120.371C26.2031 121.253 26.9182 121.968 27.8002 121.968Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_140",
    d: "M27.8002 128.356C28.6823 128.356 29.3974 127.641 29.3974 126.759C29.3974 125.877 28.6823 125.162 27.8002 125.162C26.9182 125.162 26.2031 125.877 26.2031 126.759C26.2031 127.641 26.9182 128.356 27.8002 128.356Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_141",
    d: "M27.8002 131.55C28.6823 131.55 29.3974 130.835 29.3974 129.953C29.3974 129.071 28.6823 128.355 27.8002 128.355C26.9182 128.355 26.2031 129.071 26.2031 129.953C26.2031 130.835 26.9182 131.55 27.8002 131.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_142",
    d: "M27.8002 137.938C28.6823 137.938 29.3974 137.223 29.3974 136.341C29.3974 135.459 28.6823 134.744 27.8002 134.744C26.9182 134.744 26.2031 135.459 26.2031 136.341C26.2031 137.223 26.9182 137.938 27.8002 137.938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_143",
    d: "M30.9936 6.97452C31.8757 6.97452 32.5907 6.25947 32.5907 5.3774C32.5907 4.49533 31.8757 3.78027 30.9936 3.78027C30.1115 3.78027 29.3965 4.49533 29.3965 5.3774C29.3965 6.25947 30.1115 6.97452 30.9936 6.97452Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_144",
    d: "M30.9936 10.1689C31.8757 10.1689 32.5907 9.4538 32.5907 8.57173C32.5907 7.68967 31.8757 6.97461 30.9936 6.97461C30.1115 6.97461 29.3965 7.68967 29.3965 8.57173C29.3965 9.4538 30.1115 10.1689 30.9936 10.1689Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_145",
    d: "M30.9936 26.1396C31.8757 26.1396 32.5907 25.4245 32.5907 24.5424C32.5907 23.6604 31.8757 22.9453 30.9936 22.9453C30.1115 22.9453 29.3965 23.6604 29.3965 24.5424C29.3965 25.4245 30.1115 26.1396 30.9936 26.1396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_146",
    d: "M30.9936 38.9169C31.8757 38.9169 32.5907 38.2018 32.5907 37.3198C32.5907 36.4377 31.8757 35.7227 30.9936 35.7227C30.1115 35.7227 29.3965 36.4377 29.3965 37.3198C29.3965 38.2018 30.1115 38.9169 30.9936 38.9169Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_147",
    d: "M30.9936 42.1112C31.8757 42.1112 32.5907 41.3962 32.5907 40.5141C32.5907 39.632 31.8757 38.917 30.9936 38.917C30.1115 38.917 29.3965 39.632 29.3965 40.5141C29.3965 41.3962 30.1115 42.1112 30.9936 42.1112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_148",
    d: "M30.9936 45.3056C31.8757 45.3056 32.5907 44.5905 32.5907 43.7085C32.5907 42.8264 31.8757 42.1113 30.9936 42.1113C30.1115 42.1113 29.3965 42.8264 29.3965 43.7085C29.3965 44.5905 30.1115 45.3056 30.9936 45.3056Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_149",
    d: "M30.9936 54.8886C31.8757 54.8886 32.5907 54.1735 32.5907 53.2915C32.5907 52.4094 31.8757 51.6943 30.9936 51.6943C30.1115 51.6943 29.3965 52.4094 29.3965 53.2915C29.3965 54.1735 30.1115 54.8886 30.9936 54.8886Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_150",
    d: "M30.9936 58.0819C31.8757 58.0819 32.5907 57.3669 32.5907 56.4848C32.5907 55.6028 31.8757 54.8877 30.9936 54.8877C30.1115 54.8877 29.3965 55.6028 29.3965 56.4848C29.3965 57.3669 30.1115 58.0819 30.9936 58.0819Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_151",
    d: "M30.9936 64.4706C31.8757 64.4706 32.5907 63.7556 32.5907 62.8735C32.5907 61.9914 31.8757 61.2764 30.9936 61.2764C30.1115 61.2764 29.3965 61.9914 29.3965 62.8735C29.3965 63.7556 30.1115 64.4706 30.9936 64.4706Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_152",
    d: "M30.9936 70.8593C31.8757 70.8593 32.5907 70.1442 32.5907 69.2622C32.5907 68.3801 31.8757 67.665 30.9936 67.665C30.1115 67.665 29.3965 68.3801 29.3965 69.2622C29.3965 70.1442 30.1115 70.8593 30.9936 70.8593Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_153",
    d: "M30.9936 77.248C31.8757 77.248 32.5907 76.5329 32.5907 75.6508C32.5907 74.7688 31.8757 74.0537 30.9936 74.0537C30.1115 74.0537 29.3965 74.7688 29.3965 75.6508C29.3965 76.5329 30.1115 77.248 30.9936 77.248Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_154",
    d: "M30.9936 80.4423C31.8757 80.4423 32.5907 79.7272 32.5907 78.8452C32.5907 77.9631 31.8757 77.248 30.9936 77.248C30.1115 77.248 29.3965 77.9631 29.3965 78.8452C29.3965 79.7272 30.1115 80.4423 30.9936 80.4423Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_155",
    d: "M30.9936 86.831C31.8757 86.831 32.5907 86.1159 32.5907 85.2338C32.5907 84.3518 31.8757 83.6367 30.9936 83.6367C30.1115 83.6367 29.3965 84.3518 29.3965 85.2338C29.3965 86.1159 30.1115 86.831 30.9936 86.831Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_156",
    d: "M30.9936 90.0253C31.8757 90.0253 32.5907 89.3102 32.5907 88.4282C32.5907 87.5461 31.8757 86.8311 30.9936 86.8311C30.1115 86.8311 29.3965 87.5461 29.3965 88.4282C29.3965 89.3102 30.1115 90.0253 30.9936 90.0253Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_157",
    d: "M30.9936 96.413C31.8757 96.413 32.5907 95.6979 32.5907 94.8159C32.5907 93.9338 31.8757 93.2188 30.9936 93.2188C30.1115 93.2188 29.3965 93.9338 29.3965 94.8159C29.3965 95.6979 30.1115 96.413 30.9936 96.413Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_158",
    d: "M30.9936 99.6073C31.8757 99.6073 32.5907 98.8923 32.5907 98.0102C32.5907 97.1281 31.8757 96.4131 30.9936 96.4131C30.1115 96.4131 29.3965 97.1281 29.3965 98.0102C29.3965 98.8923 30.1115 99.6073 30.9936 99.6073Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_159",
    d: "M30.9936 102.802C31.8757 102.802 32.5907 102.087 32.5907 101.205C32.5907 100.322 31.8757 99.6074 30.9936 99.6074C30.1115 99.6074 29.3965 100.322 29.3965 101.205C29.3965 102.087 30.1115 102.802 30.9936 102.802Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_160",
    d: "M30.9936 105.996C31.8757 105.996 32.5907 105.281 32.5907 104.399C32.5907 103.517 31.8757 102.802 30.9936 102.802C30.1115 102.802 29.3965 103.517 29.3965 104.399C29.3965 105.281 30.1115 105.996 30.9936 105.996Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_161",
    d: "M30.9936 109.19C31.8757 109.19 32.5907 108.475 32.5907 107.593C32.5907 106.711 31.8757 105.996 30.9936 105.996C30.1115 105.996 29.3965 106.711 29.3965 107.593C29.3965 108.475 30.1115 109.19 30.9936 109.19Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_162",
    d: "M30.9936 115.579C31.8757 115.579 32.5907 114.864 32.5907 113.982C32.5907 113.1 31.8757 112.385 30.9936 112.385C30.1115 112.385 29.3965 113.1 29.3965 113.982C29.3965 114.864 30.1115 115.579 30.9936 115.579Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_163",
    d: "M30.9936 118.773C31.8757 118.773 32.5907 118.058 32.5907 117.176C32.5907 116.294 31.8757 115.579 30.9936 115.579C30.1115 115.579 29.3965 116.294 29.3965 117.176C29.3965 118.058 30.1115 118.773 30.9936 118.773Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_164",
    d: "M30.9936 125.162C31.8757 125.162 32.5907 124.447 32.5907 123.565C32.5907 122.683 31.8757 121.968 30.9936 121.968C30.1115 121.968 29.3965 122.683 29.3965 123.565C29.3965 124.447 30.1115 125.162 30.9936 125.162Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_165",
    d: "M30.9936 134.744C31.8757 134.744 32.5907 134.029 32.5907 133.147C32.5907 132.265 31.8757 131.55 30.9936 131.55C30.1115 131.55 29.3965 132.265 29.3965 133.147C29.3965 134.029 30.1115 134.744 30.9936 134.744Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_166",
    d: "M30.9936 141.133C31.8757 141.133 32.5907 140.418 32.5907 139.536C32.5907 138.654 31.8757 137.938 30.9936 137.938C30.1115 137.938 29.3965 138.654 29.3965 139.536C29.3965 140.418 30.1115 141.133 30.9936 141.133Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_167",
    d: "M34.1889 13.3632C35.071 13.3632 35.786 12.6481 35.786 11.7661C35.786 10.884 35.071 10.1689 34.1889 10.1689C33.3069 10.1689 32.5918 10.884 32.5918 11.7661C32.5918 12.6481 33.3069 13.3632 34.1889 13.3632Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_168",
    d: "M34.1889 22.9452C35.071 22.9452 35.786 22.2302 35.786 21.3481C35.786 20.466 35.071 19.751 34.1889 19.751C33.3069 19.751 32.5918 20.466 32.5918 21.3481C32.5918 22.2302 33.3069 22.9452 34.1889 22.9452Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_169",
    d: "M34.1889 29.3339C35.071 29.3339 35.786 28.6188 35.786 27.7368C35.786 26.8547 35.071 26.1396 34.1889 26.1396C33.3069 26.1396 32.5918 26.8547 32.5918 27.7368C32.5918 28.6188 33.3069 29.3339 34.1889 29.3339Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_170",
    d: "M34.1889 32.5282C35.071 32.5282 35.786 31.8132 35.786 30.9311C35.786 30.049 35.071 29.334 34.1889 29.334C33.3069 29.334 32.5918 30.049 32.5918 30.9311C32.5918 31.8132 33.3069 32.5282 34.1889 32.5282Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_171",
    d: "M34.1889 42.1112C35.071 42.1112 35.786 41.3962 35.786 40.5141C35.786 39.632 35.071 38.917 34.1889 38.917C33.3069 38.917 32.5918 39.632 32.5918 40.5141C32.5918 41.3962 33.3069 42.1112 34.1889 42.1112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_172",
    d: "M34.1889 51.6942C35.071 51.6942 35.786 50.9792 35.786 50.0971C35.786 49.2151 35.071 48.5 34.1889 48.5C33.3069 48.5 32.5918 49.2151 32.5918 50.0971C32.5918 50.9792 33.3069 51.6942 34.1889 51.6942Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_173",
    d: "M34.1889 61.2763C35.071 61.2763 35.786 60.5612 35.786 59.6792C35.786 58.7971 35.071 58.082 34.1889 58.082C33.3069 58.082 32.5918 58.7971 32.5918 59.6792C32.5918 60.5612 33.3069 61.2763 34.1889 61.2763Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_174",
    d: "M34.1889 67.665C35.071 67.665 35.786 66.9499 35.786 66.0678C35.786 65.1858 35.071 64.4707 34.1889 64.4707C33.3069 64.4707 32.5918 65.1858 32.5918 66.0678C32.5918 66.9499 33.3069 67.665 34.1889 67.665Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_175",
    d: "M34.1889 74.0536C35.071 74.0536 35.786 73.3386 35.786 72.4565C35.786 71.5744 35.071 70.8594 34.1889 70.8594C33.3069 70.8594 32.5918 71.5744 32.5918 72.4565C32.5918 73.3386 33.3069 74.0536 34.1889 74.0536Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_176",
    d: "M34.1889 83.6366C35.071 83.6366 35.786 82.9216 35.786 82.0395C35.786 81.1574 35.071 80.4424 34.1889 80.4424C33.3069 80.4424 32.5918 81.1574 32.5918 82.0395C32.5918 82.9216 33.3069 83.6366 34.1889 83.6366Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_177",
    d: "M34.1889 86.831C35.071 86.831 35.786 86.1159 35.786 85.2338C35.786 84.3518 35.071 83.6367 34.1889 83.6367C33.3069 83.6367 32.5918 84.3518 32.5918 85.2338C32.5918 86.1159 33.3069 86.831 34.1889 86.831Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_178",
    d: "M34.1889 90.0253C35.071 90.0253 35.786 89.3102 35.786 88.4282C35.786 87.5461 35.071 86.8311 34.1889 86.8311C33.3069 86.8311 32.5918 87.5461 32.5918 88.4282C32.5918 89.3102 33.3069 90.0253 34.1889 90.0253Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_179",
    d: "M34.1889 99.6073C35.071 99.6073 35.786 98.8923 35.786 98.0102C35.786 97.1281 35.071 96.4131 34.1889 96.4131C33.3069 96.4131 32.5918 97.1281 32.5918 98.0102C32.5918 98.8923 33.3069 99.6073 34.1889 99.6073Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_180",
    d: "M34.1889 102.802C35.071 102.802 35.786 102.087 35.786 101.205C35.786 100.322 35.071 99.6074 34.1889 99.6074C33.3069 99.6074 32.5918 100.322 32.5918 101.205C32.5918 102.087 33.3069 102.802 34.1889 102.802Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_181",
    d: "M34.1889 105.996C35.071 105.996 35.786 105.281 35.786 104.399C35.786 103.517 35.071 102.802 34.1889 102.802C33.3069 102.802 32.5918 103.517 32.5918 104.399C32.5918 105.281 33.3069 105.996 34.1889 105.996Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_182",
    d: "M34.1889 115.579C35.071 115.579 35.786 114.864 35.786 113.982C35.786 113.1 35.071 112.385 34.1889 112.385C33.3069 112.385 32.5918 113.1 32.5918 113.982C32.5918 114.864 33.3069 115.579 34.1889 115.579Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_183",
    d: "M34.1889 121.968C35.071 121.968 35.786 121.253 35.786 120.371C35.786 119.488 35.071 118.773 34.1889 118.773C33.3069 118.773 32.5918 119.488 32.5918 120.371C32.5918 121.253 33.3069 121.968 34.1889 121.968Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_184",
    d: "M34.1889 125.162C35.071 125.162 35.786 124.447 35.786 123.565C35.786 122.683 35.071 121.968 34.1889 121.968C33.3069 121.968 32.5918 122.683 32.5918 123.565C32.5918 124.447 33.3069 125.162 34.1889 125.162Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_185",
    d: "M34.1889 131.55C35.071 131.55 35.786 130.835 35.786 129.953C35.786 129.071 35.071 128.355 34.1889 128.355C33.3069 128.355 32.5918 129.071 32.5918 129.953C32.5918 130.835 33.3069 131.55 34.1889 131.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_186",
    d: "M34.1889 137.938C35.071 137.938 35.786 137.223 35.786 136.341C35.786 135.459 35.071 134.744 34.1889 134.744C33.3069 134.744 32.5918 135.459 32.5918 136.341C32.5918 137.223 33.3069 137.938 34.1889 137.938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_187",
    d: "M34.1889 141.133C35.071 141.133 35.786 140.418 35.786 139.536C35.786 138.654 35.071 137.938 34.1889 137.938C33.3069 137.938 32.5918 138.654 32.5918 139.536C32.5918 140.418 33.3069 141.133 34.1889 141.133Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_188",
    d: "M37.3823 3.78019C38.2643 3.78019 38.9794 3.06513 38.9794 2.18306C38.9794 1.30099 38.2643 0.585938 37.3823 0.585938C36.5002 0.585938 35.7852 1.30099 35.7852 2.18306C35.7852 3.06513 36.5002 3.78019 37.3823 3.78019Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_189",
    d: "M37.3823 6.97452C38.2643 6.97452 38.9794 6.25947 38.9794 5.3774C38.9794 4.49533 38.2643 3.78027 37.3823 3.78027C36.5002 3.78027 35.7852 4.49533 35.7852 5.3774C35.7852 6.25947 36.5002 6.97452 37.3823 6.97452Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_190",
    d: "M37.3823 10.1689C38.2643 10.1689 38.9794 9.4538 38.9794 8.57173C38.9794 7.68967 38.2643 6.97461 37.3823 6.97461C36.5002 6.97461 35.7852 7.68967 35.7852 8.57173C35.7852 9.4538 36.5002 10.1689 37.3823 10.1689Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_191",
    d: "M37.3823 26.1396C38.2643 26.1396 38.9794 25.4245 38.9794 24.5424C38.9794 23.6604 38.2643 22.9453 37.3823 22.9453C36.5002 22.9453 35.7852 23.6604 35.7852 24.5424C35.7852 25.4245 36.5002 26.1396 37.3823 26.1396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_192",
    d: "M37.3823 29.3339C38.2643 29.3339 38.9794 28.6188 38.9794 27.7368C38.9794 26.8547 38.2643 26.1396 37.3823 26.1396C36.5002 26.1396 35.7852 26.8547 35.7852 27.7368C35.7852 28.6188 36.5002 29.3339 37.3823 29.3339Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_193",
    d: "M37.3823 51.6942C38.2643 51.6942 38.9794 50.9792 38.9794 50.0971C38.9794 49.2151 38.2643 48.5 37.3823 48.5C36.5002 48.5 35.7852 49.2151 35.7852 50.0971C35.7852 50.9792 36.5002 51.6942 37.3823 51.6942Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_194",
    d: "M37.3823 58.0819C38.2643 58.0819 38.9794 57.3669 38.9794 56.4848C38.9794 55.6028 38.2643 54.8877 37.3823 54.8877C36.5002 54.8877 35.7852 55.6028 35.7852 56.4848C35.7852 57.3669 36.5002 58.0819 37.3823 58.0819Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_195",
    d: "M37.3823 61.2763C38.2643 61.2763 38.9794 60.5612 38.9794 59.6792C38.9794 58.7971 38.2643 58.082 37.3823 58.082C36.5002 58.082 35.7852 58.7971 35.7852 59.6792C35.7852 60.5612 36.5002 61.2763 37.3823 61.2763Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_196",
    d: "M37.3823 67.665C38.2643 67.665 38.9794 66.9499 38.9794 66.0678C38.9794 65.1858 38.2643 64.4707 37.3823 64.4707C36.5002 64.4707 35.7852 65.1858 35.7852 66.0678C35.7852 66.9499 36.5002 67.665 37.3823 67.665Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_197",
    d: "M37.3823 74.0536C38.2643 74.0536 38.9794 73.3386 38.9794 72.4565C38.9794 71.5744 38.2643 70.8594 37.3823 70.8594C36.5002 70.8594 35.7852 71.5744 35.7852 72.4565C35.7852 73.3386 36.5002 74.0536 37.3823 74.0536Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_198",
    d: "M37.3823 77.248C38.2643 77.248 38.9794 76.5329 38.9794 75.6508C38.9794 74.7688 38.2643 74.0537 37.3823 74.0537C36.5002 74.0537 35.7852 74.7688 35.7852 75.6508C35.7852 76.5329 36.5002 77.248 37.3823 77.248Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_199",
    d: "M37.3823 83.6366C38.2643 83.6366 38.9794 82.9216 38.9794 82.0395C38.9794 81.1574 38.2643 80.4424 37.3823 80.4424C36.5002 80.4424 35.7852 81.1574 35.7852 82.0395C35.7852 82.9216 36.5002 83.6366 37.3823 83.6366Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_200",
    d: "M37.3823 90.0253C38.2643 90.0253 38.9794 89.3102 38.9794 88.4282C38.9794 87.5461 38.2643 86.8311 37.3823 86.8311C36.5002 86.8311 35.7852 87.5461 35.7852 88.4282C35.7852 89.3102 36.5002 90.0253 37.3823 90.0253Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_201",
    d: "M37.3823 96.413C38.2643 96.413 38.9794 95.6979 38.9794 94.8159C38.9794 93.9338 38.2643 93.2188 37.3823 93.2188C36.5002 93.2188 35.7852 93.9338 35.7852 94.8159C35.7852 95.6979 36.5002 96.413 37.3823 96.413Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_202",
    d: "M37.3823 102.802C38.2643 102.802 38.9794 102.087 38.9794 101.205C38.9794 100.322 38.2643 99.6074 37.3823 99.6074C36.5002 99.6074 35.7852 100.322 35.7852 101.205C35.7852 102.087 36.5002 102.802 37.3823 102.802Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_203",
    d: "M37.3823 105.996C38.2643 105.996 38.9794 105.281 38.9794 104.399C38.9794 103.517 38.2643 102.802 37.3823 102.802C36.5002 102.802 35.7852 103.517 35.7852 104.399C35.7852 105.281 36.5002 105.996 37.3823 105.996Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_204",
    d: "M37.3823 115.579C38.2643 115.579 38.9794 114.864 38.9794 113.982C38.9794 113.1 38.2643 112.385 37.3823 112.385C36.5002 112.385 35.7852 113.1 35.7852 113.982C35.7852 114.864 36.5002 115.579 37.3823 115.579Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_205",
    d: "M37.3823 121.968C38.2643 121.968 38.9794 121.253 38.9794 120.371C38.9794 119.488 38.2643 118.773 37.3823 118.773C36.5002 118.773 35.7852 119.488 35.7852 120.371C35.7852 121.253 36.5002 121.968 37.3823 121.968Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_206",
    d: "M37.3823 128.356C38.2643 128.356 38.9794 127.641 38.9794 126.759C38.9794 125.877 38.2643 125.162 37.3823 125.162C36.5002 125.162 35.7852 125.877 35.7852 126.759C35.7852 127.641 36.5002 128.356 37.3823 128.356Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_207",
    d: "M37.3823 144.327C38.2643 144.327 38.9794 143.612 38.9794 142.73C38.9794 141.848 38.2643 141.133 37.3823 141.133C36.5002 141.133 35.7852 141.848 35.7852 142.73C35.7852 143.612 36.5002 144.327 37.3823 144.327Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_208",
    d: "M40.5756 19.7519C41.4577 19.7519 42.1728 19.0368 42.1728 18.1547C42.1728 17.2727 41.4577 16.5576 40.5756 16.5576C39.6936 16.5576 38.9785 17.2727 38.9785 18.1547C38.9785 19.0368 39.6936 19.7519 40.5756 19.7519Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_209",
    d: "M40.5756 22.9452C41.4577 22.9452 42.1728 22.2302 42.1728 21.3481C42.1728 20.466 41.4577 19.751 40.5756 19.751C39.6936 19.751 38.9785 20.466 38.9785 21.3481C38.9785 22.2302 39.6936 22.9452 40.5756 22.9452Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_210",
    d: "M40.5756 32.5282C41.4577 32.5282 42.1728 31.8132 42.1728 30.9311C42.1728 30.049 41.4577 29.334 40.5756 29.334C39.6936 29.334 38.9785 30.049 38.9785 30.9311C38.9785 31.8132 39.6936 32.5282 40.5756 32.5282Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_211",
    d: "M40.5756 35.7226C41.4577 35.7226 42.1728 35.0075 42.1728 34.1254C42.1728 33.2434 41.4577 32.5283 40.5756 32.5283C39.6936 32.5283 38.9785 33.2434 38.9785 34.1254C38.9785 35.0075 39.6936 35.7226 40.5756 35.7226Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_212",
    d: "M40.5756 38.9169C41.4577 38.9169 42.1728 38.2018 42.1728 37.3198C42.1728 36.4377 41.4577 35.7227 40.5756 35.7227C39.6936 35.7227 38.9785 36.4377 38.9785 37.3198C38.9785 38.2018 39.6936 38.9169 40.5756 38.9169Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_213",
    d: "M40.5756 42.1112C41.4577 42.1112 42.1728 41.3962 42.1728 40.5141C42.1728 39.632 41.4577 38.917 40.5756 38.917C39.6936 38.917 38.9785 39.632 38.9785 40.5141C38.9785 41.3962 39.6936 42.1112 40.5756 42.1112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_214",
    d: "M40.5756 58.0819C41.4577 58.0819 42.1728 57.3669 42.1728 56.4848C42.1728 55.6028 41.4577 54.8877 40.5756 54.8877C39.6936 54.8877 38.9785 55.6028 38.9785 56.4848C38.9785 57.3669 39.6936 58.0819 40.5756 58.0819Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_215",
    d: "M40.5756 61.2763C41.4577 61.2763 42.1728 60.5612 42.1728 59.6792C42.1728 58.7971 41.4577 58.082 40.5756 58.082C39.6936 58.082 38.9785 58.7971 38.9785 59.6792C38.9785 60.5612 39.6936 61.2763 40.5756 61.2763Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_216",
    d: "M40.5756 64.4706C41.4577 64.4706 42.1728 63.7556 42.1728 62.8735C42.1728 61.9914 41.4577 61.2764 40.5756 61.2764C39.6936 61.2764 38.9785 61.9914 38.9785 62.8735C38.9785 63.7556 39.6936 64.4706 40.5756 64.4706Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_217",
    d: "M40.5756 70.8593C41.4577 70.8593 42.1728 70.1442 42.1728 69.2622C42.1728 68.3801 41.4577 67.665 40.5756 67.665C39.6936 67.665 38.9785 68.3801 38.9785 69.2622C38.9785 70.1442 39.6936 70.8593 40.5756 70.8593Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_218",
    d: "M40.5756 74.0536C41.4577 74.0536 42.1728 73.3386 42.1728 72.4565C42.1728 71.5744 41.4577 70.8594 40.5756 70.8594C39.6936 70.8594 38.9785 71.5744 38.9785 72.4565C38.9785 73.3386 39.6936 74.0536 40.5756 74.0536Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_219",
    d: "M40.5756 77.248C41.4577 77.248 42.1728 76.5329 42.1728 75.6508C42.1728 74.7688 41.4577 74.0537 40.5756 74.0537C39.6936 74.0537 38.9785 74.7688 38.9785 75.6508C38.9785 76.5329 39.6936 77.248 40.5756 77.248Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_220",
    d: "M40.5756 86.831C41.4577 86.831 42.1728 86.1159 42.1728 85.2338C42.1728 84.3518 41.4577 83.6367 40.5756 83.6367C39.6936 83.6367 38.9785 84.3518 38.9785 85.2338C38.9785 86.1159 39.6936 86.831 40.5756 86.831Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_221",
    d: "M40.5756 90.0253C41.4577 90.0253 42.1728 89.3102 42.1728 88.4282C42.1728 87.5461 41.4577 86.8311 40.5756 86.8311C39.6936 86.8311 38.9785 87.5461 38.9785 88.4282C38.9785 89.3102 39.6936 90.0253 40.5756 90.0253Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_222",
    d: "M40.5756 96.413C41.4577 96.413 42.1728 95.6979 42.1728 94.8159C42.1728 93.9338 41.4577 93.2188 40.5756 93.2188C39.6936 93.2188 38.9785 93.9338 38.9785 94.8159C38.9785 95.6979 39.6936 96.413 40.5756 96.413Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_223",
    d: "M40.5756 99.6073C41.4577 99.6073 42.1728 98.8923 42.1728 98.0102C42.1728 97.1281 41.4577 96.4131 40.5756 96.4131C39.6936 96.4131 38.9785 97.1281 38.9785 98.0102C38.9785 98.8923 39.6936 99.6073 40.5756 99.6073Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_224",
    d: "M40.5756 105.996C41.4577 105.996 42.1728 105.281 42.1728 104.399C42.1728 103.517 41.4577 102.802 40.5756 102.802C39.6936 102.802 38.9785 103.517 38.9785 104.399C38.9785 105.281 39.6936 105.996 40.5756 105.996Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_225",
    d: "M40.5756 109.19C41.4577 109.19 42.1728 108.475 42.1728 107.593C42.1728 106.711 41.4577 105.996 40.5756 105.996C39.6936 105.996 38.9785 106.711 38.9785 107.593C38.9785 108.475 39.6936 109.19 40.5756 109.19Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_226",
    d: "M40.5756 112.385C41.4577 112.385 42.1728 111.67 42.1728 110.788C42.1728 109.905 41.4577 109.19 40.5756 109.19C39.6936 109.19 38.9785 109.905 38.9785 110.788C38.9785 111.67 39.6936 112.385 40.5756 112.385Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_227",
    d: "M40.5756 128.356C41.4577 128.356 42.1728 127.641 42.1728 126.759C42.1728 125.877 41.4577 125.162 40.5756 125.162C39.6936 125.162 38.9785 125.877 38.9785 126.759C38.9785 127.641 39.6936 128.356 40.5756 128.356Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_228",
    d: "M40.5756 141.133C41.4577 141.133 42.1728 140.418 42.1728 139.536C42.1728 138.654 41.4577 137.938 40.5756 137.938C39.6936 137.938 38.9785 138.654 38.9785 139.536C38.9785 140.418 39.6936 141.133 40.5756 141.133Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_229",
    d: "M40.5756 144.327C41.4577 144.327 42.1728 143.612 42.1728 142.73C42.1728 141.848 41.4577 141.133 40.5756 141.133C39.6936 141.133 38.9785 141.848 38.9785 142.73C38.9785 143.612 39.6936 144.327 40.5756 144.327Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_230",
    d: "M43.771 6.97452C44.653 6.97452 45.3681 6.25947 45.3681 5.3774C45.3681 4.49533 44.653 3.78027 43.771 3.78027C42.8889 3.78027 42.1738 4.49533 42.1738 5.3774C42.1738 6.25947 42.8889 6.97452 43.771 6.97452Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_231",
    d: "M43.771 10.1689C44.653 10.1689 45.3681 9.4538 45.3681 8.57173C45.3681 7.68967 44.653 6.97461 43.771 6.97461C42.8889 6.97461 42.1738 7.68967 42.1738 8.57173C42.1738 9.4538 42.8889 10.1689 43.771 10.1689Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_232",
    d: "M43.771 13.3632C44.653 13.3632 45.3681 12.6481 45.3681 11.7661C45.3681 10.884 44.653 10.1689 43.771 10.1689C42.8889 10.1689 42.1738 10.884 42.1738 11.7661C42.1738 12.6481 42.8889 13.3632 43.771 13.3632Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_233",
    d: "M43.771 26.1396C44.653 26.1396 45.3681 25.4245 45.3681 24.5424C45.3681 23.6604 44.653 22.9453 43.771 22.9453C42.8889 22.9453 42.1738 23.6604 42.1738 24.5424C42.1738 25.4245 42.8889 26.1396 43.771 26.1396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_234",
    d: "M43.771 32.5282C44.653 32.5282 45.3681 31.8132 45.3681 30.9311C45.3681 30.049 44.653 29.334 43.771 29.334C42.8889 29.334 42.1738 30.049 42.1738 30.9311C42.1738 31.8132 42.8889 32.5282 43.771 32.5282Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_235",
    d: "M43.771 35.7226C44.653 35.7226 45.3681 35.0075 45.3681 34.1254C45.3681 33.2434 44.653 32.5283 43.771 32.5283C42.8889 32.5283 42.1738 33.2434 42.1738 34.1254C42.1738 35.0075 42.8889 35.7226 43.771 35.7226Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_236",
    d: "M43.771 38.9169C44.653 38.9169 45.3681 38.2018 45.3681 37.3198C45.3681 36.4377 44.653 35.7227 43.771 35.7227C42.8889 35.7227 42.1738 36.4377 42.1738 37.3198C42.1738 38.2018 42.8889 38.9169 43.771 38.9169Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_237",
    d: "M43.771 42.1112C44.653 42.1112 45.3681 41.3962 45.3681 40.5141C45.3681 39.632 44.653 38.917 43.771 38.917C42.8889 38.917 42.1738 39.632 42.1738 40.5141C42.1738 41.3962 42.8889 42.1112 43.771 42.1112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_238",
    d: "M43.771 61.2763C44.653 61.2763 45.3681 60.5612 45.3681 59.6792C45.3681 58.7971 44.653 58.082 43.771 58.082C42.8889 58.082 42.1738 58.7971 42.1738 59.6792C42.1738 60.5612 42.8889 61.2763 43.771 61.2763Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_239",
    d: "M43.771 64.4706C44.653 64.4706 45.3681 63.7556 45.3681 62.8735C45.3681 61.9914 44.653 61.2764 43.771 61.2764C42.8889 61.2764 42.1738 61.9914 42.1738 62.8735C42.1738 63.7556 42.8889 64.4706 43.771 64.4706Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_240",
    d: "M43.771 67.665C44.653 67.665 45.3681 66.9499 45.3681 66.0678C45.3681 65.1858 44.653 64.4707 43.771 64.4707C42.8889 64.4707 42.1738 65.1858 42.1738 66.0678C42.1738 66.9499 42.8889 67.665 43.771 67.665Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_241",
    d: "M43.771 70.8593C44.653 70.8593 45.3681 70.1442 45.3681 69.2622C45.3681 68.3801 44.653 67.665 43.771 67.665C42.8889 67.665 42.1738 68.3801 42.1738 69.2622C42.1738 70.1442 42.8889 70.8593 43.771 70.8593Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_242",
    d: "M43.771 74.0536C44.653 74.0536 45.3681 73.3386 45.3681 72.4565C45.3681 71.5744 44.653 70.8594 43.771 70.8594C42.8889 70.8594 42.1738 71.5744 42.1738 72.4565C42.1738 73.3386 42.8889 74.0536 43.771 74.0536Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_243",
    d: "M43.771 77.248C44.653 77.248 45.3681 76.5329 45.3681 75.6508C45.3681 74.7688 44.653 74.0537 43.771 74.0537C42.8889 74.0537 42.1738 74.7688 42.1738 75.6508C42.1738 76.5329 42.8889 77.248 43.771 77.248Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_244",
    d: "M43.771 86.831C44.653 86.831 45.3681 86.1159 45.3681 85.2338C45.3681 84.3518 44.653 83.6367 43.771 83.6367C42.8889 83.6367 42.1738 84.3518 42.1738 85.2338C42.1738 86.1159 42.8889 86.831 43.771 86.831Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_245",
    d: "M43.771 96.413C44.653 96.413 45.3681 95.6979 45.3681 94.8159C45.3681 93.9338 44.653 93.2188 43.771 93.2188C42.8889 93.2188 42.1738 93.9338 42.1738 94.8159C42.1738 95.6979 42.8889 96.413 43.771 96.413Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_246",
    d: "M43.771 99.6073C44.653 99.6073 45.3681 98.8923 45.3681 98.0102C45.3681 97.1281 44.653 96.4131 43.771 96.4131C42.8889 96.4131 42.1738 97.1281 42.1738 98.0102C42.1738 98.8923 42.8889 99.6073 43.771 99.6073Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_247",
    d: "M43.771 105.996C44.653 105.996 45.3681 105.281 45.3681 104.399C45.3681 103.517 44.653 102.802 43.771 102.802C42.8889 102.802 42.1738 103.517 42.1738 104.399C42.1738 105.281 42.8889 105.996 43.771 105.996Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_248",
    d: "M43.771 109.19C44.653 109.19 45.3681 108.475 45.3681 107.593C45.3681 106.711 44.653 105.996 43.771 105.996C42.8889 105.996 42.1738 106.711 42.1738 107.593C42.1738 108.475 42.8889 109.19 43.771 109.19Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_249",
    d: "M43.771 118.773C44.653 118.773 45.3681 118.058 45.3681 117.176C45.3681 116.294 44.653 115.579 43.771 115.579C42.8889 115.579 42.1738 116.294 42.1738 117.176C42.1738 118.058 42.8889 118.773 43.771 118.773Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_250",
    d: "M43.771 125.162C44.653 125.162 45.3681 124.447 45.3681 123.565C45.3681 122.683 44.653 121.968 43.771 121.968C42.8889 121.968 42.1738 122.683 42.1738 123.565C42.1738 124.447 42.8889 125.162 43.771 125.162Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_251",
    d: "M43.771 128.356C44.653 128.356 45.3681 127.641 45.3681 126.759C45.3681 125.877 44.653 125.162 43.771 125.162C42.8889 125.162 42.1738 125.877 42.1738 126.759C42.1738 127.641 42.8889 128.356 43.771 128.356Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_252",
    d: "M43.771 141.133C44.653 141.133 45.3681 140.418 45.3681 139.536C45.3681 138.654 44.653 137.938 43.771 137.938C42.8889 137.938 42.1738 138.654 42.1738 139.536C42.1738 140.418 42.8889 141.133 43.771 141.133Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_253",
    d: "M46.9663 3.78019C47.8483 3.78019 48.5634 3.06513 48.5634 2.18306C48.5634 1.30099 47.8483 0.585938 46.9663 0.585938C46.0842 0.585938 45.3691 1.30099 45.3691 2.18306C45.3691 3.06513 46.0842 3.78019 46.9663 3.78019Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_254",
    d: "M46.9663 10.1689C47.8483 10.1689 48.5634 9.4538 48.5634 8.57173C48.5634 7.68967 47.8483 6.97461 46.9663 6.97461C46.0842 6.97461 45.3691 7.68967 45.3691 8.57173C45.3691 9.4538 46.0842 10.1689 46.9663 10.1689Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_255",
    d: "M46.9663 16.5575C47.8483 16.5575 48.5634 15.8425 48.5634 14.9604C48.5634 14.0783 47.8483 13.3633 46.9663 13.3633C46.0842 13.3633 45.3691 14.0783 45.3691 14.9604C45.3691 15.8425 46.0842 16.5575 46.9663 16.5575Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_256",
    d: "M46.9663 19.7519C47.8483 19.7519 48.5634 19.0368 48.5634 18.1547C48.5634 17.2727 47.8483 16.5576 46.9663 16.5576C46.0842 16.5576 45.3691 17.2727 45.3691 18.1547C45.3691 19.0368 46.0842 19.7519 46.9663 19.7519Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_257",
    d: "M46.9663 22.9452C47.8483 22.9452 48.5634 22.2302 48.5634 21.3481C48.5634 20.466 47.8483 19.751 46.9663 19.751C46.0842 19.751 45.3691 20.466 45.3691 21.3481C45.3691 22.2302 46.0842 22.9452 46.9663 22.9452Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_258",
    d: "M46.9663 32.5282C47.8483 32.5282 48.5634 31.8132 48.5634 30.9311C48.5634 30.049 47.8483 29.334 46.9663 29.334C46.0842 29.334 45.3691 30.049 45.3691 30.9311C45.3691 31.8132 46.0842 32.5282 46.9663 32.5282Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_259",
    d: "M46.9663 35.7226C47.8483 35.7226 48.5634 35.0075 48.5634 34.1254C48.5634 33.2434 47.8483 32.5283 46.9663 32.5283C46.0842 32.5283 45.3691 33.2434 45.3691 34.1254C45.3691 35.0075 46.0842 35.7226 46.9663 35.7226Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_260",
    d: "M46.9663 48.4999C47.8483 48.4999 48.5634 47.7849 48.5634 46.9028C48.5634 46.0207 47.8483 45.3057 46.9663 45.3057C46.0842 45.3057 45.3691 46.0207 45.3691 46.9028C45.3691 47.7849 46.0842 48.4999 46.9663 48.4999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_261",
    d: "M46.9663 51.6942C47.8483 51.6942 48.5634 50.9792 48.5634 50.0971C48.5634 49.2151 47.8483 48.5 46.9663 48.5C46.0842 48.5 45.3691 49.2151 45.3691 50.0971C45.3691 50.9792 46.0842 51.6942 46.9663 51.6942Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_262",
    d: "M46.9663 58.0819C47.8483 58.0819 48.5634 57.3669 48.5634 56.4848C48.5634 55.6028 47.8483 54.8877 46.9663 54.8877C46.0842 54.8877 45.3691 55.6028 45.3691 56.4848C45.3691 57.3669 46.0842 58.0819 46.9663 58.0819Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_263",
    d: "M46.9663 67.665C47.8483 67.665 48.5634 66.9499 48.5634 66.0678C48.5634 65.1858 47.8483 64.4707 46.9663 64.4707C46.0842 64.4707 45.3691 65.1858 45.3691 66.0678C45.3691 66.9499 46.0842 67.665 46.9663 67.665Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_264",
    d: "M46.9663 70.8593C47.8483 70.8593 48.5634 70.1442 48.5634 69.2622C48.5634 68.3801 47.8483 67.665 46.9663 67.665C46.0842 67.665 45.3691 68.3801 45.3691 69.2622C45.3691 70.1442 46.0842 70.8593 46.9663 70.8593Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_265",
    d: "M46.9663 83.6366C47.8483 83.6366 48.5634 82.9216 48.5634 82.0395C48.5634 81.1574 47.8483 80.4424 46.9663 80.4424C46.0842 80.4424 45.3691 81.1574 45.3691 82.0395C45.3691 82.9216 46.0842 83.6366 46.9663 83.6366Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_266",
    d: "M46.9663 86.831C47.8483 86.831 48.5634 86.1159 48.5634 85.2338C48.5634 84.3518 47.8483 83.6367 46.9663 83.6367C46.0842 83.6367 45.3691 84.3518 45.3691 85.2338C45.3691 86.1159 46.0842 86.831 46.9663 86.831Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_267",
    d: "M46.9663 93.2187C47.8483 93.2187 48.5634 92.5036 48.5634 91.6215C48.5634 90.7395 47.8483 90.0244 46.9663 90.0244C46.0842 90.0244 45.3691 90.7395 45.3691 91.6215C45.3691 92.5036 46.0842 93.2187 46.9663 93.2187Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_268",
    d: "M46.9663 99.6073C47.8483 99.6073 48.5634 98.8923 48.5634 98.0102C48.5634 97.1281 47.8483 96.4131 46.9663 96.4131C46.0842 96.4131 45.3691 97.1281 45.3691 98.0102C45.3691 98.8923 46.0842 99.6073 46.9663 99.6073Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_269",
    d: "M46.9663 102.802C47.8483 102.802 48.5634 102.087 48.5634 101.205C48.5634 100.322 47.8483 99.6074 46.9663 99.6074C46.0842 99.6074 45.3691 100.322 45.3691 101.205C45.3691 102.087 46.0842 102.802 46.9663 102.802Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_270",
    d: "M46.9663 109.19C47.8483 109.19 48.5634 108.475 48.5634 107.593C48.5634 106.711 47.8483 105.996 46.9663 105.996C46.0842 105.996 45.3691 106.711 45.3691 107.593C45.3691 108.475 46.0842 109.19 46.9663 109.19Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_271",
    d: "M46.9663 112.385C47.8483 112.385 48.5634 111.67 48.5634 110.788C48.5634 109.905 47.8483 109.19 46.9663 109.19C46.0842 109.19 45.3691 109.905 45.3691 110.788C45.3691 111.67 46.0842 112.385 46.9663 112.385Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_272",
    d: "M46.9663 125.162C47.8483 125.162 48.5634 124.447 48.5634 123.565C48.5634 122.683 47.8483 121.968 46.9663 121.968C46.0842 121.968 45.3691 122.683 45.3691 123.565C45.3691 124.447 46.0842 125.162 46.9663 125.162Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_273",
    d: "M46.9663 141.133C47.8483 141.133 48.5634 140.418 48.5634 139.536C48.5634 138.654 47.8483 137.938 46.9663 137.938C46.0842 137.938 45.3691 138.654 45.3691 139.536C45.3691 140.418 46.0842 141.133 46.9663 141.133Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_274",
    d: "M50.1596 19.7519C51.0417 19.7519 51.7567 19.0368 51.7567 18.1547C51.7567 17.2727 51.0417 16.5576 50.1596 16.5576C49.2776 16.5576 48.5625 17.2727 48.5625 18.1547C48.5625 19.0368 49.2776 19.7519 50.1596 19.7519Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_275",
    d: "M50.1596 35.7226C51.0417 35.7226 51.7567 35.0075 51.7567 34.1254C51.7567 33.2434 51.0417 32.5283 50.1596 32.5283C49.2776 32.5283 48.5625 33.2434 48.5625 34.1254C48.5625 35.0075 49.2776 35.7226 50.1596 35.7226Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_276",
    d: "M50.1596 38.9169C51.0417 38.9169 51.7567 38.2018 51.7567 37.3198C51.7567 36.4377 51.0417 35.7227 50.1596 35.7227C49.2776 35.7227 48.5625 36.4377 48.5625 37.3198C48.5625 38.2018 49.2776 38.9169 50.1596 38.9169Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_277",
    d: "M50.1596 42.1112C51.0417 42.1112 51.7567 41.3962 51.7567 40.5141C51.7567 39.632 51.0417 38.917 50.1596 38.917C49.2776 38.917 48.5625 39.632 48.5625 40.5141C48.5625 41.3962 49.2776 42.1112 50.1596 42.1112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_278",
    d: "M50.1596 45.3056C51.0417 45.3056 51.7567 44.5905 51.7567 43.7085C51.7567 42.8264 51.0417 42.1113 50.1596 42.1113C49.2776 42.1113 48.5625 42.8264 48.5625 43.7085C48.5625 44.5905 49.2776 45.3056 50.1596 45.3056Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_279",
    d: "M50.1596 54.8886C51.0417 54.8886 51.7567 54.1735 51.7567 53.2915C51.7567 52.4094 51.0417 51.6943 50.1596 51.6943C49.2776 51.6943 48.5625 52.4094 48.5625 53.2915C48.5625 54.1735 49.2776 54.8886 50.1596 54.8886Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_280",
    d: "M50.1596 58.0819C51.0417 58.0819 51.7567 57.3669 51.7567 56.4848C51.7567 55.6028 51.0417 54.8877 50.1596 54.8877C49.2776 54.8877 48.5625 55.6028 48.5625 56.4848C48.5625 57.3669 49.2776 58.0819 50.1596 58.0819Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_281",
    d: "M50.1596 70.8593C51.0417 70.8593 51.7567 70.1442 51.7567 69.2622C51.7567 68.3801 51.0417 67.665 50.1596 67.665C49.2776 67.665 48.5625 68.3801 48.5625 69.2622C48.5625 70.1442 49.2776 70.8593 50.1596 70.8593Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_282",
    d: "M50.1596 74.0536C51.0417 74.0536 51.7567 73.3386 51.7567 72.4565C51.7567 71.5744 51.0417 70.8594 50.1596 70.8594C49.2776 70.8594 48.5625 71.5744 48.5625 72.4565C48.5625 73.3386 49.2776 74.0536 50.1596 74.0536Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_283",
    d: "M50.1596 77.248C51.0417 77.248 51.7567 76.5329 51.7567 75.6508C51.7567 74.7688 51.0417 74.0537 50.1596 74.0537C49.2776 74.0537 48.5625 74.7688 48.5625 75.6508C48.5625 76.5329 49.2776 77.248 50.1596 77.248Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_284",
    d: "M50.1596 80.4423C51.0417 80.4423 51.7567 79.7272 51.7567 78.8452C51.7567 77.9631 51.0417 77.248 50.1596 77.248C49.2776 77.248 48.5625 77.9631 48.5625 78.8452C48.5625 79.7272 49.2776 80.4423 50.1596 80.4423Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_285",
    d: "M50.1596 83.6366C51.0417 83.6366 51.7567 82.9216 51.7567 82.0395C51.7567 81.1574 51.0417 80.4424 50.1596 80.4424C49.2776 80.4424 48.5625 81.1574 48.5625 82.0395C48.5625 82.9216 49.2776 83.6366 50.1596 83.6366Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_286",
    d: "M50.1596 86.831C51.0417 86.831 51.7567 86.1159 51.7567 85.2338C51.7567 84.3518 51.0417 83.6367 50.1596 83.6367C49.2776 83.6367 48.5625 84.3518 48.5625 85.2338C48.5625 86.1159 49.2776 86.831 50.1596 86.831Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_287",
    d: "M50.1596 90.0253C51.0417 90.0253 51.7567 89.3102 51.7567 88.4282C51.7567 87.5461 51.0417 86.8311 50.1596 86.8311C49.2776 86.8311 48.5625 87.5461 48.5625 88.4282C48.5625 89.3102 49.2776 90.0253 50.1596 90.0253Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_288",
    d: "M50.1596 105.996C51.0417 105.996 51.7567 105.281 51.7567 104.399C51.7567 103.517 51.0417 102.802 50.1596 102.802C49.2776 102.802 48.5625 103.517 48.5625 104.399C48.5625 105.281 49.2776 105.996 50.1596 105.996Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_289",
    d: "M50.1596 109.19C51.0417 109.19 51.7567 108.475 51.7567 107.593C51.7567 106.711 51.0417 105.996 50.1596 105.996C49.2776 105.996 48.5625 106.711 48.5625 107.593C48.5625 108.475 49.2776 109.19 50.1596 109.19Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_290",
    d: "M50.1596 128.356C51.0417 128.356 51.7567 127.641 51.7567 126.759C51.7567 125.877 51.0417 125.162 50.1596 125.162C49.2776 125.162 48.5625 125.877 48.5625 126.759C48.5625 127.641 49.2776 128.356 50.1596 128.356Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_291",
    d: "M50.1596 141.133C51.0417 141.133 51.7567 140.418 51.7567 139.536C51.7567 138.654 51.0417 137.938 50.1596 137.938C49.2776 137.938 48.5625 138.654 48.5625 139.536C48.5625 140.418 49.2776 141.133 50.1596 141.133Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_292",
    d: "M50.1596 144.327C51.0417 144.327 51.7567 143.612 51.7567 142.73C51.7567 141.848 51.0417 141.133 50.1596 141.133C49.2776 141.133 48.5625 141.848 48.5625 142.73C48.5625 143.612 49.2776 144.327 50.1596 144.327Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_293",
    d: "M53.3549 3.78019C54.237 3.78019 54.9521 3.06513 54.9521 2.18306C54.9521 1.30099 54.237 0.585938 53.3549 0.585938C52.4729 0.585938 51.7578 1.30099 51.7578 2.18306C51.7578 3.06513 52.4729 3.78019 53.3549 3.78019Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_294",
    d: "M53.3549 16.5575C54.237 16.5575 54.9521 15.8425 54.9521 14.9604C54.9521 14.0783 54.237 13.3633 53.3549 13.3633C52.4729 13.3633 51.7578 14.0783 51.7578 14.9604C51.7578 15.8425 52.4729 16.5575 53.3549 16.5575Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_295",
    d: "M53.3549 22.9452C54.237 22.9452 54.9521 22.2302 54.9521 21.3481C54.9521 20.466 54.237 19.751 53.3549 19.751C52.4729 19.751 51.7578 20.466 51.7578 21.3481C51.7578 22.2302 52.4729 22.9452 53.3549 22.9452Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_296",
    d: "M53.3549 26.1396C54.237 26.1396 54.9521 25.4245 54.9521 24.5424C54.9521 23.6604 54.237 22.9453 53.3549 22.9453C52.4729 22.9453 51.7578 23.6604 51.7578 24.5424C51.7578 25.4245 52.4729 26.1396 53.3549 26.1396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_297",
    d: "M53.3549 32.5282C54.237 32.5282 54.9521 31.8132 54.9521 30.9311C54.9521 30.049 54.237 29.334 53.3549 29.334C52.4729 29.334 51.7578 30.049 51.7578 30.9311C51.7578 31.8132 52.4729 32.5282 53.3549 32.5282Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_298",
    d: "M53.3549 35.7226C54.237 35.7226 54.9521 35.0075 54.9521 34.1254C54.9521 33.2434 54.237 32.5283 53.3549 32.5283C52.4729 32.5283 51.7578 33.2434 51.7578 34.1254C51.7578 35.0075 52.4729 35.7226 53.3549 35.7226Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_299",
    d: "M53.3549 51.6942C54.237 51.6942 54.9521 50.9792 54.9521 50.0971C54.9521 49.2151 54.237 48.5 53.3549 48.5C52.4729 48.5 51.7578 49.2151 51.7578 50.0971C51.7578 50.9792 52.4729 51.6942 53.3549 51.6942Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_300",
    d: "M53.3549 54.8886C54.237 54.8886 54.9521 54.1735 54.9521 53.2915C54.9521 52.4094 54.237 51.6943 53.3549 51.6943C52.4729 51.6943 51.7578 52.4094 51.7578 53.2915C51.7578 54.1735 52.4729 54.8886 53.3549 54.8886Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_301",
    d: "M53.3549 67.665C54.237 67.665 54.9521 66.9499 54.9521 66.0678C54.9521 65.1858 54.237 64.4707 53.3549 64.4707C52.4729 64.4707 51.7578 65.1858 51.7578 66.0678C51.7578 66.9499 52.4729 67.665 53.3549 67.665Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_302",
    d: "M53.3549 74.0536C54.237 74.0536 54.9521 73.3386 54.9521 72.4565C54.9521 71.5744 54.237 70.8594 53.3549 70.8594C52.4729 70.8594 51.7578 71.5744 51.7578 72.4565C51.7578 73.3386 52.4729 74.0536 53.3549 74.0536Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_303",
    d: "M53.3549 83.6366C54.237 83.6366 54.9521 82.9216 54.9521 82.0395C54.9521 81.1574 54.237 80.4424 53.3549 80.4424C52.4729 80.4424 51.7578 81.1574 51.7578 82.0395C51.7578 82.9216 52.4729 83.6366 53.3549 83.6366Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_304",
    d: "M53.3549 96.413C54.237 96.413 54.9521 95.6979 54.9521 94.8159C54.9521 93.9338 54.237 93.2188 53.3549 93.2188C52.4729 93.2188 51.7578 93.9338 51.7578 94.8159C51.7578 95.6979 52.4729 96.413 53.3549 96.413Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_305",
    d: "M53.3549 99.6073C54.237 99.6073 54.9521 98.8923 54.9521 98.0102C54.9521 97.1281 54.237 96.4131 53.3549 96.4131C52.4729 96.4131 51.7578 97.1281 51.7578 98.0102C51.7578 98.8923 52.4729 99.6073 53.3549 99.6073Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_306",
    d: "M53.3549 105.996C54.237 105.996 54.9521 105.281 54.9521 104.399C54.9521 103.517 54.237 102.802 53.3549 102.802C52.4729 102.802 51.7578 103.517 51.7578 104.399C51.7578 105.281 52.4729 105.996 53.3549 105.996Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_307",
    d: "M53.3549 112.385C54.237 112.385 54.9521 111.67 54.9521 110.788C54.9521 109.905 54.237 109.19 53.3549 109.19C52.4729 109.19 51.7578 109.905 51.7578 110.788C51.7578 111.67 52.4729 112.385 53.3549 112.385Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_308",
    d: "M53.3549 115.579C54.237 115.579 54.9521 114.864 54.9521 113.982C54.9521 113.1 54.237 112.385 53.3549 112.385C52.4729 112.385 51.7578 113.1 51.7578 113.982C51.7578 114.864 52.4729 115.579 53.3549 115.579Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_309",
    d: "M53.3549 125.162C54.237 125.162 54.9521 124.447 54.9521 123.565C54.9521 122.683 54.237 121.968 53.3549 121.968C52.4729 121.968 51.7578 122.683 51.7578 123.565C51.7578 124.447 52.4729 125.162 53.3549 125.162Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_310",
    d: "M53.3549 144.327C54.237 144.327 54.9521 143.612 54.9521 142.73C54.9521 141.848 54.237 141.133 53.3549 141.133C52.4729 141.133 51.7578 141.848 51.7578 142.73C51.7578 143.612 52.4729 144.327 53.3549 144.327Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_311",
    d: "M56.5483 6.97452C57.4304 6.97452 58.1454 6.25947 58.1454 5.3774C58.1454 4.49533 57.4304 3.78027 56.5483 3.78027C55.6662 3.78027 54.9512 4.49533 54.9512 5.3774C54.9512 6.25947 55.6662 6.97452 56.5483 6.97452Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_312",
    d: "M56.5483 10.1689C57.4304 10.1689 58.1454 9.4538 58.1454 8.57173C58.1454 7.68967 57.4304 6.97461 56.5483 6.97461C55.6662 6.97461 54.9512 7.68967 54.9512 8.57173C54.9512 9.4538 55.6662 10.1689 56.5483 10.1689Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_313",
    d: "M56.5483 29.3339C57.4304 29.3339 58.1454 28.6188 58.1454 27.7368C58.1454 26.8547 57.4304 26.1396 56.5483 26.1396C55.6662 26.1396 54.9512 26.8547 54.9512 27.7368C54.9512 28.6188 55.6662 29.3339 56.5483 29.3339Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_314",
    d: "M56.5483 35.7226C57.4304 35.7226 58.1454 35.0075 58.1454 34.1254C58.1454 33.2434 57.4304 32.5283 56.5483 32.5283C55.6662 32.5283 54.9512 33.2434 54.9512 34.1254C54.9512 35.0075 55.6662 35.7226 56.5483 35.7226Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_315",
    d: "M56.5483 45.3056C57.4304 45.3056 58.1454 44.5905 58.1454 43.7085C58.1454 42.8264 57.4304 42.1113 56.5483 42.1113C55.6662 42.1113 54.9512 42.8264 54.9512 43.7085C54.9512 44.5905 55.6662 45.3056 56.5483 45.3056Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_316",
    d: "M56.5483 48.4999C57.4304 48.4999 58.1454 47.7849 58.1454 46.9028C58.1454 46.0207 57.4304 45.3057 56.5483 45.3057C55.6662 45.3057 54.9512 46.0207 54.9512 46.9028C54.9512 47.7849 55.6662 48.4999 56.5483 48.4999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_317",
    d: "M56.5483 54.8886C57.4304 54.8886 58.1454 54.1735 58.1454 53.2915C58.1454 52.4094 57.4304 51.6943 56.5483 51.6943C55.6662 51.6943 54.9512 52.4094 54.9512 53.2915C54.9512 54.1735 55.6662 54.8886 56.5483 54.8886Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_318",
    d: "M56.5483 61.2763C57.4304 61.2763 58.1454 60.5612 58.1454 59.6792C58.1454 58.7971 57.4304 58.082 56.5483 58.082C55.6662 58.082 54.9512 58.7971 54.9512 59.6792C54.9512 60.5612 55.6662 61.2763 56.5483 61.2763Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_319",
    d: "M56.5483 64.4706C57.4304 64.4706 58.1454 63.7556 58.1454 62.8735C58.1454 61.9914 57.4304 61.2764 56.5483 61.2764C55.6662 61.2764 54.9512 61.9914 54.9512 62.8735C54.9512 63.7556 55.6662 64.4706 56.5483 64.4706Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_320",
    d: "M56.5483 74.0536C57.4304 74.0536 58.1454 73.3386 58.1454 72.4565C58.1454 71.5744 57.4304 70.8594 56.5483 70.8594C55.6662 70.8594 54.9512 71.5744 54.9512 72.4565C54.9512 73.3386 55.6662 74.0536 56.5483 74.0536Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_321",
    d: "M56.5483 77.248C57.4304 77.248 58.1454 76.5329 58.1454 75.6508C58.1454 74.7688 57.4304 74.0537 56.5483 74.0537C55.6662 74.0537 54.9512 74.7688 54.9512 75.6508C54.9512 76.5329 55.6662 77.248 56.5483 77.248Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_322",
    d: "M56.5483 80.4423C57.4304 80.4423 58.1454 79.7272 58.1454 78.8452C58.1454 77.9631 57.4304 77.248 56.5483 77.248C55.6662 77.248 54.9512 77.9631 54.9512 78.8452C54.9512 79.7272 55.6662 80.4423 56.5483 80.4423Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_323",
    d: "M56.5483 83.6366C57.4304 83.6366 58.1454 82.9216 58.1454 82.0395C58.1454 81.1574 57.4304 80.4424 56.5483 80.4424C55.6662 80.4424 54.9512 81.1574 54.9512 82.0395C54.9512 82.9216 55.6662 83.6366 56.5483 83.6366Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_324",
    d: "M56.5483 86.831C57.4304 86.831 58.1454 86.1159 58.1454 85.2338C58.1454 84.3518 57.4304 83.6367 56.5483 83.6367C55.6662 83.6367 54.9512 84.3518 54.9512 85.2338C54.9512 86.1159 55.6662 86.831 56.5483 86.831Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_325",
    d: "M56.5483 90.0253C57.4304 90.0253 58.1454 89.3102 58.1454 88.4282C58.1454 87.5461 57.4304 86.8311 56.5483 86.8311C55.6662 86.8311 54.9512 87.5461 54.9512 88.4282C54.9512 89.3102 55.6662 90.0253 56.5483 90.0253Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_326",
    d: "M56.5483 96.413C57.4304 96.413 58.1454 95.6979 58.1454 94.8159C58.1454 93.9338 57.4304 93.2188 56.5483 93.2188C55.6662 93.2188 54.9512 93.9338 54.9512 94.8159C54.9512 95.6979 55.6662 96.413 56.5483 96.413Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_327",
    d: "M56.5483 99.6073C57.4304 99.6073 58.1454 98.8923 58.1454 98.0102C58.1454 97.1281 57.4304 96.4131 56.5483 96.4131C55.6662 96.4131 54.9512 97.1281 54.9512 98.0102C54.9512 98.8923 55.6662 99.6073 56.5483 99.6073Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_328",
    d: "M56.5483 102.802C57.4304 102.802 58.1454 102.087 58.1454 101.205C58.1454 100.322 57.4304 99.6074 56.5483 99.6074C55.6662 99.6074 54.9512 100.322 54.9512 101.205C54.9512 102.087 55.6662 102.802 56.5483 102.802Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_329",
    d: "M56.5483 105.996C57.4304 105.996 58.1454 105.281 58.1454 104.399C58.1454 103.517 57.4304 102.802 56.5483 102.802C55.6662 102.802 54.9512 103.517 54.9512 104.399C54.9512 105.281 55.6662 105.996 56.5483 105.996Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_330",
    d: "M56.5483 118.773C57.4304 118.773 58.1454 118.058 58.1454 117.176C58.1454 116.294 57.4304 115.579 56.5483 115.579C55.6662 115.579 54.9512 116.294 54.9512 117.176C54.9512 118.058 55.6662 118.773 56.5483 118.773Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_331",
    d: "M56.5483 125.162C57.4304 125.162 58.1454 124.447 58.1454 123.565C58.1454 122.683 57.4304 121.968 56.5483 121.968C55.6662 121.968 54.9512 122.683 54.9512 123.565C54.9512 124.447 55.6662 125.162 56.5483 125.162Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_332",
    d: "M56.5483 131.55C57.4304 131.55 58.1454 130.835 58.1454 129.953C58.1454 129.071 57.4304 128.355 56.5483 128.355C55.6662 128.355 54.9512 129.071 54.9512 129.953C54.9512 130.835 55.6662 131.55 56.5483 131.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_333",
    d: "M56.5483 141.133C57.4304 141.133 58.1454 140.418 58.1454 139.536C58.1454 138.654 57.4304 137.938 56.5483 137.938C55.6662 137.938 54.9512 138.654 54.9512 139.536C54.9512 140.418 55.6662 141.133 56.5483 141.133Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_334",
    d: "M59.7417 6.97452C60.6237 6.97452 61.3388 6.25947 61.3388 5.3774C61.3388 4.49533 60.6237 3.78027 59.7417 3.78027C58.8596 3.78027 58.1445 4.49533 58.1445 5.3774C58.1445 6.25947 58.8596 6.97452 59.7417 6.97452Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_335",
    d: "M59.7417 13.3632C60.6237 13.3632 61.3388 12.6481 61.3388 11.7661C61.3388 10.884 60.6237 10.1689 59.7417 10.1689C58.8596 10.1689 58.1445 10.884 58.1445 11.7661C58.1445 12.6481 58.8596 13.3632 59.7417 13.3632Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_336",
    d: "M59.7417 16.5575C60.6237 16.5575 61.3388 15.8425 61.3388 14.9604C61.3388 14.0783 60.6237 13.3633 59.7417 13.3633C58.8596 13.3633 58.1445 14.0783 58.1445 14.9604C58.1445 15.8425 58.8596 16.5575 59.7417 16.5575Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_337",
    d: "M59.7417 22.9452C60.6237 22.9452 61.3388 22.2302 61.3388 21.3481C61.3388 20.466 60.6237 19.751 59.7417 19.751C58.8596 19.751 58.1445 20.466 58.1445 21.3481C58.1445 22.2302 58.8596 22.9452 59.7417 22.9452Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_338",
    d: "M59.7417 35.7226C60.6237 35.7226 61.3388 35.0075 61.3388 34.1254C61.3388 33.2434 60.6237 32.5283 59.7417 32.5283C58.8596 32.5283 58.1445 33.2434 58.1445 34.1254C58.1445 35.0075 58.8596 35.7226 59.7417 35.7226Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_339",
    d: "M59.7417 38.9169C60.6237 38.9169 61.3388 38.2018 61.3388 37.3198C61.3388 36.4377 60.6237 35.7227 59.7417 35.7227C58.8596 35.7227 58.1445 36.4377 58.1445 37.3198C58.1445 38.2018 58.8596 38.9169 59.7417 38.9169Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_340",
    d: "M59.7417 42.1112C60.6237 42.1112 61.3388 41.3962 61.3388 40.5141C61.3388 39.632 60.6237 38.917 59.7417 38.917C58.8596 38.917 58.1445 39.632 58.1445 40.5141C58.1445 41.3962 58.8596 42.1112 59.7417 42.1112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_341",
    d: "M59.7417 45.3056C60.6237 45.3056 61.3388 44.5905 61.3388 43.7085C61.3388 42.8264 60.6237 42.1113 59.7417 42.1113C58.8596 42.1113 58.1445 42.8264 58.1445 43.7085C58.1445 44.5905 58.8596 45.3056 59.7417 45.3056Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_342",
    d: "M59.7417 48.4999C60.6237 48.4999 61.3388 47.7849 61.3388 46.9028C61.3388 46.0207 60.6237 45.3057 59.7417 45.3057C58.8596 45.3057 58.1445 46.0207 58.1445 46.9028C58.1445 47.7849 58.8596 48.4999 59.7417 48.4999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_343",
    d: "M59.7417 54.8886C60.6237 54.8886 61.3388 54.1735 61.3388 53.2915C61.3388 52.4094 60.6237 51.6943 59.7417 51.6943C58.8596 51.6943 58.1445 52.4094 58.1445 53.2915C58.1445 54.1735 58.8596 54.8886 59.7417 54.8886Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_344",
    d: "M59.7417 61.2763C60.6237 61.2763 61.3388 60.5612 61.3388 59.6792C61.3388 58.7971 60.6237 58.082 59.7417 58.082C58.8596 58.082 58.1445 58.7971 58.1445 59.6792C58.1445 60.5612 58.8596 61.2763 59.7417 61.2763Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_345",
    d: "M59.7417 64.4706C60.6237 64.4706 61.3388 63.7556 61.3388 62.8735C61.3388 61.9914 60.6237 61.2764 59.7417 61.2764C58.8596 61.2764 58.1445 61.9914 58.1445 62.8735C58.1445 63.7556 58.8596 64.4706 59.7417 64.4706Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_346",
    d: "M59.7417 70.8593C60.6237 70.8593 61.3388 70.1442 61.3388 69.2622C61.3388 68.3801 60.6237 67.665 59.7417 67.665C58.8596 67.665 58.1445 68.3801 58.1445 69.2622C58.1445 70.1442 58.8596 70.8593 59.7417 70.8593Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_347",
    d: "M59.7417 77.248C60.6237 77.248 61.3388 76.5329 61.3388 75.6508C61.3388 74.7688 60.6237 74.0537 59.7417 74.0537C58.8596 74.0537 58.1445 74.7688 58.1445 75.6508C58.1445 76.5329 58.8596 77.248 59.7417 77.248Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_348",
    d: "M59.7417 80.4423C60.6237 80.4423 61.3388 79.7272 61.3388 78.8452C61.3388 77.9631 60.6237 77.248 59.7417 77.248C58.8596 77.248 58.1445 77.9631 58.1445 78.8452C58.1445 79.7272 58.8596 80.4423 59.7417 80.4423Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_349",
    d: "M59.7417 86.831C60.6237 86.831 61.3388 86.1159 61.3388 85.2338C61.3388 84.3518 60.6237 83.6367 59.7417 83.6367C58.8596 83.6367 58.1445 84.3518 58.1445 85.2338C58.1445 86.1159 58.8596 86.831 59.7417 86.831Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_350",
    d: "M59.7417 90.0253C60.6237 90.0253 61.3388 89.3102 61.3388 88.4282C61.3388 87.5461 60.6237 86.8311 59.7417 86.8311C58.8596 86.8311 58.1445 87.5461 58.1445 88.4282C58.1445 89.3102 58.8596 90.0253 59.7417 90.0253Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_351",
    d: "M59.7417 99.6073C60.6237 99.6073 61.3388 98.8923 61.3388 98.0102C61.3388 97.1281 60.6237 96.4131 59.7417 96.4131C58.8596 96.4131 58.1445 97.1281 58.1445 98.0102C58.1445 98.8923 58.8596 99.6073 59.7417 99.6073Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_352",
    d: "M59.7417 102.802C60.6237 102.802 61.3388 102.087 61.3388 101.205C61.3388 100.322 60.6237 99.6074 59.7417 99.6074C58.8596 99.6074 58.1445 100.322 58.1445 101.205C58.1445 102.087 58.8596 102.802 59.7417 102.802Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_353",
    d: "M59.7417 109.19C60.6237 109.19 61.3388 108.475 61.3388 107.593C61.3388 106.711 60.6237 105.996 59.7417 105.996C58.8596 105.996 58.1445 106.711 58.1445 107.593C58.1445 108.475 58.8596 109.19 59.7417 109.19Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_354",
    d: "M59.7417 118.773C60.6237 118.773 61.3388 118.058 61.3388 117.176C61.3388 116.294 60.6237 115.579 59.7417 115.579C58.8596 115.579 58.1445 116.294 58.1445 117.176C58.1445 118.058 58.8596 118.773 59.7417 118.773Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_355",
    d: "M59.7417 121.968C60.6237 121.968 61.3388 121.253 61.3388 120.371C61.3388 119.488 60.6237 118.773 59.7417 118.773C58.8596 118.773 58.1445 119.488 58.1445 120.371C58.1445 121.253 58.8596 121.968 59.7417 121.968Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_356",
    d: "M59.7417 125.162C60.6237 125.162 61.3388 124.447 61.3388 123.565C61.3388 122.683 60.6237 121.968 59.7417 121.968C58.8596 121.968 58.1445 122.683 58.1445 123.565C58.1445 124.447 58.8596 125.162 59.7417 125.162Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_357",
    d: "M59.7417 134.744C60.6237 134.744 61.3388 134.029 61.3388 133.147C61.3388 132.265 60.6237 131.55 59.7417 131.55C58.8596 131.55 58.1445 132.265 58.1445 133.147C58.1445 134.029 58.8596 134.744 59.7417 134.744Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_358",
    d: "M59.7417 141.133C60.6237 141.133 61.3388 140.418 61.3388 139.536C61.3388 138.654 60.6237 137.938 59.7417 137.938C58.8596 137.938 58.1445 138.654 58.1445 139.536C58.1445 140.418 58.8596 141.133 59.7417 141.133Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_359",
    d: "M62.937 3.78019C63.819 3.78019 64.5341 3.06513 64.5341 2.18306C64.5341 1.30099 63.819 0.585938 62.937 0.585938C62.0549 0.585938 61.3398 1.30099 61.3398 2.18306C61.3398 3.06513 62.0549 3.78019 62.937 3.78019Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_360",
    d: "M62.937 26.1396C63.819 26.1396 64.5341 25.4245 64.5341 24.5424C64.5341 23.6604 63.819 22.9453 62.937 22.9453C62.0549 22.9453 61.3398 23.6604 61.3398 24.5424C61.3398 25.4245 62.0549 26.1396 62.937 26.1396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_361",
    d: "M62.937 32.5282C63.819 32.5282 64.5341 31.8132 64.5341 30.9311C64.5341 30.049 63.819 29.334 62.937 29.334C62.0549 29.334 61.3398 30.049 61.3398 30.9311C61.3398 31.8132 62.0549 32.5282 62.937 32.5282Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_362",
    d: "M62.937 38.9169C63.819 38.9169 64.5341 38.2018 64.5341 37.3198C64.5341 36.4377 63.819 35.7227 62.937 35.7227C62.0549 35.7227 61.3398 36.4377 61.3398 37.3198C61.3398 38.2018 62.0549 38.9169 62.937 38.9169Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_363",
    d: "M62.937 48.4999C63.819 48.4999 64.5341 47.7849 64.5341 46.9028C64.5341 46.0207 63.819 45.3057 62.937 45.3057C62.0549 45.3057 61.3398 46.0207 61.3398 46.9028C61.3398 47.7849 62.0549 48.4999 62.937 48.4999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_364",
    d: "M62.937 54.8886C63.819 54.8886 64.5341 54.1735 64.5341 53.2915C64.5341 52.4094 63.819 51.6943 62.937 51.6943C62.0549 51.6943 61.3398 52.4094 61.3398 53.2915C61.3398 54.1735 62.0549 54.8886 62.937 54.8886Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_365",
    d: "M62.937 61.2763C63.819 61.2763 64.5341 60.5612 64.5341 59.6792C64.5341 58.7971 63.819 58.082 62.937 58.082C62.0549 58.082 61.3398 58.7971 61.3398 59.6792C61.3398 60.5612 62.0549 61.2763 62.937 61.2763Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_366",
    d: "M62.937 64.4706C63.819 64.4706 64.5341 63.7556 64.5341 62.8735C64.5341 61.9914 63.819 61.2764 62.937 61.2764C62.0549 61.2764 61.3398 61.9914 61.3398 62.8735C61.3398 63.7556 62.0549 64.4706 62.937 64.4706Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_367",
    d: "M62.937 77.248C63.819 77.248 64.5341 76.5329 64.5341 75.6508C64.5341 74.7688 63.819 74.0537 62.937 74.0537C62.0549 74.0537 61.3398 74.7688 61.3398 75.6508C61.3398 76.5329 62.0549 77.248 62.937 77.248Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_368",
    d: "M62.937 80.4423C63.819 80.4423 64.5341 79.7272 64.5341 78.8452C64.5341 77.9631 63.819 77.248 62.937 77.248C62.0549 77.248 61.3398 77.9631 61.3398 78.8452C61.3398 79.7272 62.0549 80.4423 62.937 80.4423Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_369",
    d: "M62.937 93.2187C63.819 93.2187 64.5341 92.5036 64.5341 91.6215C64.5341 90.7395 63.819 90.0244 62.937 90.0244C62.0549 90.0244 61.3398 90.7395 61.3398 91.6215C61.3398 92.5036 62.0549 93.2187 62.937 93.2187Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_370",
    d: "M62.937 105.996C63.819 105.996 64.5341 105.281 64.5341 104.399C64.5341 103.517 63.819 102.802 62.937 102.802C62.0549 102.802 61.3398 103.517 61.3398 104.399C61.3398 105.281 62.0549 105.996 62.937 105.996Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_371",
    d: "M62.937 115.579C63.819 115.579 64.5341 114.864 64.5341 113.982C64.5341 113.1 63.819 112.385 62.937 112.385C62.0549 112.385 61.3398 113.1 61.3398 113.982C61.3398 114.864 62.0549 115.579 62.937 115.579Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_372",
    d: "M62.937 121.968C63.819 121.968 64.5341 121.253 64.5341 120.371C64.5341 119.488 63.819 118.773 62.937 118.773C62.0549 118.773 61.3398 119.488 61.3398 120.371C61.3398 121.253 62.0549 121.968 62.937 121.968Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_373",
    d: "M62.937 125.162C63.819 125.162 64.5341 124.447 64.5341 123.565C64.5341 122.683 63.819 121.968 62.937 121.968C62.0549 121.968 61.3398 122.683 61.3398 123.565C61.3398 124.447 62.0549 125.162 62.937 125.162Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_374",
    d: "M62.937 144.327C63.819 144.327 64.5341 143.612 64.5341 142.73C64.5341 141.848 63.819 141.133 62.937 141.133C62.0549 141.133 61.3398 141.848 61.3398 142.73C61.3398 143.612 62.0549 144.327 62.937 144.327Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_375",
    d: "M66.1303 3.78019C67.0124 3.78019 67.7275 3.06513 67.7275 2.18306C67.7275 1.30099 67.0124 0.585938 66.1303 0.585938C65.2483 0.585938 64.5332 1.30099 64.5332 2.18306C64.5332 3.06513 65.2483 3.78019 66.1303 3.78019Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_376",
    d: "M66.1303 6.97452C67.0124 6.97452 67.7275 6.25947 67.7275 5.3774C67.7275 4.49533 67.0124 3.78027 66.1303 3.78027C65.2483 3.78027 64.5332 4.49533 64.5332 5.3774C64.5332 6.25947 65.2483 6.97452 66.1303 6.97452Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_377",
    d: "M66.1303 16.5575C67.0124 16.5575 67.7275 15.8425 67.7275 14.9604C67.7275 14.0783 67.0124 13.3633 66.1303 13.3633C65.2483 13.3633 64.5332 14.0783 64.5332 14.9604C64.5332 15.8425 65.2483 16.5575 66.1303 16.5575Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_378",
    d: "M66.1303 19.7519C67.0124 19.7519 67.7275 19.0368 67.7275 18.1547C67.7275 17.2727 67.0124 16.5576 66.1303 16.5576C65.2483 16.5576 64.5332 17.2727 64.5332 18.1547C64.5332 19.0368 65.2483 19.7519 66.1303 19.7519Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_379",
    d: "M66.1303 22.9452C67.0124 22.9452 67.7275 22.2302 67.7275 21.3481C67.7275 20.466 67.0124 19.751 66.1303 19.751C65.2483 19.751 64.5332 20.466 64.5332 21.3481C64.5332 22.2302 65.2483 22.9452 66.1303 22.9452Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_380",
    d: "M66.1303 26.1396C67.0124 26.1396 67.7275 25.4245 67.7275 24.5424C67.7275 23.6604 67.0124 22.9453 66.1303 22.9453C65.2483 22.9453 64.5332 23.6604 64.5332 24.5424C64.5332 25.4245 65.2483 26.1396 66.1303 26.1396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_381",
    d: "M66.1303 29.3339C67.0124 29.3339 67.7275 28.6188 67.7275 27.7368C67.7275 26.8547 67.0124 26.1396 66.1303 26.1396C65.2483 26.1396 64.5332 26.8547 64.5332 27.7368C64.5332 28.6188 65.2483 29.3339 66.1303 29.3339Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_382",
    d: "M66.1303 32.5282C67.0124 32.5282 67.7275 31.8132 67.7275 30.9311C67.7275 30.049 67.0124 29.334 66.1303 29.334C65.2483 29.334 64.5332 30.049 64.5332 30.9311C64.5332 31.8132 65.2483 32.5282 66.1303 32.5282Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_383",
    d: "M66.1303 42.1112C67.0124 42.1112 67.7275 41.3962 67.7275 40.5141C67.7275 39.632 67.0124 38.917 66.1303 38.917C65.2483 38.917 64.5332 39.632 64.5332 40.5141C64.5332 41.3962 65.2483 42.1112 66.1303 42.1112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_384",
    d: "M66.1303 54.8886C67.0124 54.8886 67.7275 54.1735 67.7275 53.2915C67.7275 52.4094 67.0124 51.6943 66.1303 51.6943C65.2483 51.6943 64.5332 52.4094 64.5332 53.2915C64.5332 54.1735 65.2483 54.8886 66.1303 54.8886Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_385",
    d: "M66.1303 58.0819C67.0124 58.0819 67.7275 57.3669 67.7275 56.4848C67.7275 55.6028 67.0124 54.8877 66.1303 54.8877C65.2483 54.8877 64.5332 55.6028 64.5332 56.4848C64.5332 57.3669 65.2483 58.0819 66.1303 58.0819Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_386",
    d: "M66.1303 61.2763C67.0124 61.2763 67.7275 60.5612 67.7275 59.6792C67.7275 58.7971 67.0124 58.082 66.1303 58.082C65.2483 58.082 64.5332 58.7971 64.5332 59.6792C64.5332 60.5612 65.2483 61.2763 66.1303 61.2763Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_387",
    d: "M66.1303 67.665C67.0124 67.665 67.7275 66.9499 67.7275 66.0678C67.7275 65.1858 67.0124 64.4707 66.1303 64.4707C65.2483 64.4707 64.5332 65.1858 64.5332 66.0678C64.5332 66.9499 65.2483 67.665 66.1303 67.665Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_388",
    d: "M66.1303 70.8593C67.0124 70.8593 67.7275 70.1442 67.7275 69.2622C67.7275 68.3801 67.0124 67.665 66.1303 67.665C65.2483 67.665 64.5332 68.3801 64.5332 69.2622C64.5332 70.1442 65.2483 70.8593 66.1303 70.8593Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_389",
    d: "M66.1303 74.0536C67.0124 74.0536 67.7275 73.3386 67.7275 72.4565C67.7275 71.5744 67.0124 70.8594 66.1303 70.8594C65.2483 70.8594 64.5332 71.5744 64.5332 72.4565C64.5332 73.3386 65.2483 74.0536 66.1303 74.0536Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_390",
    d: "M66.1303 77.248C67.0124 77.248 67.7275 76.5329 67.7275 75.6508C67.7275 74.7688 67.0124 74.0537 66.1303 74.0537C65.2483 74.0537 64.5332 74.7688 64.5332 75.6508C64.5332 76.5329 65.2483 77.248 66.1303 77.248Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_391",
    d: "M66.1303 80.4423C67.0124 80.4423 67.7275 79.7272 67.7275 78.8452C67.7275 77.9631 67.0124 77.248 66.1303 77.248C65.2483 77.248 64.5332 77.9631 64.5332 78.8452C64.5332 79.7272 65.2483 80.4423 66.1303 80.4423Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_392",
    d: "M66.1303 90.0253C67.0124 90.0253 67.7275 89.3102 67.7275 88.4282C67.7275 87.5461 67.0124 86.8311 66.1303 86.8311C65.2483 86.8311 64.5332 87.5461 64.5332 88.4282C64.5332 89.3102 65.2483 90.0253 66.1303 90.0253Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_393",
    d: "M66.1303 96.413C67.0124 96.413 67.7275 95.6979 67.7275 94.8159C67.7275 93.9338 67.0124 93.2188 66.1303 93.2188C65.2483 93.2188 64.5332 93.9338 64.5332 94.8159C64.5332 95.6979 65.2483 96.413 66.1303 96.413Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_394",
    d: "M66.1303 105.996C67.0124 105.996 67.7275 105.281 67.7275 104.399C67.7275 103.517 67.0124 102.802 66.1303 102.802C65.2483 102.802 64.5332 103.517 64.5332 104.399C64.5332 105.281 65.2483 105.996 66.1303 105.996Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_395",
    d: "M66.1303 112.385C67.0124 112.385 67.7275 111.67 67.7275 110.788C67.7275 109.905 67.0124 109.19 66.1303 109.19C65.2483 109.19 64.5332 109.905 64.5332 110.788C64.5332 111.67 65.2483 112.385 66.1303 112.385Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_396",
    d: "M66.1303 115.579C67.0124 115.579 67.7275 114.864 67.7275 113.982C67.7275 113.1 67.0124 112.385 66.1303 112.385C65.2483 112.385 64.5332 113.1 64.5332 113.982C64.5332 114.864 65.2483 115.579 66.1303 115.579Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_397",
    d: "M66.1303 118.773C67.0124 118.773 67.7275 118.058 67.7275 117.176C67.7275 116.294 67.0124 115.579 66.1303 115.579C65.2483 115.579 64.5332 116.294 64.5332 117.176C64.5332 118.058 65.2483 118.773 66.1303 118.773Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_398",
    d: "M66.1303 121.968C67.0124 121.968 67.7275 121.253 67.7275 120.371C67.7275 119.488 67.0124 118.773 66.1303 118.773C65.2483 118.773 64.5332 119.488 64.5332 120.371C64.5332 121.253 65.2483 121.968 66.1303 121.968Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_399",
    d: "M66.1303 125.162C67.0124 125.162 67.7275 124.447 67.7275 123.565C67.7275 122.683 67.0124 121.968 66.1303 121.968C65.2483 121.968 64.5332 122.683 64.5332 123.565C64.5332 124.447 65.2483 125.162 66.1303 125.162Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_400",
    d: "M66.1303 128.356C67.0124 128.356 67.7275 127.641 67.7275 126.759C67.7275 125.877 67.0124 125.162 66.1303 125.162C65.2483 125.162 64.5332 125.877 64.5332 126.759C64.5332 127.641 65.2483 128.356 66.1303 128.356Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_401",
    d: "M66.1303 131.55C67.0124 131.55 67.7275 130.835 67.7275 129.953C67.7275 129.071 67.0124 128.355 66.1303 128.355C65.2483 128.355 64.5332 129.071 64.5332 129.953C64.5332 130.835 65.2483 131.55 66.1303 131.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_402",
    d: "M66.1303 144.327C67.0124 144.327 67.7275 143.612 67.7275 142.73C67.7275 141.848 67.0124 141.133 66.1303 141.133C65.2483 141.133 64.5332 141.848 64.5332 142.73C64.5332 143.612 65.2483 144.327 66.1303 144.327Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_403",
    d: "M69.3237 3.78019C70.2058 3.78019 70.9208 3.06513 70.9208 2.18306C70.9208 1.30099 70.2058 0.585938 69.3237 0.585938C68.4416 0.585938 67.7266 1.30099 67.7266 2.18306C67.7266 3.06513 68.4416 3.78019 69.3237 3.78019Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_404",
    d: "M69.3237 6.97452C70.2058 6.97452 70.9208 6.25947 70.9208 5.3774C70.9208 4.49533 70.2058 3.78027 69.3237 3.78027C68.4416 3.78027 67.7266 4.49533 67.7266 5.3774C67.7266 6.25947 68.4416 6.97452 69.3237 6.97452Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_405",
    d: "M69.3237 10.1689C70.2058 10.1689 70.9208 9.4538 70.9208 8.57173C70.9208 7.68967 70.2058 6.97461 69.3237 6.97461C68.4416 6.97461 67.7266 7.68967 67.7266 8.57173C67.7266 9.4538 68.4416 10.1689 69.3237 10.1689Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_406",
    d: "M69.3237 16.5575C70.2058 16.5575 70.9208 15.8425 70.9208 14.9604C70.9208 14.0783 70.2058 13.3633 69.3237 13.3633C68.4416 13.3633 67.7266 14.0783 67.7266 14.9604C67.7266 15.8425 68.4416 16.5575 69.3237 16.5575Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_407",
    d: "M69.3237 29.3339C70.2058 29.3339 70.9208 28.6188 70.9208 27.7368C70.9208 26.8547 70.2058 26.1396 69.3237 26.1396C68.4416 26.1396 67.7266 26.8547 67.7266 27.7368C67.7266 28.6188 68.4416 29.3339 69.3237 29.3339Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_408",
    d: "M69.3237 38.9169C70.2058 38.9169 70.9208 38.2018 70.9208 37.3198C70.9208 36.4377 70.2058 35.7227 69.3237 35.7227C68.4416 35.7227 67.7266 36.4377 67.7266 37.3198C67.7266 38.2018 68.4416 38.9169 69.3237 38.9169Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_409",
    d: "M69.3237 54.8886C70.2058 54.8886 70.9208 54.1735 70.9208 53.2915C70.9208 52.4094 70.2058 51.6943 69.3237 51.6943C68.4416 51.6943 67.7266 52.4094 67.7266 53.2915C67.7266 54.1735 68.4416 54.8886 69.3237 54.8886Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_410",
    d: "M69.3237 58.0819C70.2058 58.0819 70.9208 57.3669 70.9208 56.4848C70.9208 55.6028 70.2058 54.8877 69.3237 54.8877C68.4416 54.8877 67.7266 55.6028 67.7266 56.4848C67.7266 57.3669 68.4416 58.0819 69.3237 58.0819Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_411",
    d: "M69.3237 64.4706C70.2058 64.4706 70.9208 63.7556 70.9208 62.8735C70.9208 61.9914 70.2058 61.2764 69.3237 61.2764C68.4416 61.2764 67.7266 61.9914 67.7266 62.8735C67.7266 63.7556 68.4416 64.4706 69.3237 64.4706Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_412",
    d: "M69.3237 67.665C70.2058 67.665 70.9208 66.9499 70.9208 66.0678C70.9208 65.1858 70.2058 64.4707 69.3237 64.4707C68.4416 64.4707 67.7266 65.1858 67.7266 66.0678C67.7266 66.9499 68.4416 67.665 69.3237 67.665Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_413",
    d: "M69.3237 80.4423C70.2058 80.4423 70.9208 79.7272 70.9208 78.8452C70.9208 77.9631 70.2058 77.248 69.3237 77.248C68.4416 77.248 67.7266 77.9631 67.7266 78.8452C67.7266 79.7272 68.4416 80.4423 69.3237 80.4423Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_414",
    d: "M69.3237 83.6366C70.2058 83.6366 70.9208 82.9216 70.9208 82.0395C70.9208 81.1574 70.2058 80.4424 69.3237 80.4424C68.4416 80.4424 67.7266 81.1574 67.7266 82.0395C67.7266 82.9216 68.4416 83.6366 69.3237 83.6366Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_415",
    d: "M69.3237 86.831C70.2058 86.831 70.9208 86.1159 70.9208 85.2338C70.9208 84.3518 70.2058 83.6367 69.3237 83.6367C68.4416 83.6367 67.7266 84.3518 67.7266 85.2338C67.7266 86.1159 68.4416 86.831 69.3237 86.831Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_416",
    d: "M69.3237 90.0253C70.2058 90.0253 70.9208 89.3102 70.9208 88.4282C70.9208 87.5461 70.2058 86.8311 69.3237 86.8311C68.4416 86.8311 67.7266 87.5461 67.7266 88.4282C67.7266 89.3102 68.4416 90.0253 69.3237 90.0253Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_417",
    d: "M69.3237 96.413C70.2058 96.413 70.9208 95.6979 70.9208 94.8159C70.9208 93.9338 70.2058 93.2188 69.3237 93.2188C68.4416 93.2188 67.7266 93.9338 67.7266 94.8159C67.7266 95.6979 68.4416 96.413 69.3237 96.413Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_418",
    d: "M69.3237 99.6073C70.2058 99.6073 70.9208 98.8923 70.9208 98.0102C70.9208 97.1281 70.2058 96.4131 69.3237 96.4131C68.4416 96.4131 67.7266 97.1281 67.7266 98.0102C67.7266 98.8923 68.4416 99.6073 69.3237 99.6073Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_419",
    d: "M69.3237 109.19C70.2058 109.19 70.9208 108.475 70.9208 107.593C70.9208 106.711 70.2058 105.996 69.3237 105.996C68.4416 105.996 67.7266 106.711 67.7266 107.593C67.7266 108.475 68.4416 109.19 69.3237 109.19Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_420",
    d: "M69.3237 118.773C70.2058 118.773 70.9208 118.058 70.9208 117.176C70.9208 116.294 70.2058 115.579 69.3237 115.579C68.4416 115.579 67.7266 116.294 67.7266 117.176C67.7266 118.058 68.4416 118.773 69.3237 118.773Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_421",
    d: "M69.3237 131.55C70.2058 131.55 70.9208 130.835 70.9208 129.953C70.9208 129.071 70.2058 128.355 69.3237 128.355C68.4416 128.355 67.7266 129.071 67.7266 129.953C67.7266 130.835 68.4416 131.55 69.3237 131.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_422",
    d: "M69.3237 141.133C70.2058 141.133 70.9208 140.418 70.9208 139.536C70.9208 138.654 70.2058 137.938 69.3237 137.938C68.4416 137.938 67.7266 138.654 67.7266 139.536C67.7266 140.418 68.4416 141.133 69.3237 141.133Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_423",
    d: "M72.519 3.78019C73.4011 3.78019 74.1161 3.06513 74.1161 2.18306C74.1161 1.30099 73.4011 0.585938 72.519 0.585938C71.6369 0.585938 70.9219 1.30099 70.9219 2.18306C70.9219 3.06513 71.6369 3.78019 72.519 3.78019Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_424",
    d: "M72.519 10.1689C73.4011 10.1689 74.1161 9.4538 74.1161 8.57173C74.1161 7.68967 73.4011 6.97461 72.519 6.97461C71.6369 6.97461 70.9219 7.68967 70.9219 8.57173C70.9219 9.4538 71.6369 10.1689 72.519 10.1689Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_425",
    d: "M72.519 16.5575C73.4011 16.5575 74.1161 15.8425 74.1161 14.9604C74.1161 14.0783 73.4011 13.3633 72.519 13.3633C71.6369 13.3633 70.9219 14.0783 70.9219 14.9604C70.9219 15.8425 71.6369 16.5575 72.519 16.5575Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_426",
    d: "M72.519 22.9452C73.4011 22.9452 74.1161 22.2302 74.1161 21.3481C74.1161 20.466 73.4011 19.751 72.519 19.751C71.6369 19.751 70.9219 20.466 70.9219 21.3481C70.9219 22.2302 71.6369 22.9452 72.519 22.9452Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_427",
    d: "M72.519 29.3339C73.4011 29.3339 74.1161 28.6188 74.1161 27.7368C74.1161 26.8547 73.4011 26.1396 72.519 26.1396C71.6369 26.1396 70.9219 26.8547 70.9219 27.7368C70.9219 28.6188 71.6369 29.3339 72.519 29.3339Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_428",
    d: "M72.519 32.5282C73.4011 32.5282 74.1161 31.8132 74.1161 30.9311C74.1161 30.049 73.4011 29.334 72.519 29.334C71.6369 29.334 70.9219 30.049 70.9219 30.9311C70.9219 31.8132 71.6369 32.5282 72.519 32.5282Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_429",
    d: "M72.519 38.9169C73.4011 38.9169 74.1161 38.2018 74.1161 37.3198C74.1161 36.4377 73.4011 35.7227 72.519 35.7227C71.6369 35.7227 70.9219 36.4377 70.9219 37.3198C70.9219 38.2018 71.6369 38.9169 72.519 38.9169Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_430",
    d: "M72.519 45.3056C73.4011 45.3056 74.1161 44.5905 74.1161 43.7085C74.1161 42.8264 73.4011 42.1113 72.519 42.1113C71.6369 42.1113 70.9219 42.8264 70.9219 43.7085C70.9219 44.5905 71.6369 45.3056 72.519 45.3056Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_431",
    d: "M72.519 54.8886C73.4011 54.8886 74.1161 54.1735 74.1161 53.2915C74.1161 52.4094 73.4011 51.6943 72.519 51.6943C71.6369 51.6943 70.9219 52.4094 70.9219 53.2915C70.9219 54.1735 71.6369 54.8886 72.519 54.8886Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_432",
    d: "M72.519 61.2763C73.4011 61.2763 74.1161 60.5612 74.1161 59.6792C74.1161 58.7971 73.4011 58.082 72.519 58.082C71.6369 58.082 70.9219 58.7971 70.9219 59.6792C70.9219 60.5612 71.6369 61.2763 72.519 61.2763Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_433",
    d: "M72.519 67.665C73.4011 67.665 74.1161 66.9499 74.1161 66.0678C74.1161 65.1858 73.4011 64.4707 72.519 64.4707C71.6369 64.4707 70.9219 65.1858 70.9219 66.0678C70.9219 66.9499 71.6369 67.665 72.519 67.665Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_434",
    d: "M72.519 74.0536C73.4011 74.0536 74.1161 73.3386 74.1161 72.4565C74.1161 71.5744 73.4011 70.8594 72.519 70.8594C71.6369 70.8594 70.9219 71.5744 70.9219 72.4565C70.9219 73.3386 71.6369 74.0536 72.519 74.0536Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_435",
    d: "M72.519 80.4423C73.4011 80.4423 74.1161 79.7272 74.1161 78.8452C74.1161 77.9631 73.4011 77.248 72.519 77.248C71.6369 77.248 70.9219 77.9631 70.9219 78.8452C70.9219 79.7272 71.6369 80.4423 72.519 80.4423Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_436",
    d: "M72.519 96.413C73.4011 96.413 74.1161 95.6979 74.1161 94.8159C74.1161 93.9338 73.4011 93.2188 72.519 93.2188C71.6369 93.2188 70.9219 93.9338 70.9219 94.8159C70.9219 95.6979 71.6369 96.413 72.519 96.413Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_437",
    d: "M72.519 99.6073C73.4011 99.6073 74.1161 98.8923 74.1161 98.0102C74.1161 97.1281 73.4011 96.4131 72.519 96.4131C71.6369 96.4131 70.9219 97.1281 70.9219 98.0102C70.9219 98.8923 71.6369 99.6073 72.519 99.6073Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_438",
    d: "M72.519 102.802C73.4011 102.802 74.1161 102.087 74.1161 101.205C74.1161 100.322 73.4011 99.6074 72.519 99.6074C71.6369 99.6074 70.9219 100.322 70.9219 101.205C70.9219 102.087 71.6369 102.802 72.519 102.802Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_439",
    d: "M72.519 105.996C73.4011 105.996 74.1161 105.281 74.1161 104.399C74.1161 103.517 73.4011 102.802 72.519 102.802C71.6369 102.802 70.9219 103.517 70.9219 104.399C70.9219 105.281 71.6369 105.996 72.519 105.996Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_440",
    d: "M72.519 109.19C73.4011 109.19 74.1161 108.475 74.1161 107.593C74.1161 106.711 73.4011 105.996 72.519 105.996C71.6369 105.996 70.9219 106.711 70.9219 107.593C70.9219 108.475 71.6369 109.19 72.519 109.19Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_441",
    d: "M72.519 118.773C73.4011 118.773 74.1161 118.058 74.1161 117.176C74.1161 116.294 73.4011 115.579 72.519 115.579C71.6369 115.579 70.9219 116.294 70.9219 117.176C70.9219 118.058 71.6369 118.773 72.519 118.773Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_442",
    d: "M72.519 125.162C73.4011 125.162 74.1161 124.447 74.1161 123.565C74.1161 122.683 73.4011 121.968 72.519 121.968C71.6369 121.968 70.9219 122.683 70.9219 123.565C70.9219 124.447 71.6369 125.162 72.519 125.162Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_443",
    d: "M72.519 131.55C73.4011 131.55 74.1161 130.835 74.1161 129.953C74.1161 129.071 73.4011 128.355 72.519 128.355C71.6369 128.355 70.9219 129.071 70.9219 129.953C70.9219 130.835 71.6369 131.55 72.519 131.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_444",
    d: "M72.519 134.744C73.4011 134.744 74.1161 134.029 74.1161 133.147C74.1161 132.265 73.4011 131.55 72.519 131.55C71.6369 131.55 70.9219 132.265 70.9219 133.147C70.9219 134.029 71.6369 134.744 72.519 134.744Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_445",
    d: "M72.519 141.133C73.4011 141.133 74.1161 140.418 74.1161 139.536C74.1161 138.654 73.4011 137.938 72.519 137.938C71.6369 137.938 70.9219 138.654 70.9219 139.536C70.9219 140.418 71.6369 141.133 72.519 141.133Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_446",
    d: "M75.7124 3.78019C76.5944 3.78019 77.3095 3.06513 77.3095 2.18306C77.3095 1.30099 76.5944 0.585938 75.7124 0.585938C74.8303 0.585938 74.1152 1.30099 74.1152 2.18306C74.1152 3.06513 74.8303 3.78019 75.7124 3.78019Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_447",
    d: "M75.7124 6.97452C76.5944 6.97452 77.3095 6.25947 77.3095 5.3774C77.3095 4.49533 76.5944 3.78027 75.7124 3.78027C74.8303 3.78027 74.1152 4.49533 74.1152 5.3774C74.1152 6.25947 74.8303 6.97452 75.7124 6.97452Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_448",
    d: "M75.7124 10.1689C76.5944 10.1689 77.3095 9.4538 77.3095 8.57173C77.3095 7.68967 76.5944 6.97461 75.7124 6.97461C74.8303 6.97461 74.1152 7.68967 74.1152 8.57173C74.1152 9.4538 74.8303 10.1689 75.7124 10.1689Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_449",
    d: "M75.7124 16.5575C76.5944 16.5575 77.3095 15.8425 77.3095 14.9604C77.3095 14.0783 76.5944 13.3633 75.7124 13.3633C74.8303 13.3633 74.1152 14.0783 74.1152 14.9604C74.1152 15.8425 74.8303 16.5575 75.7124 16.5575Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_450",
    d: "M75.7124 29.3339C76.5944 29.3339 77.3095 28.6188 77.3095 27.7368C77.3095 26.8547 76.5944 26.1396 75.7124 26.1396C74.8303 26.1396 74.1152 26.8547 74.1152 27.7368C74.1152 28.6188 74.8303 29.3339 75.7124 29.3339Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_451",
    d: "M75.7124 32.5282C76.5944 32.5282 77.3095 31.8132 77.3095 30.9311C77.3095 30.049 76.5944 29.334 75.7124 29.334C74.8303 29.334 74.1152 30.049 74.1152 30.9311C74.1152 31.8132 74.8303 32.5282 75.7124 32.5282Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_452",
    d: "M75.7124 38.9169C76.5944 38.9169 77.3095 38.2018 77.3095 37.3198C77.3095 36.4377 76.5944 35.7227 75.7124 35.7227C74.8303 35.7227 74.1152 36.4377 74.1152 37.3198C74.1152 38.2018 74.8303 38.9169 75.7124 38.9169Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_453",
    d: "M75.7124 42.1112C76.5944 42.1112 77.3095 41.3962 77.3095 40.5141C77.3095 39.632 76.5944 38.917 75.7124 38.917C74.8303 38.917 74.1152 39.632 74.1152 40.5141C74.1152 41.3962 74.8303 42.1112 75.7124 42.1112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_454",
    d: "M75.7124 48.4999C76.5944 48.4999 77.3095 47.7849 77.3095 46.9028C77.3095 46.0207 76.5944 45.3057 75.7124 45.3057C74.8303 45.3057 74.1152 46.0207 74.1152 46.9028C74.1152 47.7849 74.8303 48.4999 75.7124 48.4999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_455",
    d: "M75.7124 54.8886C76.5944 54.8886 77.3095 54.1735 77.3095 53.2915C77.3095 52.4094 76.5944 51.6943 75.7124 51.6943C74.8303 51.6943 74.1152 52.4094 74.1152 53.2915C74.1152 54.1735 74.8303 54.8886 75.7124 54.8886Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_456",
    d: "M75.7124 58.0819C76.5944 58.0819 77.3095 57.3669 77.3095 56.4848C77.3095 55.6028 76.5944 54.8877 75.7124 54.8877C74.8303 54.8877 74.1152 55.6028 74.1152 56.4848C74.1152 57.3669 74.8303 58.0819 75.7124 58.0819Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_457",
    d: "M75.7124 64.4706C76.5944 64.4706 77.3095 63.7556 77.3095 62.8735C77.3095 61.9914 76.5944 61.2764 75.7124 61.2764C74.8303 61.2764 74.1152 61.9914 74.1152 62.8735C74.1152 63.7556 74.8303 64.4706 75.7124 64.4706Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_458",
    d: "M75.7124 67.665C76.5944 67.665 77.3095 66.9499 77.3095 66.0678C77.3095 65.1858 76.5944 64.4707 75.7124 64.4707C74.8303 64.4707 74.1152 65.1858 74.1152 66.0678C74.1152 66.9499 74.8303 67.665 75.7124 67.665Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_459",
    d: "M75.7124 80.4423C76.5944 80.4423 77.3095 79.7272 77.3095 78.8452C77.3095 77.9631 76.5944 77.248 75.7124 77.248C74.8303 77.248 74.1152 77.9631 74.1152 78.8452C74.1152 79.7272 74.8303 80.4423 75.7124 80.4423Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_460",
    d: "M75.7124 86.831C76.5944 86.831 77.3095 86.1159 77.3095 85.2338C77.3095 84.3518 76.5944 83.6367 75.7124 83.6367C74.8303 83.6367 74.1152 84.3518 74.1152 85.2338C74.1152 86.1159 74.8303 86.831 75.7124 86.831Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_461",
    d: "M75.7124 90.0253C76.5944 90.0253 77.3095 89.3102 77.3095 88.4282C77.3095 87.5461 76.5944 86.8311 75.7124 86.8311C74.8303 86.8311 74.1152 87.5461 74.1152 88.4282C74.1152 89.3102 74.8303 90.0253 75.7124 90.0253Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_462",
    d: "M75.7124 99.6073C76.5944 99.6073 77.3095 98.8923 77.3095 98.0102C77.3095 97.1281 76.5944 96.4131 75.7124 96.4131C74.8303 96.4131 74.1152 97.1281 74.1152 98.0102C74.1152 98.8923 74.8303 99.6073 75.7124 99.6073Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_463",
    d: "M75.7124 102.802C76.5944 102.802 77.3095 102.087 77.3095 101.205C77.3095 100.322 76.5944 99.6074 75.7124 99.6074C74.8303 99.6074 74.1152 100.322 74.1152 101.205C74.1152 102.087 74.8303 102.802 75.7124 102.802Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_464",
    d: "M75.7124 105.996C76.5944 105.996 77.3095 105.281 77.3095 104.399C77.3095 103.517 76.5944 102.802 75.7124 102.802C74.8303 102.802 74.1152 103.517 74.1152 104.399C74.1152 105.281 74.8303 105.996 75.7124 105.996Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_465",
    d: "M75.7124 109.19C76.5944 109.19 77.3095 108.475 77.3095 107.593C77.3095 106.711 76.5944 105.996 75.7124 105.996C74.8303 105.996 74.1152 106.711 74.1152 107.593C74.1152 108.475 74.8303 109.19 75.7124 109.19Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_466",
    d: "M75.7124 112.385C76.5944 112.385 77.3095 111.67 77.3095 110.788C77.3095 109.905 76.5944 109.19 75.7124 109.19C74.8303 109.19 74.1152 109.905 74.1152 110.788C74.1152 111.67 74.8303 112.385 75.7124 112.385Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_467",
    d: "M75.7124 115.579C76.5944 115.579 77.3095 114.864 77.3095 113.982C77.3095 113.1 76.5944 112.385 75.7124 112.385C74.8303 112.385 74.1152 113.1 74.1152 113.982C74.1152 114.864 74.8303 115.579 75.7124 115.579Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_468",
    d: "M75.7124 118.773C76.5944 118.773 77.3095 118.058 77.3095 117.176C77.3095 116.294 76.5944 115.579 75.7124 115.579C74.8303 115.579 74.1152 116.294 74.1152 117.176C74.1152 118.058 74.8303 118.773 75.7124 118.773Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_469",
    d: "M75.7124 131.55C76.5944 131.55 77.3095 130.835 77.3095 129.953C77.3095 129.071 76.5944 128.355 75.7124 128.355C74.8303 128.355 74.1152 129.071 74.1152 129.953C74.1152 130.835 74.8303 131.55 75.7124 131.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_470",
    d: "M75.7124 144.327C76.5944 144.327 77.3095 143.612 77.3095 142.73C77.3095 141.848 76.5944 141.133 75.7124 141.133C74.8303 141.133 74.1152 141.848 74.1152 142.73C74.1152 143.612 74.8303 144.327 75.7124 144.327Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_471",
    d: "M78.9077 10.1689C79.7897 10.1689 80.5048 9.4538 80.5048 8.57173C80.5048 7.68967 79.7897 6.97461 78.9077 6.97461C78.0256 6.97461 77.3105 7.68967 77.3105 8.57173C77.3105 9.4538 78.0256 10.1689 78.9077 10.1689Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_472",
    d: "M78.9077 13.3632C79.7897 13.3632 80.5048 12.6481 80.5048 11.7661C80.5048 10.884 79.7897 10.1689 78.9077 10.1689C78.0256 10.1689 77.3105 10.884 77.3105 11.7661C77.3105 12.6481 78.0256 13.3632 78.9077 13.3632Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_473",
    d: "M78.9077 16.5575C79.7897 16.5575 80.5048 15.8425 80.5048 14.9604C80.5048 14.0783 79.7897 13.3633 78.9077 13.3633C78.0256 13.3633 77.3105 14.0783 77.3105 14.9604C77.3105 15.8425 78.0256 16.5575 78.9077 16.5575Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_474",
    d: "M78.9077 19.7519C79.7897 19.7519 80.5048 19.0368 80.5048 18.1547C80.5048 17.2727 79.7897 16.5576 78.9077 16.5576C78.0256 16.5576 77.3105 17.2727 77.3105 18.1547C77.3105 19.0368 78.0256 19.7519 78.9077 19.7519Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_475",
    d: "M78.9077 22.9452C79.7897 22.9452 80.5048 22.2302 80.5048 21.3481C80.5048 20.466 79.7897 19.751 78.9077 19.751C78.0256 19.751 77.3105 20.466 77.3105 21.3481C77.3105 22.2302 78.0256 22.9452 78.9077 22.9452Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_476",
    d: "M78.9077 26.1396C79.7897 26.1396 80.5048 25.4245 80.5048 24.5424C80.5048 23.6604 79.7897 22.9453 78.9077 22.9453C78.0256 22.9453 77.3105 23.6604 77.3105 24.5424C77.3105 25.4245 78.0256 26.1396 78.9077 26.1396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_477",
    d: "M78.9077 29.3339C79.7897 29.3339 80.5048 28.6188 80.5048 27.7368C80.5048 26.8547 79.7897 26.1396 78.9077 26.1396C78.0256 26.1396 77.3105 26.8547 77.3105 27.7368C77.3105 28.6188 78.0256 29.3339 78.9077 29.3339Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_478",
    d: "M78.9077 35.7226C79.7897 35.7226 80.5048 35.0075 80.5048 34.1254C80.5048 33.2434 79.7897 32.5283 78.9077 32.5283C78.0256 32.5283 77.3105 33.2434 77.3105 34.1254C77.3105 35.0075 78.0256 35.7226 78.9077 35.7226Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_479",
    d: "M78.9077 42.1112C79.7897 42.1112 80.5048 41.3962 80.5048 40.5141C80.5048 39.632 79.7897 38.917 78.9077 38.917C78.0256 38.917 77.3105 39.632 77.3105 40.5141C77.3105 41.3962 78.0256 42.1112 78.9077 42.1112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_480",
    d: "M78.9077 61.2763C79.7897 61.2763 80.5048 60.5612 80.5048 59.6792C80.5048 58.7971 79.7897 58.082 78.9077 58.082C78.0256 58.082 77.3105 58.7971 77.3105 59.6792C77.3105 60.5612 78.0256 61.2763 78.9077 61.2763Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_481",
    d: "M78.9077 64.4706C79.7897 64.4706 80.5048 63.7556 80.5048 62.8735C80.5048 61.9914 79.7897 61.2764 78.9077 61.2764C78.0256 61.2764 77.3105 61.9914 77.3105 62.8735C77.3105 63.7556 78.0256 64.4706 78.9077 64.4706Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_482",
    d: "M78.9077 67.665C79.7897 67.665 80.5048 66.9499 80.5048 66.0678C80.5048 65.1858 79.7897 64.4707 78.9077 64.4707C78.0256 64.4707 77.3105 65.1858 77.3105 66.0678C77.3105 66.9499 78.0256 67.665 78.9077 67.665Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_483",
    d: "M78.9077 70.8593C79.7897 70.8593 80.5048 70.1442 80.5048 69.2622C80.5048 68.3801 79.7897 67.665 78.9077 67.665C78.0256 67.665 77.3105 68.3801 77.3105 69.2622C77.3105 70.1442 78.0256 70.8593 78.9077 70.8593Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_484",
    d: "M78.9077 74.0536C79.7897 74.0536 80.5048 73.3386 80.5048 72.4565C80.5048 71.5744 79.7897 70.8594 78.9077 70.8594C78.0256 70.8594 77.3105 71.5744 77.3105 72.4565C77.3105 73.3386 78.0256 74.0536 78.9077 74.0536Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_485",
    d: "M78.9077 77.248C79.7897 77.248 80.5048 76.5329 80.5048 75.6508C80.5048 74.7688 79.7897 74.0537 78.9077 74.0537C78.0256 74.0537 77.3105 74.7688 77.3105 75.6508C77.3105 76.5329 78.0256 77.248 78.9077 77.248Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_486",
    d: "M78.9077 80.4423C79.7897 80.4423 80.5048 79.7272 80.5048 78.8452C80.5048 77.9631 79.7897 77.248 78.9077 77.248C78.0256 77.248 77.3105 77.9631 77.3105 78.8452C77.3105 79.7272 78.0256 80.4423 78.9077 80.4423Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_487",
    d: "M78.9077 90.0253C79.7897 90.0253 80.5048 89.3102 80.5048 88.4282C80.5048 87.5461 79.7897 86.8311 78.9077 86.8311C78.0256 86.8311 77.3105 87.5461 77.3105 88.4282C77.3105 89.3102 78.0256 90.0253 78.9077 90.0253Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_488",
    d: "M78.9077 99.6073C79.7897 99.6073 80.5048 98.8923 80.5048 98.0102C80.5048 97.1281 79.7897 96.4131 78.9077 96.4131C78.0256 96.4131 77.3105 97.1281 77.3105 98.0102C77.3105 98.8923 78.0256 99.6073 78.9077 99.6073Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_489",
    d: "M78.9077 105.996C79.7897 105.996 80.5048 105.281 80.5048 104.399C80.5048 103.517 79.7897 102.802 78.9077 102.802C78.0256 102.802 77.3105 103.517 77.3105 104.399C77.3105 105.281 78.0256 105.996 78.9077 105.996Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_490",
    d: "M78.9077 109.19C79.7897 109.19 80.5048 108.475 80.5048 107.593C80.5048 106.711 79.7897 105.996 78.9077 105.996C78.0256 105.996 77.3105 106.711 77.3105 107.593C77.3105 108.475 78.0256 109.19 78.9077 109.19Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_491",
    d: "M78.9077 112.385C79.7897 112.385 80.5048 111.67 80.5048 110.788C80.5048 109.905 79.7897 109.19 78.9077 109.19C78.0256 109.19 77.3105 109.905 77.3105 110.788C77.3105 111.67 78.0256 112.385 78.9077 112.385Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_492",
    d: "M78.9077 118.773C79.7897 118.773 80.5048 118.058 80.5048 117.176C80.5048 116.294 79.7897 115.579 78.9077 115.579C78.0256 115.579 77.3105 116.294 77.3105 117.176C77.3105 118.058 78.0256 118.773 78.9077 118.773Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_493",
    d: "M78.9077 121.968C79.7897 121.968 80.5048 121.253 80.5048 120.371C80.5048 119.488 79.7897 118.773 78.9077 118.773C78.0256 118.773 77.3105 119.488 77.3105 120.371C77.3105 121.253 78.0256 121.968 78.9077 121.968Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_494",
    d: "M78.9077 125.162C79.7897 125.162 80.5048 124.447 80.5048 123.565C80.5048 122.683 79.7897 121.968 78.9077 121.968C78.0256 121.968 77.3105 122.683 77.3105 123.565C77.3105 124.447 78.0256 125.162 78.9077 125.162Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_495",
    d: "M78.9077 128.356C79.7897 128.356 80.5048 127.641 80.5048 126.759C80.5048 125.877 79.7897 125.162 78.9077 125.162C78.0256 125.162 77.3105 125.877 77.3105 126.759C77.3105 127.641 78.0256 128.356 78.9077 128.356Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_496",
    d: "M78.9077 131.55C79.7897 131.55 80.5048 130.835 80.5048 129.953C80.5048 129.071 79.7897 128.355 78.9077 128.355C78.0256 128.355 77.3105 129.071 77.3105 129.953C77.3105 130.835 78.0256 131.55 78.9077 131.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_497",
    d: "M78.9077 134.744C79.7897 134.744 80.5048 134.029 80.5048 133.147C80.5048 132.265 79.7897 131.55 78.9077 131.55C78.0256 131.55 77.3105 132.265 77.3105 133.147C77.3105 134.029 78.0256 134.744 78.9077 134.744Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_498",
    d: "M78.9077 144.327C79.7897 144.327 80.5048 143.612 80.5048 142.73C80.5048 141.848 79.7897 141.133 78.9077 141.133C78.0256 141.133 77.3105 141.848 77.3105 142.73C77.3105 143.612 78.0256 144.327 78.9077 144.327Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_499",
    d: "M82.103 3.78019C82.9851 3.78019 83.7001 3.06513 83.7001 2.18306C83.7001 1.30099 82.9851 0.585938 82.103 0.585938C81.2209 0.585938 80.5059 1.30099 80.5059 2.18306C80.5059 3.06513 81.2209 3.78019 82.103 3.78019Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_500",
    d: "M82.103 13.3632C82.9851 13.3632 83.7001 12.6481 83.7001 11.7661C83.7001 10.884 82.9851 10.1689 82.103 10.1689C81.2209 10.1689 80.5059 10.884 80.5059 11.7661C80.5059 12.6481 81.2209 13.3632 82.103 13.3632Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_501",
    d: "M82.103 19.7519C82.9851 19.7519 83.7001 19.0368 83.7001 18.1547C83.7001 17.2727 82.9851 16.5576 82.103 16.5576C81.2209 16.5576 80.5059 17.2727 80.5059 18.1547C80.5059 19.0368 81.2209 19.7519 82.103 19.7519Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_502",
    d: "M82.103 26.1396C82.9851 26.1396 83.7001 25.4245 83.7001 24.5424C83.7001 23.6604 82.9851 22.9453 82.103 22.9453C81.2209 22.9453 80.5059 23.6604 80.5059 24.5424C80.5059 25.4245 81.2209 26.1396 82.103 26.1396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_503",
    d: "M82.103 29.3339C82.9851 29.3339 83.7001 28.6188 83.7001 27.7368C83.7001 26.8547 82.9851 26.1396 82.103 26.1396C81.2209 26.1396 80.5059 26.8547 80.5059 27.7368C80.5059 28.6188 81.2209 29.3339 82.103 29.3339Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_504",
    d: "M82.103 32.5282C82.9851 32.5282 83.7001 31.8132 83.7001 30.9311C83.7001 30.049 82.9851 29.334 82.103 29.334C81.2209 29.334 80.5059 30.049 80.5059 30.9311C80.5059 31.8132 81.2209 32.5282 82.103 32.5282Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_505",
    d: "M82.103 35.7226C82.9851 35.7226 83.7001 35.0075 83.7001 34.1254C83.7001 33.2434 82.9851 32.5283 82.103 32.5283C81.2209 32.5283 80.5059 33.2434 80.5059 34.1254C80.5059 35.0075 81.2209 35.7226 82.103 35.7226Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_506",
    d: "M82.103 42.1112C82.9851 42.1112 83.7001 41.3962 83.7001 40.5141C83.7001 39.632 82.9851 38.917 82.103 38.917C81.2209 38.917 80.5059 39.632 80.5059 40.5141C80.5059 41.3962 81.2209 42.1112 82.103 42.1112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_507",
    d: "M82.103 51.6942C82.9851 51.6942 83.7001 50.9792 83.7001 50.0971C83.7001 49.2151 82.9851 48.5 82.103 48.5C81.2209 48.5 80.5059 49.2151 80.5059 50.0971C80.5059 50.9792 81.2209 51.6942 82.103 51.6942Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_508",
    d: "M82.103 74.0536C82.9851 74.0536 83.7001 73.3386 83.7001 72.4565C83.7001 71.5744 82.9851 70.8594 82.103 70.8594C81.2209 70.8594 80.5059 71.5744 80.5059 72.4565C80.5059 73.3386 81.2209 74.0536 82.103 74.0536Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_509",
    d: "M82.103 80.4423C82.9851 80.4423 83.7001 79.7272 83.7001 78.8452C83.7001 77.9631 82.9851 77.248 82.103 77.248C81.2209 77.248 80.5059 77.9631 80.5059 78.8452C80.5059 79.7272 81.2209 80.4423 82.103 80.4423Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_510",
    d: "M82.103 86.831C82.9851 86.831 83.7001 86.1159 83.7001 85.2338C83.7001 84.3518 82.9851 83.6367 82.103 83.6367C81.2209 83.6367 80.5059 84.3518 80.5059 85.2338C80.5059 86.1159 81.2209 86.831 82.103 86.831Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_511",
    d: "M82.103 90.0253C82.9851 90.0253 83.7001 89.3102 83.7001 88.4282C83.7001 87.5461 82.9851 86.8311 82.103 86.8311C81.2209 86.8311 80.5059 87.5461 80.5059 88.4282C80.5059 89.3102 81.2209 90.0253 82.103 90.0253Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_512",
    d: "M82.103 96.413C82.9851 96.413 83.7001 95.6979 83.7001 94.8159C83.7001 93.9338 82.9851 93.2188 82.103 93.2188C81.2209 93.2188 80.5059 93.9338 80.5059 94.8159C80.5059 95.6979 81.2209 96.413 82.103 96.413Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_513",
    d: "M82.103 99.6073C82.9851 99.6073 83.7001 98.8923 83.7001 98.0102C83.7001 97.1281 82.9851 96.4131 82.103 96.4131C81.2209 96.4131 80.5059 97.1281 80.5059 98.0102C80.5059 98.8923 81.2209 99.6073 82.103 99.6073Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_514",
    d: "M82.103 115.579C82.9851 115.579 83.7001 114.864 83.7001 113.982C83.7001 113.1 82.9851 112.385 82.103 112.385C81.2209 112.385 80.5059 113.1 80.5059 113.982C80.5059 114.864 81.2209 115.579 82.103 115.579Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_515",
    d: "M82.103 125.162C82.9851 125.162 83.7001 124.447 83.7001 123.565C83.7001 122.683 82.9851 121.968 82.103 121.968C81.2209 121.968 80.5059 122.683 80.5059 123.565C80.5059 124.447 81.2209 125.162 82.103 125.162Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_516",
    d: "M82.103 134.744C82.9851 134.744 83.7001 134.029 83.7001 133.147C83.7001 132.265 82.9851 131.55 82.103 131.55C81.2209 131.55 80.5059 132.265 80.5059 133.147C80.5059 134.029 81.2209 134.744 82.103 134.744Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_517",
    d: "M82.103 141.133C82.9851 141.133 83.7001 140.418 83.7001 139.536C83.7001 138.654 82.9851 137.938 82.103 137.938C81.2209 137.938 80.5059 138.654 80.5059 139.536C80.5059 140.418 81.2209 141.133 82.103 141.133Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_518",
    d: "M85.2963 3.78019C86.1784 3.78019 86.8935 3.06513 86.8935 2.18306C86.8935 1.30099 86.1784 0.585938 85.2963 0.585938C84.4143 0.585938 83.6992 1.30099 83.6992 2.18306C83.6992 3.06513 84.4143 3.78019 85.2963 3.78019Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_519",
    d: "M85.2963 6.97452C86.1784 6.97452 86.8935 6.25947 86.8935 5.3774C86.8935 4.49533 86.1784 3.78027 85.2963 3.78027C84.4143 3.78027 83.6992 4.49533 83.6992 5.3774C83.6992 6.25947 84.4143 6.97452 85.2963 6.97452Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_520",
    d: "M85.2963 19.7519C86.1784 19.7519 86.8935 19.0368 86.8935 18.1547C86.8935 17.2727 86.1784 16.5576 85.2963 16.5576C84.4143 16.5576 83.6992 17.2727 83.6992 18.1547C83.6992 19.0368 84.4143 19.7519 85.2963 19.7519Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_521",
    d: "M85.2963 22.9452C86.1784 22.9452 86.8935 22.2302 86.8935 21.3481C86.8935 20.466 86.1784 19.751 85.2963 19.751C84.4143 19.751 83.6992 20.466 83.6992 21.3481C83.6992 22.2302 84.4143 22.9452 85.2963 22.9452Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_522",
    d: "M85.2963 26.1396C86.1784 26.1396 86.8935 25.4245 86.8935 24.5424C86.8935 23.6604 86.1784 22.9453 85.2963 22.9453C84.4143 22.9453 83.6992 23.6604 83.6992 24.5424C83.6992 25.4245 84.4143 26.1396 85.2963 26.1396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_523",
    d: "M85.2963 45.3056C86.1784 45.3056 86.8935 44.5905 86.8935 43.7085C86.8935 42.8264 86.1784 42.1113 85.2963 42.1113C84.4143 42.1113 83.6992 42.8264 83.6992 43.7085C83.6992 44.5905 84.4143 45.3056 85.2963 45.3056Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_524",
    d: "M85.2963 48.4999C86.1784 48.4999 86.8935 47.7849 86.8935 46.9028C86.8935 46.0207 86.1784 45.3057 85.2963 45.3057C84.4143 45.3057 83.6992 46.0207 83.6992 46.9028C83.6992 47.7849 84.4143 48.4999 85.2963 48.4999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_525",
    d: "M85.2963 51.6942C86.1784 51.6942 86.8935 50.9792 86.8935 50.0971C86.8935 49.2151 86.1784 48.5 85.2963 48.5C84.4143 48.5 83.6992 49.2151 83.6992 50.0971C83.6992 50.9792 84.4143 51.6942 85.2963 51.6942Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_526",
    d: "M85.2963 58.0819C86.1784 58.0819 86.8935 57.3669 86.8935 56.4848C86.8935 55.6028 86.1784 54.8877 85.2963 54.8877C84.4143 54.8877 83.6992 55.6028 83.6992 56.4848C83.6992 57.3669 84.4143 58.0819 85.2963 58.0819Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_527",
    d: "M85.2963 61.2763C86.1784 61.2763 86.8935 60.5612 86.8935 59.6792C86.8935 58.7971 86.1784 58.082 85.2963 58.082C84.4143 58.082 83.6992 58.7971 83.6992 59.6792C83.6992 60.5612 84.4143 61.2763 85.2963 61.2763Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_528",
    d: "M85.2963 64.4706C86.1784 64.4706 86.8935 63.7556 86.8935 62.8735C86.8935 61.9914 86.1784 61.2764 85.2963 61.2764C84.4143 61.2764 83.6992 61.9914 83.6992 62.8735C83.6992 63.7556 84.4143 64.4706 85.2963 64.4706Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_529",
    d: "M85.2963 67.665C86.1784 67.665 86.8935 66.9499 86.8935 66.0678C86.8935 65.1858 86.1784 64.4707 85.2963 64.4707C84.4143 64.4707 83.6992 65.1858 83.6992 66.0678C83.6992 66.9499 84.4143 67.665 85.2963 67.665Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_530",
    d: "M85.2963 70.8593C86.1784 70.8593 86.8935 70.1442 86.8935 69.2622C86.8935 68.3801 86.1784 67.665 85.2963 67.665C84.4143 67.665 83.6992 68.3801 83.6992 69.2622C83.6992 70.1442 84.4143 70.8593 85.2963 70.8593Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_531",
    d: "M85.2963 74.0536C86.1784 74.0536 86.8935 73.3386 86.8935 72.4565C86.8935 71.5744 86.1784 70.8594 85.2963 70.8594C84.4143 70.8594 83.6992 71.5744 83.6992 72.4565C83.6992 73.3386 84.4143 74.0536 85.2963 74.0536Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_532",
    d: "M85.2963 80.4423C86.1784 80.4423 86.8935 79.7272 86.8935 78.8452C86.8935 77.9631 86.1784 77.248 85.2963 77.248C84.4143 77.248 83.6992 77.9631 83.6992 78.8452C83.6992 79.7272 84.4143 80.4423 85.2963 80.4423Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_533",
    d: "M85.2963 83.6366C86.1784 83.6366 86.8935 82.9216 86.8935 82.0395C86.8935 81.1574 86.1784 80.4424 85.2963 80.4424C84.4143 80.4424 83.6992 81.1574 83.6992 82.0395C83.6992 82.9216 84.4143 83.6366 85.2963 83.6366Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_534",
    d: "M85.2963 90.0253C86.1784 90.0253 86.8935 89.3102 86.8935 88.4282C86.8935 87.5461 86.1784 86.8311 85.2963 86.8311C84.4143 86.8311 83.6992 87.5461 83.6992 88.4282C83.6992 89.3102 84.4143 90.0253 85.2963 90.0253Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_535",
    d: "M85.2963 96.413C86.1784 96.413 86.8935 95.6979 86.8935 94.8159C86.8935 93.9338 86.1784 93.2188 85.2963 93.2188C84.4143 93.2188 83.6992 93.9338 83.6992 94.8159C83.6992 95.6979 84.4143 96.413 85.2963 96.413Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_536",
    d: "M85.2963 99.6073C86.1784 99.6073 86.8935 98.8923 86.8935 98.0102C86.8935 97.1281 86.1784 96.4131 85.2963 96.4131C84.4143 96.4131 83.6992 97.1281 83.6992 98.0102C83.6992 98.8923 84.4143 99.6073 85.2963 99.6073Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_537",
    d: "M85.2963 102.802C86.1784 102.802 86.8935 102.087 86.8935 101.205C86.8935 100.322 86.1784 99.6074 85.2963 99.6074C84.4143 99.6074 83.6992 100.322 83.6992 101.205C83.6992 102.087 84.4143 102.802 85.2963 102.802Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_538",
    d: "M85.2963 105.996C86.1784 105.996 86.8935 105.281 86.8935 104.399C86.8935 103.517 86.1784 102.802 85.2963 102.802C84.4143 102.802 83.6992 103.517 83.6992 104.399C83.6992 105.281 84.4143 105.996 85.2963 105.996Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_539",
    d: "M85.2963 109.19C86.1784 109.19 86.8935 108.475 86.8935 107.593C86.8935 106.711 86.1784 105.996 85.2963 105.996C84.4143 105.996 83.6992 106.711 83.6992 107.593C83.6992 108.475 84.4143 109.19 85.2963 109.19Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_540",
    d: "M85.2963 118.773C86.1784 118.773 86.8935 118.058 86.8935 117.176C86.8935 116.294 86.1784 115.579 85.2963 115.579C84.4143 115.579 83.6992 116.294 83.6992 117.176C83.6992 118.058 84.4143 118.773 85.2963 118.773Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_541",
    d: "M85.2963 121.968C86.1784 121.968 86.8935 121.253 86.8935 120.371C86.8935 119.488 86.1784 118.773 85.2963 118.773C84.4143 118.773 83.6992 119.488 83.6992 120.371C83.6992 121.253 84.4143 121.968 85.2963 121.968Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_542",
    d: "M85.2963 128.356C86.1784 128.356 86.8935 127.641 86.8935 126.759C86.8935 125.877 86.1784 125.162 85.2963 125.162C84.4143 125.162 83.6992 125.877 83.6992 126.759C83.6992 127.641 84.4143 128.356 85.2963 128.356Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_543",
    d: "M85.2963 131.55C86.1784 131.55 86.8935 130.835 86.8935 129.953C86.8935 129.071 86.1784 128.355 85.2963 128.355C84.4143 128.355 83.6992 129.071 83.6992 129.953C83.6992 130.835 84.4143 131.55 85.2963 131.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_544",
    d: "M85.2963 137.938C86.1784 137.938 86.8935 137.223 86.8935 136.341C86.8935 135.459 86.1784 134.744 85.2963 134.744C84.4143 134.744 83.6992 135.459 83.6992 136.341C83.6992 137.223 84.4143 137.938 85.2963 137.938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_545",
    d: "M85.2963 141.133C86.1784 141.133 86.8935 140.418 86.8935 139.536C86.8935 138.654 86.1784 137.938 85.2963 137.938C84.4143 137.938 83.6992 138.654 83.6992 139.536C83.6992 140.418 84.4143 141.133 85.2963 141.133Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_546",
    d: "M88.4897 3.78019C89.3718 3.78019 90.0868 3.06513 90.0868 2.18306C90.0868 1.30099 89.3718 0.585938 88.4897 0.585938C87.6076 0.585938 86.8926 1.30099 86.8926 2.18306C86.8926 3.06513 87.6076 3.78019 88.4897 3.78019Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_547",
    d: "M88.4897 6.97452C89.3718 6.97452 90.0868 6.25947 90.0868 5.3774C90.0868 4.49533 89.3718 3.78027 88.4897 3.78027C87.6076 3.78027 86.8926 4.49533 86.8926 5.3774C86.8926 6.25947 87.6076 6.97452 88.4897 6.97452Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_548",
    d: "M88.4897 10.1689C89.3718 10.1689 90.0868 9.4538 90.0868 8.57173C90.0868 7.68967 89.3718 6.97461 88.4897 6.97461C87.6076 6.97461 86.8926 7.68967 86.8926 8.57173C86.8926 9.4538 87.6076 10.1689 88.4897 10.1689Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_549",
    d: "M88.4897 19.7519C89.3718 19.7519 90.0868 19.0368 90.0868 18.1547C90.0868 17.2727 89.3718 16.5576 88.4897 16.5576C87.6076 16.5576 86.8926 17.2727 86.8926 18.1547C86.8926 19.0368 87.6076 19.7519 88.4897 19.7519Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_550",
    d: "M88.4897 32.5282C89.3718 32.5282 90.0868 31.8132 90.0868 30.9311C90.0868 30.049 89.3718 29.334 88.4897 29.334C87.6076 29.334 86.8926 30.049 86.8926 30.9311C86.8926 31.8132 87.6076 32.5282 88.4897 32.5282Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_551",
    d: "M88.4897 35.7226C89.3718 35.7226 90.0868 35.0075 90.0868 34.1254C90.0868 33.2434 89.3718 32.5283 88.4897 32.5283C87.6076 32.5283 86.8926 33.2434 86.8926 34.1254C86.8926 35.0075 87.6076 35.7226 88.4897 35.7226Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_552",
    d: "M88.4897 45.3056C89.3718 45.3056 90.0868 44.5905 90.0868 43.7085C90.0868 42.8264 89.3718 42.1113 88.4897 42.1113C87.6076 42.1113 86.8926 42.8264 86.8926 43.7085C86.8926 44.5905 87.6076 45.3056 88.4897 45.3056Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_553",
    d: "M88.4897 48.4999C89.3718 48.4999 90.0868 47.7849 90.0868 46.9028C90.0868 46.0207 89.3718 45.3057 88.4897 45.3057C87.6076 45.3057 86.8926 46.0207 86.8926 46.9028C86.8926 47.7849 87.6076 48.4999 88.4897 48.4999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_554",
    d: "M88.4897 54.8886C89.3718 54.8886 90.0868 54.1735 90.0868 53.2915C90.0868 52.4094 89.3718 51.6943 88.4897 51.6943C87.6076 51.6943 86.8926 52.4094 86.8926 53.2915C86.8926 54.1735 87.6076 54.8886 88.4897 54.8886Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_555",
    d: "M88.4897 70.8593C89.3718 70.8593 90.0868 70.1442 90.0868 69.2622C90.0868 68.3801 89.3718 67.665 88.4897 67.665C87.6076 67.665 86.8926 68.3801 86.8926 69.2622C86.8926 70.1442 87.6076 70.8593 88.4897 70.8593Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_556",
    d: "M88.4897 74.0536C89.3718 74.0536 90.0868 73.3386 90.0868 72.4565C90.0868 71.5744 89.3718 70.8594 88.4897 70.8594C87.6076 70.8594 86.8926 71.5744 86.8926 72.4565C86.8926 73.3386 87.6076 74.0536 88.4897 74.0536Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_557",
    d: "M88.4897 80.4423C89.3718 80.4423 90.0868 79.7272 90.0868 78.8452C90.0868 77.9631 89.3718 77.248 88.4897 77.248C87.6076 77.248 86.8926 77.9631 86.8926 78.8452C86.8926 79.7272 87.6076 80.4423 88.4897 80.4423Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_558",
    d: "M88.4897 86.831C89.3718 86.831 90.0868 86.1159 90.0868 85.2338C90.0868 84.3518 89.3718 83.6367 88.4897 83.6367C87.6076 83.6367 86.8926 84.3518 86.8926 85.2338C86.8926 86.1159 87.6076 86.831 88.4897 86.831Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_559",
    d: "M88.4897 90.0253C89.3718 90.0253 90.0868 89.3102 90.0868 88.4282C90.0868 87.5461 89.3718 86.8311 88.4897 86.8311C87.6076 86.8311 86.8926 87.5461 86.8926 88.4282C86.8926 89.3102 87.6076 90.0253 88.4897 90.0253Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_560",
    d: "M88.4897 99.6073C89.3718 99.6073 90.0868 98.8923 90.0868 98.0102C90.0868 97.1281 89.3718 96.4131 88.4897 96.4131C87.6076 96.4131 86.8926 97.1281 86.8926 98.0102C86.8926 98.8923 87.6076 99.6073 88.4897 99.6073Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_561",
    d: "M88.4897 105.996C89.3718 105.996 90.0868 105.281 90.0868 104.399C90.0868 103.517 89.3718 102.802 88.4897 102.802C87.6076 102.802 86.8926 103.517 86.8926 104.399C86.8926 105.281 87.6076 105.996 88.4897 105.996Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_562",
    d: "M88.4897 118.773C89.3718 118.773 90.0868 118.058 90.0868 117.176C90.0868 116.294 89.3718 115.579 88.4897 115.579C87.6076 115.579 86.8926 116.294 86.8926 117.176C86.8926 118.058 87.6076 118.773 88.4897 118.773Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_563",
    d: "M88.4897 125.162C89.3718 125.162 90.0868 124.447 90.0868 123.565C90.0868 122.683 89.3718 121.968 88.4897 121.968C87.6076 121.968 86.8926 122.683 86.8926 123.565C86.8926 124.447 87.6076 125.162 88.4897 125.162Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_564",
    d: "M88.4897 131.55C89.3718 131.55 90.0868 130.835 90.0868 129.953C90.0868 129.071 89.3718 128.355 88.4897 128.355C87.6076 128.355 86.8926 129.071 86.8926 129.953C86.8926 130.835 87.6076 131.55 88.4897 131.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_565",
    d: "M91.685 3.78019C92.5671 3.78019 93.2821 3.06513 93.2821 2.18306C93.2821 1.30099 92.5671 0.585938 91.685 0.585938C90.8029 0.585938 90.0879 1.30099 90.0879 2.18306C90.0879 3.06513 90.8029 3.78019 91.685 3.78019Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_566",
    d: "M91.685 22.9452C92.5671 22.9452 93.2821 22.2302 93.2821 21.3481C93.2821 20.466 92.5671 19.751 91.685 19.751C90.8029 19.751 90.0879 20.466 90.0879 21.3481C90.0879 22.2302 90.8029 22.9452 91.685 22.9452Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_567",
    d: "M91.685 26.1396C92.5671 26.1396 93.2821 25.4245 93.2821 24.5424C93.2821 23.6604 92.5671 22.9453 91.685 22.9453C90.8029 22.9453 90.0879 23.6604 90.0879 24.5424C90.0879 25.4245 90.8029 26.1396 91.685 26.1396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_568",
    d: "M91.685 35.7226C92.5671 35.7226 93.2821 35.0075 93.2821 34.1254C93.2821 33.2434 92.5671 32.5283 91.685 32.5283C90.8029 32.5283 90.0879 33.2434 90.0879 34.1254C90.0879 35.0075 90.8029 35.7226 91.685 35.7226Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_569",
    d: "M91.685 38.9169C92.5671 38.9169 93.2821 38.2018 93.2821 37.3198C93.2821 36.4377 92.5671 35.7227 91.685 35.7227C90.8029 35.7227 90.0879 36.4377 90.0879 37.3198C90.0879 38.2018 90.8029 38.9169 91.685 38.9169Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_570",
    d: "M91.685 42.1112C92.5671 42.1112 93.2821 41.3962 93.2821 40.5141C93.2821 39.632 92.5671 38.917 91.685 38.917C90.8029 38.917 90.0879 39.632 90.0879 40.5141C90.0879 41.3962 90.8029 42.1112 91.685 42.1112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_571",
    d: "M91.685 48.4999C92.5671 48.4999 93.2821 47.7849 93.2821 46.9028C93.2821 46.0207 92.5671 45.3057 91.685 45.3057C90.8029 45.3057 90.0879 46.0207 90.0879 46.9028C90.0879 47.7849 90.8029 48.4999 91.685 48.4999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_572",
    d: "M91.685 51.6942C92.5671 51.6942 93.2821 50.9792 93.2821 50.0971C93.2821 49.2151 92.5671 48.5 91.685 48.5C90.8029 48.5 90.0879 49.2151 90.0879 50.0971C90.0879 50.9792 90.8029 51.6942 91.685 51.6942Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_573",
    d: "M91.685 54.8886C92.5671 54.8886 93.2821 54.1735 93.2821 53.2915C93.2821 52.4094 92.5671 51.6943 91.685 51.6943C90.8029 51.6943 90.0879 52.4094 90.0879 53.2915C90.0879 54.1735 90.8029 54.8886 91.685 54.8886Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_574",
    d: "M91.685 61.2763C92.5671 61.2763 93.2821 60.5612 93.2821 59.6792C93.2821 58.7971 92.5671 58.082 91.685 58.082C90.8029 58.082 90.0879 58.7971 90.0879 59.6792C90.0879 60.5612 90.8029 61.2763 91.685 61.2763Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_575",
    d: "M91.685 64.4706C92.5671 64.4706 93.2821 63.7556 93.2821 62.8735C93.2821 61.9914 92.5671 61.2764 91.685 61.2764C90.8029 61.2764 90.0879 61.9914 90.0879 62.8735C90.0879 63.7556 90.8029 64.4706 91.685 64.4706Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_576",
    d: "M91.685 67.665C92.5671 67.665 93.2821 66.9499 93.2821 66.0678C93.2821 65.1858 92.5671 64.4707 91.685 64.4707C90.8029 64.4707 90.0879 65.1858 90.0879 66.0678C90.0879 66.9499 90.8029 67.665 91.685 67.665Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_577",
    d: "M91.685 70.8593C92.5671 70.8593 93.2821 70.1442 93.2821 69.2622C93.2821 68.3801 92.5671 67.665 91.685 67.665C90.8029 67.665 90.0879 68.3801 90.0879 69.2622C90.0879 70.1442 90.8029 70.8593 91.685 70.8593Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_578",
    d: "M91.685 77.248C92.5671 77.248 93.2821 76.5329 93.2821 75.6508C93.2821 74.7688 92.5671 74.0537 91.685 74.0537C90.8029 74.0537 90.0879 74.7688 90.0879 75.6508C90.0879 76.5329 90.8029 77.248 91.685 77.248Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_579",
    d: "M91.685 80.4423C92.5671 80.4423 93.2821 79.7272 93.2821 78.8452C93.2821 77.9631 92.5671 77.248 91.685 77.248C90.8029 77.248 90.0879 77.9631 90.0879 78.8452C90.0879 79.7272 90.8029 80.4423 91.685 80.4423Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_580",
    d: "M91.685 86.831C92.5671 86.831 93.2821 86.1159 93.2821 85.2338C93.2821 84.3518 92.5671 83.6367 91.685 83.6367C90.8029 83.6367 90.0879 84.3518 90.0879 85.2338C90.0879 86.1159 90.8029 86.831 91.685 86.831Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_581",
    d: "M91.685 90.0253C92.5671 90.0253 93.2821 89.3102 93.2821 88.4282C93.2821 87.5461 92.5671 86.8311 91.685 86.8311C90.8029 86.8311 90.0879 87.5461 90.0879 88.4282C90.0879 89.3102 90.8029 90.0253 91.685 90.0253Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_582",
    d: "M91.685 96.413C92.5671 96.413 93.2821 95.6979 93.2821 94.8159C93.2821 93.9338 92.5671 93.2188 91.685 93.2188C90.8029 93.2188 90.0879 93.9338 90.0879 94.8159C90.0879 95.6979 90.8029 96.413 91.685 96.413Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_583",
    d: "M91.685 102.802C92.5671 102.802 93.2821 102.087 93.2821 101.205C93.2821 100.322 92.5671 99.6074 91.685 99.6074C90.8029 99.6074 90.0879 100.322 90.0879 101.205C90.0879 102.087 90.8029 102.802 91.685 102.802Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_584",
    d: "M91.685 105.996C92.5671 105.996 93.2821 105.281 93.2821 104.399C93.2821 103.517 92.5671 102.802 91.685 102.802C90.8029 102.802 90.0879 103.517 90.0879 104.399C90.0879 105.281 90.8029 105.996 91.685 105.996Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_585",
    d: "M91.685 109.19C92.5671 109.19 93.2821 108.475 93.2821 107.593C93.2821 106.711 92.5671 105.996 91.685 105.996C90.8029 105.996 90.0879 106.711 90.0879 107.593C90.0879 108.475 90.8029 109.19 91.685 109.19Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_586",
    d: "M91.685 131.55C92.5671 131.55 93.2821 130.835 93.2821 129.953C93.2821 129.071 92.5671 128.355 91.685 128.355C90.8029 128.355 90.0879 129.071 90.0879 129.953C90.0879 130.835 90.8029 131.55 91.685 131.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_587",
    d: "M91.685 144.327C92.5671 144.327 93.2821 143.612 93.2821 142.73C93.2821 141.848 92.5671 141.133 91.685 141.133C90.8029 141.133 90.0879 141.848 90.0879 142.73C90.0879 143.612 90.8029 144.327 91.685 144.327Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_588",
    d: "M94.8784 6.97452C95.7604 6.97452 96.4755 6.25947 96.4755 5.3774C96.4755 4.49533 95.7604 3.78027 94.8784 3.78027C93.9963 3.78027 93.2812 4.49533 93.2812 5.3774C93.2812 6.25947 93.9963 6.97452 94.8784 6.97452Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_589",
    d: "M94.8784 10.1689C95.7604 10.1689 96.4755 9.4538 96.4755 8.57173C96.4755 7.68967 95.7604 6.97461 94.8784 6.97461C93.9963 6.97461 93.2812 7.68967 93.2812 8.57173C93.2812 9.4538 93.9963 10.1689 94.8784 10.1689Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_590",
    d: "M94.8784 16.5575C95.7604 16.5575 96.4755 15.8425 96.4755 14.9604C96.4755 14.0783 95.7604 13.3633 94.8784 13.3633C93.9963 13.3633 93.2812 14.0783 93.2812 14.9604C93.2812 15.8425 93.9963 16.5575 94.8784 16.5575Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_591",
    d: "M94.8784 32.5282C95.7604 32.5282 96.4755 31.8132 96.4755 30.9311C96.4755 30.049 95.7604 29.334 94.8784 29.334C93.9963 29.334 93.2812 30.049 93.2812 30.9311C93.2812 31.8132 93.9963 32.5282 94.8784 32.5282Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_592",
    d: "M94.8784 35.7226C95.7604 35.7226 96.4755 35.0075 96.4755 34.1254C96.4755 33.2434 95.7604 32.5283 94.8784 32.5283C93.9963 32.5283 93.2812 33.2434 93.2812 34.1254C93.2812 35.0075 93.9963 35.7226 94.8784 35.7226Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_593",
    d: "M94.8784 38.9169C95.7604 38.9169 96.4755 38.2018 96.4755 37.3198C96.4755 36.4377 95.7604 35.7227 94.8784 35.7227C93.9963 35.7227 93.2812 36.4377 93.2812 37.3198C93.2812 38.2018 93.9963 38.9169 94.8784 38.9169Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_594",
    d: "M94.8784 51.6942C95.7604 51.6942 96.4755 50.9792 96.4755 50.0971C96.4755 49.2151 95.7604 48.5 94.8784 48.5C93.9963 48.5 93.2812 49.2151 93.2812 50.0971C93.2812 50.9792 93.9963 51.6942 94.8784 51.6942Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_595",
    d: "M94.8784 54.8886C95.7604 54.8886 96.4755 54.1735 96.4755 53.2915C96.4755 52.4094 95.7604 51.6943 94.8784 51.6943C93.9963 51.6943 93.2812 52.4094 93.2812 53.2915C93.2812 54.1735 93.9963 54.8886 94.8784 54.8886Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_596",
    d: "M94.8784 64.4706C95.7604 64.4706 96.4755 63.7556 96.4755 62.8735C96.4755 61.9914 95.7604 61.2764 94.8784 61.2764C93.9963 61.2764 93.2812 61.9914 93.2812 62.8735C93.2812 63.7556 93.9963 64.4706 94.8784 64.4706Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_597",
    d: "M94.8784 77.248C95.7604 77.248 96.4755 76.5329 96.4755 75.6508C96.4755 74.7688 95.7604 74.0537 94.8784 74.0537C93.9963 74.0537 93.2812 74.7688 93.2812 75.6508C93.2812 76.5329 93.9963 77.248 94.8784 77.248Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_598",
    d: "M94.8784 83.6366C95.7604 83.6366 96.4755 82.9216 96.4755 82.0395C96.4755 81.1574 95.7604 80.4424 94.8784 80.4424C93.9963 80.4424 93.2812 81.1574 93.2812 82.0395C93.2812 82.9216 93.9963 83.6366 94.8784 83.6366Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_599",
    d: "M94.8784 86.831C95.7604 86.831 96.4755 86.1159 96.4755 85.2338C96.4755 84.3518 95.7604 83.6367 94.8784 83.6367C93.9963 83.6367 93.2812 84.3518 93.2812 85.2338C93.2812 86.1159 93.9963 86.831 94.8784 86.831Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_600",
    d: "M94.8784 90.0253C95.7604 90.0253 96.4755 89.3102 96.4755 88.4282C96.4755 87.5461 95.7604 86.8311 94.8784 86.8311C93.9963 86.8311 93.2812 87.5461 93.2812 88.4282C93.2812 89.3102 93.9963 90.0253 94.8784 90.0253Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_601",
    d: "M94.8784 96.413C95.7604 96.413 96.4755 95.6979 96.4755 94.8159C96.4755 93.9338 95.7604 93.2188 94.8784 93.2188C93.9963 93.2188 93.2812 93.9338 93.2812 94.8159C93.2812 95.6979 93.9963 96.413 94.8784 96.413Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_602",
    d: "M94.8784 99.6073C95.7604 99.6073 96.4755 98.8923 96.4755 98.0102C96.4755 97.1281 95.7604 96.4131 94.8784 96.4131C93.9963 96.4131 93.2812 97.1281 93.2812 98.0102C93.2812 98.8923 93.9963 99.6073 94.8784 99.6073Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_603",
    d: "M94.8784 105.996C95.7604 105.996 96.4755 105.281 96.4755 104.399C96.4755 103.517 95.7604 102.802 94.8784 102.802C93.9963 102.802 93.2812 103.517 93.2812 104.399C93.2812 105.281 93.9963 105.996 94.8784 105.996Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_604",
    d: "M94.8784 121.968C95.7604 121.968 96.4755 121.253 96.4755 120.371C96.4755 119.488 95.7604 118.773 94.8784 118.773C93.9963 118.773 93.2812 119.488 93.2812 120.371C93.2812 121.253 93.9963 121.968 94.8784 121.968Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_605",
    d: "M94.8784 128.356C95.7604 128.356 96.4755 127.641 96.4755 126.759C96.4755 125.877 95.7604 125.162 94.8784 125.162C93.9963 125.162 93.2812 125.877 93.2812 126.759C93.2812 127.641 93.9963 128.356 94.8784 128.356Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_606",
    d: "M94.8784 134.744C95.7604 134.744 96.4755 134.029 96.4755 133.147C96.4755 132.265 95.7604 131.55 94.8784 131.55C93.9963 131.55 93.2812 132.265 93.2812 133.147C93.2812 134.029 93.9963 134.744 94.8784 134.744Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_607",
    d: "M94.8784 137.938C95.7604 137.938 96.4755 137.223 96.4755 136.341C96.4755 135.459 95.7604 134.744 94.8784 134.744C93.9963 134.744 93.2812 135.459 93.2812 136.341C93.2812 137.223 93.9963 137.938 94.8784 137.938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_608",
    d: "M98.0737 19.7519C98.9558 19.7519 99.6708 19.0368 99.6708 18.1547C99.6708 17.2727 98.9558 16.5576 98.0737 16.5576C97.1916 16.5576 96.4766 17.2727 96.4766 18.1547C96.4766 19.0368 97.1916 19.7519 98.0737 19.7519Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_609",
    d: "M98.0737 22.9452C98.9558 22.9452 99.6708 22.2302 99.6708 21.3481C99.6708 20.466 98.9558 19.751 98.0737 19.751C97.1916 19.751 96.4766 20.466 96.4766 21.3481C96.4766 22.2302 97.1916 22.9452 98.0737 22.9452Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_610",
    d: "M98.0737 26.1396C98.9558 26.1396 99.6708 25.4245 99.6708 24.5424C99.6708 23.6604 98.9558 22.9453 98.0737 22.9453C97.1916 22.9453 96.4766 23.6604 96.4766 24.5424C96.4766 25.4245 97.1916 26.1396 98.0737 26.1396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_611",
    d: "M98.0737 35.7226C98.9558 35.7226 99.6708 35.0075 99.6708 34.1254C99.6708 33.2434 98.9558 32.5283 98.0737 32.5283C97.1916 32.5283 96.4766 33.2434 96.4766 34.1254C96.4766 35.0075 97.1916 35.7226 98.0737 35.7226Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_612",
    d: "M98.0737 42.1112C98.9558 42.1112 99.6708 41.3962 99.6708 40.5141C99.6708 39.632 98.9558 38.917 98.0737 38.917C97.1916 38.917 96.4766 39.632 96.4766 40.5141C96.4766 41.3962 97.1916 42.1112 98.0737 42.1112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_613",
    d: "M98.0737 51.6942C98.9558 51.6942 99.6708 50.9792 99.6708 50.0971C99.6708 49.2151 98.9558 48.5 98.0737 48.5C97.1916 48.5 96.4766 49.2151 96.4766 50.0971C96.4766 50.9792 97.1916 51.6942 98.0737 51.6942Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_614",
    d: "M98.0737 61.2763C98.9558 61.2763 99.6708 60.5612 99.6708 59.6792C99.6708 58.7971 98.9558 58.082 98.0737 58.082C97.1916 58.082 96.4766 58.7971 96.4766 59.6792C96.4766 60.5612 97.1916 61.2763 98.0737 61.2763Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_615",
    d: "M98.0737 64.4706C98.9558 64.4706 99.6708 63.7556 99.6708 62.8735C99.6708 61.9914 98.9558 61.2764 98.0737 61.2764C97.1916 61.2764 96.4766 61.9914 96.4766 62.8735C96.4766 63.7556 97.1916 64.4706 98.0737 64.4706Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_616",
    d: "M98.0737 67.665C98.9558 67.665 99.6708 66.9499 99.6708 66.0678C99.6708 65.1858 98.9558 64.4707 98.0737 64.4707C97.1916 64.4707 96.4766 65.1858 96.4766 66.0678C96.4766 66.9499 97.1916 67.665 98.0737 67.665Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_617",
    d: "M98.0737 80.4423C98.9558 80.4423 99.6708 79.7272 99.6708 78.8452C99.6708 77.9631 98.9558 77.248 98.0737 77.248C97.1916 77.248 96.4766 77.9631 96.4766 78.8452C96.4766 79.7272 97.1916 80.4423 98.0737 80.4423Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_618",
    d: "M98.0737 83.6366C98.9558 83.6366 99.6708 82.9216 99.6708 82.0395C99.6708 81.1574 98.9558 80.4424 98.0737 80.4424C97.1916 80.4424 96.4766 81.1574 96.4766 82.0395C96.4766 82.9216 97.1916 83.6366 98.0737 83.6366Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_619",
    d: "M98.0737 90.0253C98.9558 90.0253 99.6708 89.3102 99.6708 88.4282C99.6708 87.5461 98.9558 86.8311 98.0737 86.8311C97.1916 86.8311 96.4766 87.5461 96.4766 88.4282C96.4766 89.3102 97.1916 90.0253 98.0737 90.0253Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_620",
    d: "M98.0737 93.2187C98.9558 93.2187 99.6708 92.5036 99.6708 91.6215C99.6708 90.7395 98.9558 90.0244 98.0737 90.0244C97.1916 90.0244 96.4766 90.7395 96.4766 91.6215C96.4766 92.5036 97.1916 93.2187 98.0737 93.2187Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_621",
    d: "M98.0737 99.6073C98.9558 99.6073 99.6708 98.8923 99.6708 98.0102C99.6708 97.1281 98.9558 96.4131 98.0737 96.4131C97.1916 96.4131 96.4766 97.1281 96.4766 98.0102C96.4766 98.8923 97.1916 99.6073 98.0737 99.6073Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_622",
    d: "M98.0737 102.802C98.9558 102.802 99.6708 102.087 99.6708 101.205C99.6708 100.322 98.9558 99.6074 98.0737 99.6074C97.1916 99.6074 96.4766 100.322 96.4766 101.205C96.4766 102.087 97.1916 102.802 98.0737 102.802Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_623",
    d: "M98.0737 109.19C98.9558 109.19 99.6708 108.475 99.6708 107.593C99.6708 106.711 98.9558 105.996 98.0737 105.996C97.1916 105.996 96.4766 106.711 96.4766 107.593C96.4766 108.475 97.1916 109.19 98.0737 109.19Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_624",
    d: "M98.0737 115.579C98.9558 115.579 99.6708 114.864 99.6708 113.982C99.6708 113.1 98.9558 112.385 98.0737 112.385C97.1916 112.385 96.4766 113.1 96.4766 113.982C96.4766 114.864 97.1916 115.579 98.0737 115.579Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_625",
    d: "M98.0737 121.968C98.9558 121.968 99.6708 121.253 99.6708 120.371C99.6708 119.488 98.9558 118.773 98.0737 118.773C97.1916 118.773 96.4766 119.488 96.4766 120.371C96.4766 121.253 97.1916 121.968 98.0737 121.968Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_626",
    d: "M101.267 3.78019C102.149 3.78019 102.864 3.06513 102.864 2.18306C102.864 1.30099 102.149 0.585938 101.267 0.585938C100.385 0.585938 99.6699 1.30099 99.6699 2.18306C99.6699 3.06513 100.385 3.78019 101.267 3.78019Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_627",
    d: "M101.267 6.97452C102.149 6.97452 102.864 6.25947 102.864 5.3774C102.864 4.49533 102.149 3.78027 101.267 3.78027C100.385 3.78027 99.6699 4.49533 99.6699 5.3774C99.6699 6.25947 100.385 6.97452 101.267 6.97452Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_628",
    d: "M101.267 13.3632C102.149 13.3632 102.864 12.6481 102.864 11.7661C102.864 10.884 102.149 10.1689 101.267 10.1689C100.385 10.1689 99.6699 10.884 99.6699 11.7661C99.6699 12.6481 100.385 13.3632 101.267 13.3632Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_629",
    d: "M101.267 19.7519C102.149 19.7519 102.864 19.0368 102.864 18.1547C102.864 17.2727 102.149 16.5576 101.267 16.5576C100.385 16.5576 99.6699 17.2727 99.6699 18.1547C99.6699 19.0368 100.385 19.7519 101.267 19.7519Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_630",
    d: "M101.267 26.1396C102.149 26.1396 102.864 25.4245 102.864 24.5424C102.864 23.6604 102.149 22.9453 101.267 22.9453C100.385 22.9453 99.6699 23.6604 99.6699 24.5424C99.6699 25.4245 100.385 26.1396 101.267 26.1396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_631",
    d: "M101.267 32.5282C102.149 32.5282 102.864 31.8132 102.864 30.9311C102.864 30.049 102.149 29.334 101.267 29.334C100.385 29.334 99.6699 30.049 99.6699 30.9311C99.6699 31.8132 100.385 32.5282 101.267 32.5282Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_632",
    d: "M101.267 38.9169C102.149 38.9169 102.864 38.2018 102.864 37.3198C102.864 36.4377 102.149 35.7227 101.267 35.7227C100.385 35.7227 99.6699 36.4377 99.6699 37.3198C99.6699 38.2018 100.385 38.9169 101.267 38.9169Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_633",
    d: "M101.267 54.8886C102.149 54.8886 102.864 54.1735 102.864 53.2915C102.864 52.4094 102.149 51.6943 101.267 51.6943C100.385 51.6943 99.6699 52.4094 99.6699 53.2915C99.6699 54.1735 100.385 54.8886 101.267 54.8886Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_634",
    d: "M101.267 64.4706C102.149 64.4706 102.864 63.7556 102.864 62.8735C102.864 61.9914 102.149 61.2764 101.267 61.2764C100.385 61.2764 99.6699 61.9914 99.6699 62.8735C99.6699 63.7556 100.385 64.4706 101.267 64.4706Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_635",
    d: "M101.267 70.8593C102.149 70.8593 102.864 70.1442 102.864 69.2622C102.864 68.3801 102.149 67.665 101.267 67.665C100.385 67.665 99.6699 68.3801 99.6699 69.2622C99.6699 70.1442 100.385 70.8593 101.267 70.8593Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_636",
    d: "M101.267 77.248C102.149 77.248 102.864 76.5329 102.864 75.6508C102.864 74.7688 102.149 74.0537 101.267 74.0537C100.385 74.0537 99.6699 74.7688 99.6699 75.6508C99.6699 76.5329 100.385 77.248 101.267 77.248Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_637",
    d: "M101.267 83.6366C102.149 83.6366 102.864 82.9216 102.864 82.0395C102.864 81.1574 102.149 80.4424 101.267 80.4424C100.385 80.4424 99.6699 81.1574 99.6699 82.0395C99.6699 82.9216 100.385 83.6366 101.267 83.6366Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_638",
    d: "M101.267 90.0253C102.149 90.0253 102.864 89.3102 102.864 88.4282C102.864 87.5461 102.149 86.8311 101.267 86.8311C100.385 86.8311 99.6699 87.5461 99.6699 88.4282C99.6699 89.3102 100.385 90.0253 101.267 90.0253Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_639",
    d: "M101.267 105.996C102.149 105.996 102.864 105.281 102.864 104.399C102.864 103.517 102.149 102.802 101.267 102.802C100.385 102.802 99.6699 103.517 99.6699 104.399C99.6699 105.281 100.385 105.996 101.267 105.996Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_640",
    d: "M101.267 112.385C102.149 112.385 102.864 111.67 102.864 110.788C102.864 109.905 102.149 109.19 101.267 109.19C100.385 109.19 99.6699 109.905 99.6699 110.788C99.6699 111.67 100.385 112.385 101.267 112.385Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_641",
    d: "M101.267 118.773C102.149 118.773 102.864 118.058 102.864 117.176C102.864 116.294 102.149 115.579 101.267 115.579C100.385 115.579 99.6699 116.294 99.6699 117.176C99.6699 118.058 100.385 118.773 101.267 118.773Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_642",
    d: "M101.267 125.162C102.149 125.162 102.864 124.447 102.864 123.565C102.864 122.683 102.149 121.968 101.267 121.968C100.385 121.968 99.6699 122.683 99.6699 123.565C99.6699 124.447 100.385 125.162 101.267 125.162Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_643",
    d: "M101.267 134.744C102.149 134.744 102.864 134.029 102.864 133.147C102.864 132.265 102.149 131.55 101.267 131.55C100.385 131.55 99.6699 132.265 99.6699 133.147C99.6699 134.029 100.385 134.744 101.267 134.744Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_644",
    d: "M101.267 141.133C102.149 141.133 102.864 140.418 102.864 139.536C102.864 138.654 102.149 137.938 101.267 137.938C100.385 137.938 99.6699 138.654 99.6699 139.536C99.6699 140.418 100.385 141.133 101.267 141.133Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_645",
    d: "M101.267 144.327C102.149 144.327 102.864 143.612 102.864 142.73C102.864 141.848 102.149 141.133 101.267 141.133C100.385 141.133 99.6699 141.848 99.6699 142.73C99.6699 143.612 100.385 144.327 101.267 144.327Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_646",
    d: "M104.462 3.78019C105.344 3.78019 106.059 3.06513 106.059 2.18306C106.059 1.30099 105.344 0.585938 104.462 0.585938C103.58 0.585938 102.865 1.30099 102.865 2.18306C102.865 3.06513 103.58 3.78019 104.462 3.78019Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_647",
    d: "M104.462 6.97452C105.344 6.97452 106.059 6.25947 106.059 5.3774C106.059 4.49533 105.344 3.78027 104.462 3.78027C103.58 3.78027 102.865 4.49533 102.865 5.3774C102.865 6.25947 103.58 6.97452 104.462 6.97452Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_648",
    d: "M104.462 10.1689C105.344 10.1689 106.059 9.4538 106.059 8.57173C106.059 7.68967 105.344 6.97461 104.462 6.97461C103.58 6.97461 102.865 7.68967 102.865 8.57173C102.865 9.4538 103.58 10.1689 104.462 10.1689Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_649",
    d: "M104.462 22.9452C105.344 22.9452 106.059 22.2302 106.059 21.3481C106.059 20.466 105.344 19.751 104.462 19.751C103.58 19.751 102.865 20.466 102.865 21.3481C102.865 22.2302 103.58 22.9452 104.462 22.9452Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_650",
    d: "M104.462 29.3339C105.344 29.3339 106.059 28.6188 106.059 27.7368C106.059 26.8547 105.344 26.1396 104.462 26.1396C103.58 26.1396 102.865 26.8547 102.865 27.7368C102.865 28.6188 103.58 29.3339 104.462 29.3339Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_651",
    d: "M104.462 32.5282C105.344 32.5282 106.059 31.8132 106.059 30.9311C106.059 30.049 105.344 29.334 104.462 29.334C103.58 29.334 102.865 30.049 102.865 30.9311C102.865 31.8132 103.58 32.5282 104.462 32.5282Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_652",
    d: "M104.462 35.7226C105.344 35.7226 106.059 35.0075 106.059 34.1254C106.059 33.2434 105.344 32.5283 104.462 32.5283C103.58 32.5283 102.865 33.2434 102.865 34.1254C102.865 35.0075 103.58 35.7226 104.462 35.7226Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_653",
    d: "M104.462 38.9169C105.344 38.9169 106.059 38.2018 106.059 37.3198C106.059 36.4377 105.344 35.7227 104.462 35.7227C103.58 35.7227 102.865 36.4377 102.865 37.3198C102.865 38.2018 103.58 38.9169 104.462 38.9169Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_654",
    d: "M104.462 42.1112C105.344 42.1112 106.059 41.3962 106.059 40.5141C106.059 39.632 105.344 38.917 104.462 38.917C103.58 38.917 102.865 39.632 102.865 40.5141C102.865 41.3962 103.58 42.1112 104.462 42.1112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_655",
    d: "M104.462 48.4999C105.344 48.4999 106.059 47.7849 106.059 46.9028C106.059 46.0207 105.344 45.3057 104.462 45.3057C103.58 45.3057 102.865 46.0207 102.865 46.9028C102.865 47.7849 103.58 48.4999 104.462 48.4999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_656",
    d: "M104.462 58.0819C105.344 58.0819 106.059 57.3669 106.059 56.4848C106.059 55.6028 105.344 54.8877 104.462 54.8877C103.58 54.8877 102.865 55.6028 102.865 56.4848C102.865 57.3669 103.58 58.0819 104.462 58.0819Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_657",
    d: "M104.462 67.665C105.344 67.665 106.059 66.9499 106.059 66.0678C106.059 65.1858 105.344 64.4707 104.462 64.4707C103.58 64.4707 102.865 65.1858 102.865 66.0678C102.865 66.9499 103.58 67.665 104.462 67.665Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_658",
    d: "M104.462 70.8593C105.344 70.8593 106.059 70.1442 106.059 69.2622C106.059 68.3801 105.344 67.665 104.462 67.665C103.58 67.665 102.865 68.3801 102.865 69.2622C102.865 70.1442 103.58 70.8593 104.462 70.8593Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_659",
    d: "M104.462 77.248C105.344 77.248 106.059 76.5329 106.059 75.6508C106.059 74.7688 105.344 74.0537 104.462 74.0537C103.58 74.0537 102.865 74.7688 102.865 75.6508C102.865 76.5329 103.58 77.248 104.462 77.248Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_660",
    d: "M104.462 80.4423C105.344 80.4423 106.059 79.7272 106.059 78.8452C106.059 77.9631 105.344 77.248 104.462 77.248C103.58 77.248 102.865 77.9631 102.865 78.8452C102.865 79.7272 103.58 80.4423 104.462 80.4423Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_661",
    d: "M104.462 86.831C105.344 86.831 106.059 86.1159 106.059 85.2338C106.059 84.3518 105.344 83.6367 104.462 83.6367C103.58 83.6367 102.865 84.3518 102.865 85.2338C102.865 86.1159 103.58 86.831 104.462 86.831Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_662",
    d: "M104.462 90.0253C105.344 90.0253 106.059 89.3102 106.059 88.4282C106.059 87.5461 105.344 86.8311 104.462 86.8311C103.58 86.8311 102.865 87.5461 102.865 88.4282C102.865 89.3102 103.58 90.0253 104.462 90.0253Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_663",
    d: "M104.462 99.6073C105.344 99.6073 106.059 98.8923 106.059 98.0102C106.059 97.1281 105.344 96.4131 104.462 96.4131C103.58 96.4131 102.865 97.1281 102.865 98.0102C102.865 98.8923 103.58 99.6073 104.462 99.6073Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_664",
    d: "M104.462 105.996C105.344 105.996 106.059 105.281 106.059 104.399C106.059 103.517 105.344 102.802 104.462 102.802C103.58 102.802 102.865 103.517 102.865 104.399C102.865 105.281 103.58 105.996 104.462 105.996Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_665",
    d: "M104.462 109.19C105.344 109.19 106.059 108.475 106.059 107.593C106.059 106.711 105.344 105.996 104.462 105.996C103.58 105.996 102.865 106.711 102.865 107.593C102.865 108.475 103.58 109.19 104.462 109.19Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_666",
    d: "M104.462 125.162C105.344 125.162 106.059 124.447 106.059 123.565C106.059 122.683 105.344 121.968 104.462 121.968C103.58 121.968 102.865 122.683 102.865 123.565C102.865 124.447 103.58 125.162 104.462 125.162Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_667",
    d: "M104.462 131.55C105.344 131.55 106.059 130.835 106.059 129.953C106.059 129.071 105.344 128.355 104.462 128.355C103.58 128.355 102.865 129.071 102.865 129.953C102.865 130.835 103.58 131.55 104.462 131.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_668",
    d: "M104.462 141.133C105.344 141.133 106.059 140.418 106.059 139.536C106.059 138.654 105.344 137.938 104.462 137.938C103.58 137.938 102.865 138.654 102.865 139.536C102.865 140.418 103.58 141.133 104.462 141.133Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_669",
    d: "M104.462 144.327C105.344 144.327 106.059 143.612 106.059 142.73C106.059 141.848 105.344 141.133 104.462 141.133C103.58 141.133 102.865 141.848 102.865 142.73C102.865 143.612 103.58 144.327 104.462 144.327Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_670",
    d: "M107.656 3.78019C108.538 3.78019 109.253 3.06513 109.253 2.18306C109.253 1.30099 108.538 0.585938 107.656 0.585938C106.774 0.585938 106.059 1.30099 106.059 2.18306C106.059 3.06513 106.774 3.78019 107.656 3.78019Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_671",
    d: "M107.656 6.97452C108.538 6.97452 109.253 6.25947 109.253 5.3774C109.253 4.49533 108.538 3.78027 107.656 3.78027C106.774 3.78027 106.059 4.49533 106.059 5.3774C106.059 6.25947 106.774 6.97452 107.656 6.97452Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_672",
    d: "M107.656 13.3632C108.538 13.3632 109.253 12.6481 109.253 11.7661C109.253 10.884 108.538 10.1689 107.656 10.1689C106.774 10.1689 106.059 10.884 106.059 11.7661C106.059 12.6481 106.774 13.3632 107.656 13.3632Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_673",
    d: "M107.656 19.7519C108.538 19.7519 109.253 19.0368 109.253 18.1547C109.253 17.2727 108.538 16.5576 107.656 16.5576C106.774 16.5576 106.059 17.2727 106.059 18.1547C106.059 19.0368 106.774 19.7519 107.656 19.7519Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_674",
    d: "M107.656 26.1396C108.538 26.1396 109.253 25.4245 109.253 24.5424C109.253 23.6604 108.538 22.9453 107.656 22.9453C106.774 22.9453 106.059 23.6604 106.059 24.5424C106.059 25.4245 106.774 26.1396 107.656 26.1396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_675",
    d: "M107.656 29.3339C108.538 29.3339 109.253 28.6188 109.253 27.7368C109.253 26.8547 108.538 26.1396 107.656 26.1396C106.774 26.1396 106.059 26.8547 106.059 27.7368C106.059 28.6188 106.774 29.3339 107.656 29.3339Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_676",
    d: "M107.656 35.7226C108.538 35.7226 109.253 35.0075 109.253 34.1254C109.253 33.2434 108.538 32.5283 107.656 32.5283C106.774 32.5283 106.059 33.2434 106.059 34.1254C106.059 35.0075 106.774 35.7226 107.656 35.7226Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_677",
    d: "M107.656 38.9169C108.538 38.9169 109.253 38.2018 109.253 37.3198C109.253 36.4377 108.538 35.7227 107.656 35.7227C106.774 35.7227 106.059 36.4377 106.059 37.3198C106.059 38.2018 106.774 38.9169 107.656 38.9169Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_678",
    d: "M107.656 54.8886C108.538 54.8886 109.253 54.1735 109.253 53.2915C109.253 52.4094 108.538 51.6943 107.656 51.6943C106.774 51.6943 106.059 52.4094 106.059 53.2915C106.059 54.1735 106.774 54.8886 107.656 54.8886Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_679",
    d: "M107.656 61.2763C108.538 61.2763 109.253 60.5612 109.253 59.6792C109.253 58.7971 108.538 58.082 107.656 58.082C106.774 58.082 106.059 58.7971 106.059 59.6792C106.059 60.5612 106.774 61.2763 107.656 61.2763Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_680",
    d: "M107.656 64.4706C108.538 64.4706 109.253 63.7556 109.253 62.8735C109.253 61.9914 108.538 61.2764 107.656 61.2764C106.774 61.2764 106.059 61.9914 106.059 62.8735C106.059 63.7556 106.774 64.4706 107.656 64.4706Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_681",
    d: "M107.656 74.0536C108.538 74.0536 109.253 73.3386 109.253 72.4565C109.253 71.5744 108.538 70.8594 107.656 70.8594C106.774 70.8594 106.059 71.5744 106.059 72.4565C106.059 73.3386 106.774 74.0536 107.656 74.0536Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_682",
    d: "M107.656 77.248C108.538 77.248 109.253 76.5329 109.253 75.6508C109.253 74.7688 108.538 74.0537 107.656 74.0537C106.774 74.0537 106.059 74.7688 106.059 75.6508C106.059 76.5329 106.774 77.248 107.656 77.248Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_683",
    d: "M107.656 80.4423C108.538 80.4423 109.253 79.7272 109.253 78.8452C109.253 77.9631 108.538 77.248 107.656 77.248C106.774 77.248 106.059 77.9631 106.059 78.8452C106.059 79.7272 106.774 80.4423 107.656 80.4423Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_684",
    d: "M107.656 90.0253C108.538 90.0253 109.253 89.3102 109.253 88.4282C109.253 87.5461 108.538 86.8311 107.656 86.8311C106.774 86.8311 106.059 87.5461 106.059 88.4282C106.059 89.3102 106.774 90.0253 107.656 90.0253Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_685",
    d: "M107.656 96.413C108.538 96.413 109.253 95.6979 109.253 94.8159C109.253 93.9338 108.538 93.2188 107.656 93.2188C106.774 93.2188 106.059 93.9338 106.059 94.8159C106.059 95.6979 106.774 96.413 107.656 96.413Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_686",
    d: "M107.656 99.6073C108.538 99.6073 109.253 98.8923 109.253 98.0102C109.253 97.1281 108.538 96.4131 107.656 96.4131C106.774 96.4131 106.059 97.1281 106.059 98.0102C106.059 98.8923 106.774 99.6073 107.656 99.6073Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_687",
    d: "M107.656 105.996C108.538 105.996 109.253 105.281 109.253 104.399C109.253 103.517 108.538 102.802 107.656 102.802C106.774 102.802 106.059 103.517 106.059 104.399C106.059 105.281 106.774 105.996 107.656 105.996Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_688",
    d: "M107.656 109.19C108.538 109.19 109.253 108.475 109.253 107.593C109.253 106.711 108.538 105.996 107.656 105.996C106.774 105.996 106.059 106.711 106.059 107.593C106.059 108.475 106.774 109.19 107.656 109.19Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_689",
    d: "M107.656 115.579C108.538 115.579 109.253 114.864 109.253 113.982C109.253 113.1 108.538 112.385 107.656 112.385C106.774 112.385 106.059 113.1 106.059 113.982C106.059 114.864 106.774 115.579 107.656 115.579Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_690",
    d: "M107.656 118.773C108.538 118.773 109.253 118.058 109.253 117.176C109.253 116.294 108.538 115.579 107.656 115.579C106.774 115.579 106.059 116.294 106.059 117.176C106.059 118.058 106.774 118.773 107.656 118.773Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_691",
    d: "M107.656 125.162C108.538 125.162 109.253 124.447 109.253 123.565C109.253 122.683 108.538 121.968 107.656 121.968C106.774 121.968 106.059 122.683 106.059 123.565C106.059 124.447 106.774 125.162 107.656 125.162Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_692",
    d: "M107.656 128.356C108.538 128.356 109.253 127.641 109.253 126.759C109.253 125.877 108.538 125.162 107.656 125.162C106.774 125.162 106.059 125.877 106.059 126.759C106.059 127.641 106.774 128.356 107.656 128.356Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_693",
    d: "M110.849 16.5575C111.731 16.5575 112.446 15.8425 112.446 14.9604C112.446 14.0783 111.731 13.3633 110.849 13.3633C109.967 13.3633 109.252 14.0783 109.252 14.9604C109.252 15.8425 109.967 16.5575 110.849 16.5575Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_694",
    d: "M110.849 22.9452C111.731 22.9452 112.446 22.2302 112.446 21.3481C112.446 20.466 111.731 19.751 110.849 19.751C109.967 19.751 109.252 20.466 109.252 21.3481C109.252 22.2302 109.967 22.9452 110.849 22.9452Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_695",
    d: "M110.849 32.5282C111.731 32.5282 112.446 31.8132 112.446 30.9311C112.446 30.049 111.731 29.334 110.849 29.334C109.967 29.334 109.252 30.049 109.252 30.9311C109.252 31.8132 109.967 32.5282 110.849 32.5282Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_696",
    d: "M110.849 35.7226C111.731 35.7226 112.446 35.0075 112.446 34.1254C112.446 33.2434 111.731 32.5283 110.849 32.5283C109.967 32.5283 109.252 33.2434 109.252 34.1254C109.252 35.0075 109.967 35.7226 110.849 35.7226Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_697",
    d: "M110.849 42.1112C111.731 42.1112 112.446 41.3962 112.446 40.5141C112.446 39.632 111.731 38.917 110.849 38.917C109.967 38.917 109.252 39.632 109.252 40.5141C109.252 41.3962 109.967 42.1112 110.849 42.1112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_698",
    d: "M110.849 48.4999C111.731 48.4999 112.446 47.7849 112.446 46.9028C112.446 46.0207 111.731 45.3057 110.849 45.3057C109.967 45.3057 109.252 46.0207 109.252 46.9028C109.252 47.7849 109.967 48.4999 110.849 48.4999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_699",
    d: "M110.849 83.6366C111.731 83.6366 112.446 82.9216 112.446 82.0395C112.446 81.1574 111.731 80.4424 110.849 80.4424C109.967 80.4424 109.252 81.1574 109.252 82.0395C109.252 82.9216 109.967 83.6366 110.849 83.6366Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_700",
    d: "M110.849 90.0253C111.731 90.0253 112.446 89.3102 112.446 88.4282C112.446 87.5461 111.731 86.8311 110.849 86.8311C109.967 86.8311 109.252 87.5461 109.252 88.4282C109.252 89.3102 109.967 90.0253 110.849 90.0253Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_701",
    d: "M110.849 93.2187C111.731 93.2187 112.446 92.5036 112.446 91.6215C112.446 90.7395 111.731 90.0244 110.849 90.0244C109.967 90.0244 109.252 90.7395 109.252 91.6215C109.252 92.5036 109.967 93.2187 110.849 93.2187Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_702",
    d: "M110.849 96.413C111.731 96.413 112.446 95.6979 112.446 94.8159C112.446 93.9338 111.731 93.2188 110.849 93.2188C109.967 93.2188 109.252 93.9338 109.252 94.8159C109.252 95.6979 109.967 96.413 110.849 96.413Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_703",
    d: "M110.849 99.6073C111.731 99.6073 112.446 98.8923 112.446 98.0102C112.446 97.1281 111.731 96.4131 110.849 96.4131C109.967 96.4131 109.252 97.1281 109.252 98.0102C109.252 98.8923 109.967 99.6073 110.849 99.6073Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_704",
    d: "M110.849 109.19C111.731 109.19 112.446 108.475 112.446 107.593C112.446 106.711 111.731 105.996 110.849 105.996C109.967 105.996 109.252 106.711 109.252 107.593C109.252 108.475 109.967 109.19 110.849 109.19Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_705",
    d: "M110.849 115.579C111.731 115.579 112.446 114.864 112.446 113.982C112.446 113.1 111.731 112.385 110.849 112.385C109.967 112.385 109.252 113.1 109.252 113.982C109.252 114.864 109.967 115.579 110.849 115.579Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_706",
    d: "M110.849 118.773C111.731 118.773 112.446 118.058 112.446 117.176C112.446 116.294 111.731 115.579 110.849 115.579C109.967 115.579 109.252 116.294 109.252 117.176C109.252 118.058 109.967 118.773 110.849 118.773Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_707",
    d: "M110.849 121.968C111.731 121.968 112.446 121.253 112.446 120.371C112.446 119.488 111.731 118.773 110.849 118.773C109.967 118.773 109.252 119.488 109.252 120.371C109.252 121.253 109.967 121.968 110.849 121.968Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_708",
    d: "M110.849 141.133C111.731 141.133 112.446 140.418 112.446 139.536C112.446 138.654 111.731 137.938 110.849 137.938C109.967 137.938 109.252 138.654 109.252 139.536C109.252 140.418 109.967 141.133 110.849 141.133Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_709",
    d: "M114.044 6.97452C114.926 6.97452 115.642 6.25947 115.642 5.3774C115.642 4.49533 114.926 3.78027 114.044 3.78027C113.162 3.78027 112.447 4.49533 112.447 5.3774C112.447 6.25947 113.162 6.97452 114.044 6.97452Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_710",
    d: "M114.044 10.1689C114.926 10.1689 115.642 9.4538 115.642 8.57173C115.642 7.68967 114.926 6.97461 114.044 6.97461C113.162 6.97461 112.447 7.68967 112.447 8.57173C112.447 9.4538 113.162 10.1689 114.044 10.1689Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_711",
    d: "M114.044 13.3632C114.926 13.3632 115.642 12.6481 115.642 11.7661C115.642 10.884 114.926 10.1689 114.044 10.1689C113.162 10.1689 112.447 10.884 112.447 11.7661C112.447 12.6481 113.162 13.3632 114.044 13.3632Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_712",
    d: "M114.044 16.5575C114.926 16.5575 115.642 15.8425 115.642 14.9604C115.642 14.0783 114.926 13.3633 114.044 13.3633C113.162 13.3633 112.447 14.0783 112.447 14.9604C112.447 15.8425 113.162 16.5575 114.044 16.5575Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_713",
    d: "M114.044 26.1396C114.926 26.1396 115.642 25.4245 115.642 24.5424C115.642 23.6604 114.926 22.9453 114.044 22.9453C113.162 22.9453 112.447 23.6604 112.447 24.5424C112.447 25.4245 113.162 26.1396 114.044 26.1396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_714",
    d: "M114.044 29.3339C114.926 29.3339 115.642 28.6188 115.642 27.7368C115.642 26.8547 114.926 26.1396 114.044 26.1396C113.162 26.1396 112.447 26.8547 112.447 27.7368C112.447 28.6188 113.162 29.3339 114.044 29.3339Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_715",
    d: "M114.044 38.9169C114.926 38.9169 115.642 38.2018 115.642 37.3198C115.642 36.4377 114.926 35.7227 114.044 35.7227C113.162 35.7227 112.447 36.4377 112.447 37.3198C112.447 38.2018 113.162 38.9169 114.044 38.9169Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_716",
    d: "M114.044 42.1112C114.926 42.1112 115.642 41.3962 115.642 40.5141C115.642 39.632 114.926 38.917 114.044 38.917C113.162 38.917 112.447 39.632 112.447 40.5141C112.447 41.3962 113.162 42.1112 114.044 42.1112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_717",
    d: "M114.044 45.3056C114.926 45.3056 115.642 44.5905 115.642 43.7085C115.642 42.8264 114.926 42.1113 114.044 42.1113C113.162 42.1113 112.447 42.8264 112.447 43.7085C112.447 44.5905 113.162 45.3056 114.044 45.3056Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_718",
    d: "M114.044 48.4999C114.926 48.4999 115.642 47.7849 115.642 46.9028C115.642 46.0207 114.926 45.3057 114.044 45.3057C113.162 45.3057 112.447 46.0207 112.447 46.9028C112.447 47.7849 113.162 48.4999 114.044 48.4999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_719",
    d: "M114.044 51.6942C114.926 51.6942 115.642 50.9792 115.642 50.0971C115.642 49.2151 114.926 48.5 114.044 48.5C113.162 48.5 112.447 49.2151 112.447 50.0971C112.447 50.9792 113.162 51.6942 114.044 51.6942Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_720",
    d: "M114.044 58.0819C114.926 58.0819 115.642 57.3669 115.642 56.4848C115.642 55.6028 114.926 54.8877 114.044 54.8877C113.162 54.8877 112.447 55.6028 112.447 56.4848C112.447 57.3669 113.162 58.0819 114.044 58.0819Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_721",
    d: "M114.044 64.4706C114.926 64.4706 115.642 63.7556 115.642 62.8735C115.642 61.9914 114.926 61.2764 114.044 61.2764C113.162 61.2764 112.447 61.9914 112.447 62.8735C112.447 63.7556 113.162 64.4706 114.044 64.4706Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_722",
    d: "M114.044 70.8593C114.926 70.8593 115.642 70.1442 115.642 69.2622C115.642 68.3801 114.926 67.665 114.044 67.665C113.162 67.665 112.447 68.3801 112.447 69.2622C112.447 70.1442 113.162 70.8593 114.044 70.8593Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_723",
    d: "M114.044 77.248C114.926 77.248 115.642 76.5329 115.642 75.6508C115.642 74.7688 114.926 74.0537 114.044 74.0537C113.162 74.0537 112.447 74.7688 112.447 75.6508C112.447 76.5329 113.162 77.248 114.044 77.248Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_724",
    d: "M114.044 80.4423C114.926 80.4423 115.642 79.7272 115.642 78.8452C115.642 77.9631 114.926 77.248 114.044 77.248C113.162 77.248 112.447 77.9631 112.447 78.8452C112.447 79.7272 113.162 80.4423 114.044 80.4423Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_725",
    d: "M114.044 105.996C114.926 105.996 115.642 105.281 115.642 104.399C115.642 103.517 114.926 102.802 114.044 102.802C113.162 102.802 112.447 103.517 112.447 104.399C112.447 105.281 113.162 105.996 114.044 105.996Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_726",
    d: "M114.044 109.19C114.926 109.19 115.642 108.475 115.642 107.593C115.642 106.711 114.926 105.996 114.044 105.996C113.162 105.996 112.447 106.711 112.447 107.593C112.447 108.475 113.162 109.19 114.044 109.19Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_727",
    d: "M114.044 112.385C114.926 112.385 115.642 111.67 115.642 110.788C115.642 109.905 114.926 109.19 114.044 109.19C113.162 109.19 112.447 109.905 112.447 110.788C112.447 111.67 113.162 112.385 114.044 112.385Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_728",
    d: "M114.044 118.773C114.926 118.773 115.642 118.058 115.642 117.176C115.642 116.294 114.926 115.579 114.044 115.579C113.162 115.579 112.447 116.294 112.447 117.176C112.447 118.058 113.162 118.773 114.044 118.773Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_729",
    d: "M114.044 125.162C114.926 125.162 115.642 124.447 115.642 123.565C115.642 122.683 114.926 121.968 114.044 121.968C113.162 121.968 112.447 122.683 112.447 123.565C112.447 124.447 113.162 125.162 114.044 125.162Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_730",
    d: "M114.044 141.133C114.926 141.133 115.642 140.418 115.642 139.536C115.642 138.654 114.926 137.938 114.044 137.938C113.162 137.938 112.447 138.654 112.447 139.536C112.447 140.418 113.162 141.133 114.044 141.133Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_731",
    d: "M114.044 144.327C114.926 144.327 115.642 143.612 115.642 142.73C115.642 141.848 114.926 141.133 114.044 141.133C113.162 141.133 112.447 141.848 112.447 142.73C112.447 143.612 113.162 144.327 114.044 144.327Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_732",
    d: "M117.24 3.78019C118.122 3.78019 118.837 3.06513 118.837 2.18306C118.837 1.30099 118.122 0.585938 117.24 0.585938C116.358 0.585938 115.643 1.30099 115.643 2.18306C115.643 3.06513 116.358 3.78019 117.24 3.78019Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_733",
    d: "M117.24 13.3632C118.122 13.3632 118.837 12.6481 118.837 11.7661C118.837 10.884 118.122 10.1689 117.24 10.1689C116.358 10.1689 115.643 10.884 115.643 11.7661C115.643 12.6481 116.358 13.3632 117.24 13.3632Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_734",
    d: "M117.24 16.5575C118.122 16.5575 118.837 15.8425 118.837 14.9604C118.837 14.0783 118.122 13.3633 117.24 13.3633C116.358 13.3633 115.643 14.0783 115.643 14.9604C115.643 15.8425 116.358 16.5575 117.24 16.5575Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_735",
    d: "M117.24 22.9452C118.122 22.9452 118.837 22.2302 118.837 21.3481C118.837 20.466 118.122 19.751 117.24 19.751C116.358 19.751 115.643 20.466 115.643 21.3481C115.643 22.2302 116.358 22.9452 117.24 22.9452Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_736",
    d: "M117.24 26.1396C118.122 26.1396 118.837 25.4245 118.837 24.5424C118.837 23.6604 118.122 22.9453 117.24 22.9453C116.358 22.9453 115.643 23.6604 115.643 24.5424C115.643 25.4245 116.358 26.1396 117.24 26.1396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_737",
    d: "M117.24 38.9169C118.122 38.9169 118.837 38.2018 118.837 37.3198C118.837 36.4377 118.122 35.7227 117.24 35.7227C116.358 35.7227 115.643 36.4377 115.643 37.3198C115.643 38.2018 116.358 38.9169 117.24 38.9169Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_738",
    d: "M117.24 42.1112C118.122 42.1112 118.837 41.3962 118.837 40.5141C118.837 39.632 118.122 38.917 117.24 38.917C116.358 38.917 115.643 39.632 115.643 40.5141C115.643 41.3962 116.358 42.1112 117.24 42.1112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_739",
    d: "M117.24 51.6942C118.122 51.6942 118.837 50.9792 118.837 50.0971C118.837 49.2151 118.122 48.5 117.24 48.5C116.358 48.5 115.643 49.2151 115.643 50.0971C115.643 50.9792 116.358 51.6942 117.24 51.6942Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_740",
    d: "M117.24 54.8886C118.122 54.8886 118.837 54.1735 118.837 53.2915C118.837 52.4094 118.122 51.6943 117.24 51.6943C116.358 51.6943 115.643 52.4094 115.643 53.2915C115.643 54.1735 116.358 54.8886 117.24 54.8886Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_741",
    d: "M117.24 58.0819C118.122 58.0819 118.837 57.3669 118.837 56.4848C118.837 55.6028 118.122 54.8877 117.24 54.8877C116.358 54.8877 115.643 55.6028 115.643 56.4848C115.643 57.3669 116.358 58.0819 117.24 58.0819Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_742",
    d: "M117.24 61.2763C118.122 61.2763 118.837 60.5612 118.837 59.6792C118.837 58.7971 118.122 58.082 117.24 58.082C116.358 58.082 115.643 58.7971 115.643 59.6792C115.643 60.5612 116.358 61.2763 117.24 61.2763Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_743",
    d: "M117.24 67.665C118.122 67.665 118.837 66.9499 118.837 66.0678C118.837 65.1858 118.122 64.4707 117.24 64.4707C116.358 64.4707 115.643 65.1858 115.643 66.0678C115.643 66.9499 116.358 67.665 117.24 67.665Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_744",
    d: "M117.24 70.8593C118.122 70.8593 118.837 70.1442 118.837 69.2622C118.837 68.3801 118.122 67.665 117.24 67.665C116.358 67.665 115.643 68.3801 115.643 69.2622C115.643 70.1442 116.358 70.8593 117.24 70.8593Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_745",
    d: "M117.24 74.0536C118.122 74.0536 118.837 73.3386 118.837 72.4565C118.837 71.5744 118.122 70.8594 117.24 70.8594C116.358 70.8594 115.643 71.5744 115.643 72.4565C115.643 73.3386 116.358 74.0536 117.24 74.0536Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_746",
    d: "M117.24 77.248C118.122 77.248 118.837 76.5329 118.837 75.6508C118.837 74.7688 118.122 74.0537 117.24 74.0537C116.358 74.0537 115.643 74.7688 115.643 75.6508C115.643 76.5329 116.358 77.248 117.24 77.248Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_747",
    d: "M117.24 80.4423C118.122 80.4423 118.837 79.7272 118.837 78.8452C118.837 77.9631 118.122 77.248 117.24 77.248C116.358 77.248 115.643 77.9631 115.643 78.8452C115.643 79.7272 116.358 80.4423 117.24 80.4423Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_748",
    d: "M117.24 86.831C118.122 86.831 118.837 86.1159 118.837 85.2338C118.837 84.3518 118.122 83.6367 117.24 83.6367C116.358 83.6367 115.643 84.3518 115.643 85.2338C115.643 86.1159 116.358 86.831 117.24 86.831Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_749",
    d: "M117.24 90.0253C118.122 90.0253 118.837 89.3102 118.837 88.4282C118.837 87.5461 118.122 86.8311 117.24 86.8311C116.358 86.8311 115.643 87.5461 115.643 88.4282C115.643 89.3102 116.358 90.0253 117.24 90.0253Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_750",
    d: "M117.24 96.413C118.122 96.413 118.837 95.6979 118.837 94.8159C118.837 93.9338 118.122 93.2188 117.24 93.2188C116.358 93.2188 115.643 93.9338 115.643 94.8159C115.643 95.6979 116.358 96.413 117.24 96.413Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_751",
    d: "M117.24 99.6073C118.122 99.6073 118.837 98.8923 118.837 98.0102C118.837 97.1281 118.122 96.4131 117.24 96.4131C116.358 96.4131 115.643 97.1281 115.643 98.0102C115.643 98.8923 116.358 99.6073 117.24 99.6073Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_752",
    d: "M117.24 105.996C118.122 105.996 118.837 105.281 118.837 104.399C118.837 103.517 118.122 102.802 117.24 102.802C116.358 102.802 115.643 103.517 115.643 104.399C115.643 105.281 116.358 105.996 117.24 105.996Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_753",
    d: "M117.24 109.19C118.122 109.19 118.837 108.475 118.837 107.593C118.837 106.711 118.122 105.996 117.24 105.996C116.358 105.996 115.643 106.711 115.643 107.593C115.643 108.475 116.358 109.19 117.24 109.19Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_754",
    d: "M117.24 118.773C118.122 118.773 118.837 118.058 118.837 117.176C118.837 116.294 118.122 115.579 117.24 115.579C116.358 115.579 115.643 116.294 115.643 117.176C115.643 118.058 116.358 118.773 117.24 118.773Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_755",
    d: "M117.24 121.968C118.122 121.968 118.837 121.253 118.837 120.371C118.837 119.488 118.122 118.773 117.24 118.773C116.358 118.773 115.643 119.488 115.643 120.371C115.643 121.253 116.358 121.968 117.24 121.968Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_756",
    d: "M117.24 125.162C118.122 125.162 118.837 124.447 118.837 123.565C118.837 122.683 118.122 121.968 117.24 121.968C116.358 121.968 115.643 122.683 115.643 123.565C115.643 124.447 116.358 125.162 117.24 125.162Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_757",
    d: "M117.24 128.356C118.122 128.356 118.837 127.641 118.837 126.759C118.837 125.877 118.122 125.162 117.24 125.162C116.358 125.162 115.643 125.877 115.643 126.759C115.643 127.641 116.358 128.356 117.24 128.356Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_758",
    d: "M117.24 131.55C118.122 131.55 118.837 130.835 118.837 129.953C118.837 129.071 118.122 128.355 117.24 128.355C116.358 128.355 115.643 129.071 115.643 129.953C115.643 130.835 116.358 131.55 117.24 131.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_759",
    d: "M120.433 29.3339C121.315 29.3339 122.03 28.6188 122.03 27.7368C122.03 26.8547 121.315 26.1396 120.433 26.1396C119.551 26.1396 118.836 26.8547 118.836 27.7368C118.836 28.6188 119.551 29.3339 120.433 29.3339Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_760",
    d: "M120.433 42.1112C121.315 42.1112 122.03 41.3962 122.03 40.5141C122.03 39.632 121.315 38.917 120.433 38.917C119.551 38.917 118.836 39.632 118.836 40.5141C118.836 41.3962 119.551 42.1112 120.433 42.1112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_761",
    d: "M120.433 45.3056C121.315 45.3056 122.03 44.5905 122.03 43.7085C122.03 42.8264 121.315 42.1113 120.433 42.1113C119.551 42.1113 118.836 42.8264 118.836 43.7085C118.836 44.5905 119.551 45.3056 120.433 45.3056Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_762",
    d: "M120.433 48.4999C121.315 48.4999 122.03 47.7849 122.03 46.9028C122.03 46.0207 121.315 45.3057 120.433 45.3057C119.551 45.3057 118.836 46.0207 118.836 46.9028C118.836 47.7849 119.551 48.4999 120.433 48.4999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_763",
    d: "M120.433 51.6942C121.315 51.6942 122.03 50.9792 122.03 50.0971C122.03 49.2151 121.315 48.5 120.433 48.5C119.551 48.5 118.836 49.2151 118.836 50.0971C118.836 50.9792 119.551 51.6942 120.433 51.6942Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_764",
    d: "M120.433 58.0819C121.315 58.0819 122.03 57.3669 122.03 56.4848C122.03 55.6028 121.315 54.8877 120.433 54.8877C119.551 54.8877 118.836 55.6028 118.836 56.4848C118.836 57.3669 119.551 58.0819 120.433 58.0819Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_765",
    d: "M120.433 64.4706C121.315 64.4706 122.03 63.7556 122.03 62.8735C122.03 61.9914 121.315 61.2764 120.433 61.2764C119.551 61.2764 118.836 61.9914 118.836 62.8735C118.836 63.7556 119.551 64.4706 120.433 64.4706Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_766",
    d: "M120.433 67.665C121.315 67.665 122.03 66.9499 122.03 66.0678C122.03 65.1858 121.315 64.4707 120.433 64.4707C119.551 64.4707 118.836 65.1858 118.836 66.0678C118.836 66.9499 119.551 67.665 120.433 67.665Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_767",
    d: "M120.433 80.4423C121.315 80.4423 122.03 79.7272 122.03 78.8452C122.03 77.9631 121.315 77.248 120.433 77.248C119.551 77.248 118.836 77.9631 118.836 78.8452C118.836 79.7272 119.551 80.4423 120.433 80.4423Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_768",
    d: "M120.433 86.831C121.315 86.831 122.03 86.1159 122.03 85.2338C122.03 84.3518 121.315 83.6367 120.433 83.6367C119.551 83.6367 118.836 84.3518 118.836 85.2338C118.836 86.1159 119.551 86.831 120.433 86.831Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_769",
    d: "M120.433 90.0253C121.315 90.0253 122.03 89.3102 122.03 88.4282C122.03 87.5461 121.315 86.8311 120.433 86.8311C119.551 86.8311 118.836 87.5461 118.836 88.4282C118.836 89.3102 119.551 90.0253 120.433 90.0253Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_770",
    d: "M120.433 93.2187C121.315 93.2187 122.03 92.5036 122.03 91.6215C122.03 90.7395 121.315 90.0244 120.433 90.0244C119.551 90.0244 118.836 90.7395 118.836 91.6215C118.836 92.5036 119.551 93.2187 120.433 93.2187Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_771",
    d: "M120.433 96.413C121.315 96.413 122.03 95.6979 122.03 94.8159C122.03 93.9338 121.315 93.2188 120.433 93.2188C119.551 93.2188 118.836 93.9338 118.836 94.8159C118.836 95.6979 119.551 96.413 120.433 96.413Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_772",
    d: "M120.433 99.6073C121.315 99.6073 122.03 98.8923 122.03 98.0102C122.03 97.1281 121.315 96.4131 120.433 96.4131C119.551 96.4131 118.836 97.1281 118.836 98.0102C118.836 98.8923 119.551 99.6073 120.433 99.6073Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_773",
    d: "M120.433 102.802C121.315 102.802 122.03 102.087 122.03 101.205C122.03 100.322 121.315 99.6074 120.433 99.6074C119.551 99.6074 118.836 100.322 118.836 101.205C118.836 102.087 119.551 102.802 120.433 102.802Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_774",
    d: "M120.433 109.19C121.315 109.19 122.03 108.475 122.03 107.593C122.03 106.711 121.315 105.996 120.433 105.996C119.551 105.996 118.836 106.711 118.836 107.593C118.836 108.475 119.551 109.19 120.433 109.19Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_775",
    d: "M120.433 118.773C121.315 118.773 122.03 118.058 122.03 117.176C122.03 116.294 121.315 115.579 120.433 115.579C119.551 115.579 118.836 116.294 118.836 117.176C118.836 118.058 119.551 118.773 120.433 118.773Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_776",
    d: "M120.433 131.55C121.315 131.55 122.03 130.835 122.03 129.953C122.03 129.071 121.315 128.355 120.433 128.355C119.551 128.355 118.836 129.071 118.836 129.953C118.836 130.835 119.551 131.55 120.433 131.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_777",
    d: "M120.433 134.744C121.315 134.744 122.03 134.029 122.03 133.147C122.03 132.265 121.315 131.55 120.433 131.55C119.551 131.55 118.836 132.265 118.836 133.147C118.836 134.029 119.551 134.744 120.433 134.744Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_778",
    d: "M120.433 141.133C121.315 141.133 122.03 140.418 122.03 139.536C122.03 138.654 121.315 137.938 120.433 137.938C119.551 137.938 118.836 138.654 118.836 139.536C118.836 140.418 119.551 141.133 120.433 141.133Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_779",
    d: "M123.626 35.7226C124.508 35.7226 125.224 35.0075 125.224 34.1254C125.224 33.2434 124.508 32.5283 123.626 32.5283C122.744 32.5283 122.029 33.2434 122.029 34.1254C122.029 35.0075 122.744 35.7226 123.626 35.7226Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_780",
    d: "M123.626 42.1112C124.508 42.1112 125.224 41.3962 125.224 40.5141C125.224 39.632 124.508 38.917 123.626 38.917C122.744 38.917 122.029 39.632 122.029 40.5141C122.029 41.3962 122.744 42.1112 123.626 42.1112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_781",
    d: "M123.626 51.6942C124.508 51.6942 125.224 50.9792 125.224 50.0971C125.224 49.2151 124.508 48.5 123.626 48.5C122.744 48.5 122.029 49.2151 122.029 50.0971C122.029 50.9792 122.744 51.6942 123.626 51.6942Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_782",
    d: "M123.626 54.8886C124.508 54.8886 125.224 54.1735 125.224 53.2915C125.224 52.4094 124.508 51.6943 123.626 51.6943C122.744 51.6943 122.029 52.4094 122.029 53.2915C122.029 54.1735 122.744 54.8886 123.626 54.8886Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_783",
    d: "M123.626 61.2763C124.508 61.2763 125.224 60.5612 125.224 59.6792C125.224 58.7971 124.508 58.082 123.626 58.082C122.744 58.082 122.029 58.7971 122.029 59.6792C122.029 60.5612 122.744 61.2763 123.626 61.2763Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_784",
    d: "M123.626 64.4706C124.508 64.4706 125.224 63.7556 125.224 62.8735C125.224 61.9914 124.508 61.2764 123.626 61.2764C122.744 61.2764 122.029 61.9914 122.029 62.8735C122.029 63.7556 122.744 64.4706 123.626 64.4706Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_785",
    d: "M123.626 67.665C124.508 67.665 125.224 66.9499 125.224 66.0678C125.224 65.1858 124.508 64.4707 123.626 64.4707C122.744 64.4707 122.029 65.1858 122.029 66.0678C122.029 66.9499 122.744 67.665 123.626 67.665Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_786",
    d: "M123.626 74.0536C124.508 74.0536 125.224 73.3386 125.224 72.4565C125.224 71.5744 124.508 70.8594 123.626 70.8594C122.744 70.8594 122.029 71.5744 122.029 72.4565C122.029 73.3386 122.744 74.0536 123.626 74.0536Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_787",
    d: "M123.626 80.4423C124.508 80.4423 125.224 79.7272 125.224 78.8452C125.224 77.9631 124.508 77.248 123.626 77.248C122.744 77.248 122.029 77.9631 122.029 78.8452C122.029 79.7272 122.744 80.4423 123.626 80.4423Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_788",
    d: "M123.626 86.831C124.508 86.831 125.224 86.1159 125.224 85.2338C125.224 84.3518 124.508 83.6367 123.626 83.6367C122.744 83.6367 122.029 84.3518 122.029 85.2338C122.029 86.1159 122.744 86.831 123.626 86.831Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_789",
    d: "M123.626 90.0253C124.508 90.0253 125.224 89.3102 125.224 88.4282C125.224 87.5461 124.508 86.8311 123.626 86.8311C122.744 86.8311 122.029 87.5461 122.029 88.4282C122.029 89.3102 122.744 90.0253 123.626 90.0253Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_790",
    d: "M123.626 93.2187C124.508 93.2187 125.224 92.5036 125.224 91.6215C125.224 90.7395 124.508 90.0244 123.626 90.0244C122.744 90.0244 122.029 90.7395 122.029 91.6215C122.029 92.5036 122.744 93.2187 123.626 93.2187Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_791",
    d: "M123.626 96.413C124.508 96.413 125.224 95.6979 125.224 94.8159C125.224 93.9338 124.508 93.2188 123.626 93.2188C122.744 93.2188 122.029 93.9338 122.029 94.8159C122.029 95.6979 122.744 96.413 123.626 96.413Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_792",
    d: "M123.626 99.6073C124.508 99.6073 125.224 98.8923 125.224 98.0102C125.224 97.1281 124.508 96.4131 123.626 96.4131C122.744 96.4131 122.029 97.1281 122.029 98.0102C122.029 98.8923 122.744 99.6073 123.626 99.6073Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_793",
    d: "M123.626 102.802C124.508 102.802 125.224 102.087 125.224 101.205C125.224 100.322 124.508 99.6074 123.626 99.6074C122.744 99.6074 122.029 100.322 122.029 101.205C122.029 102.087 122.744 102.802 123.626 102.802Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_794",
    d: "M123.626 105.996C124.508 105.996 125.224 105.281 125.224 104.399C125.224 103.517 124.508 102.802 123.626 102.802C122.744 102.802 122.029 103.517 122.029 104.399C122.029 105.281 122.744 105.996 123.626 105.996Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_795",
    d: "M123.626 112.385C124.508 112.385 125.224 111.67 125.224 110.788C125.224 109.905 124.508 109.19 123.626 109.19C122.744 109.19 122.029 109.905 122.029 110.788C122.029 111.67 122.744 112.385 123.626 112.385Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_796",
    d: "M123.626 115.579C124.508 115.579 125.224 114.864 125.224 113.982C125.224 113.1 124.508 112.385 123.626 112.385C122.744 112.385 122.029 113.1 122.029 113.982C122.029 114.864 122.744 115.579 123.626 115.579Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_797",
    d: "M123.626 118.773C124.508 118.773 125.224 118.058 125.224 117.176C125.224 116.294 124.508 115.579 123.626 115.579C122.744 115.579 122.029 116.294 122.029 117.176C122.029 118.058 122.744 118.773 123.626 118.773Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_798",
    d: "M123.626 125.162C124.508 125.162 125.224 124.447 125.224 123.565C125.224 122.683 124.508 121.968 123.626 121.968C122.744 121.968 122.029 122.683 122.029 123.565C122.029 124.447 122.744 125.162 123.626 125.162Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_799",
    d: "M123.626 131.55C124.508 131.55 125.224 130.835 125.224 129.953C125.224 129.071 124.508 128.355 123.626 128.355C122.744 128.355 122.029 129.071 122.029 129.953C122.029 130.835 122.744 131.55 123.626 131.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_800",
    d: "M123.626 137.938C124.508 137.938 125.224 137.223 125.224 136.341C125.224 135.459 124.508 134.744 123.626 134.744C122.744 134.744 122.029 135.459 122.029 136.341C122.029 137.223 122.744 137.938 123.626 137.938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_801",
    d: "M123.626 141.133C124.508 141.133 125.224 140.418 125.224 139.536C125.224 138.654 124.508 137.938 123.626 137.938C122.744 137.938 122.029 138.654 122.029 139.536C122.029 140.418 122.744 141.133 123.626 141.133Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_802",
    d: "M126.822 32.5282C127.704 32.5282 128.419 31.8132 128.419 30.9311C128.419 30.049 127.704 29.334 126.822 29.334C125.94 29.334 125.225 30.049 125.225 30.9311C125.225 31.8132 125.94 32.5282 126.822 32.5282Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_803",
    d: "M126.822 35.7226C127.704 35.7226 128.419 35.0075 128.419 34.1254C128.419 33.2434 127.704 32.5283 126.822 32.5283C125.94 32.5283 125.225 33.2434 125.225 34.1254C125.225 35.0075 125.94 35.7226 126.822 35.7226Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_804",
    d: "M126.822 45.3056C127.704 45.3056 128.419 44.5905 128.419 43.7085C128.419 42.8264 127.704 42.1113 126.822 42.1113C125.94 42.1113 125.225 42.8264 125.225 43.7085C125.225 44.5905 125.94 45.3056 126.822 45.3056Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_805",
    d: "M126.822 54.8886C127.704 54.8886 128.419 54.1735 128.419 53.2915C128.419 52.4094 127.704 51.6943 126.822 51.6943C125.94 51.6943 125.225 52.4094 125.225 53.2915C125.225 54.1735 125.94 54.8886 126.822 54.8886Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_806",
    d: "M126.822 58.0819C127.704 58.0819 128.419 57.3669 128.419 56.4848C128.419 55.6028 127.704 54.8877 126.822 54.8877C125.94 54.8877 125.225 55.6028 125.225 56.4848C125.225 57.3669 125.94 58.0819 126.822 58.0819Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_807",
    d: "M126.822 61.2763C127.704 61.2763 128.419 60.5612 128.419 59.6792C128.419 58.7971 127.704 58.082 126.822 58.082C125.94 58.082 125.225 58.7971 125.225 59.6792C125.225 60.5612 125.94 61.2763 126.822 61.2763Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_808",
    d: "M126.822 67.665C127.704 67.665 128.419 66.9499 128.419 66.0678C128.419 65.1858 127.704 64.4707 126.822 64.4707C125.94 64.4707 125.225 65.1858 125.225 66.0678C125.225 66.9499 125.94 67.665 126.822 67.665Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_809",
    d: "M126.822 80.4423C127.704 80.4423 128.419 79.7272 128.419 78.8452C128.419 77.9631 127.704 77.248 126.822 77.248C125.94 77.248 125.225 77.9631 125.225 78.8452C125.225 79.7272 125.94 80.4423 126.822 80.4423Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_810",
    d: "M126.822 83.6366C127.704 83.6366 128.419 82.9216 128.419 82.0395C128.419 81.1574 127.704 80.4424 126.822 80.4424C125.94 80.4424 125.225 81.1574 125.225 82.0395C125.225 82.9216 125.94 83.6366 126.822 83.6366Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_811",
    d: "M126.822 105.996C127.704 105.996 128.419 105.281 128.419 104.399C128.419 103.517 127.704 102.802 126.822 102.802C125.94 102.802 125.225 103.517 125.225 104.399C125.225 105.281 125.94 105.996 126.822 105.996Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_812",
    d: "M126.822 115.579C127.704 115.579 128.419 114.864 128.419 113.982C128.419 113.1 127.704 112.385 126.822 112.385C125.94 112.385 125.225 113.1 125.225 113.982C125.225 114.864 125.94 115.579 126.822 115.579Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_813",
    d: "M126.822 118.773C127.704 118.773 128.419 118.058 128.419 117.176C128.419 116.294 127.704 115.579 126.822 115.579C125.94 115.579 125.225 116.294 125.225 117.176C125.225 118.058 125.94 118.773 126.822 118.773Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_814",
    d: "M126.822 131.55C127.704 131.55 128.419 130.835 128.419 129.953C128.419 129.071 127.704 128.355 126.822 128.355C125.94 128.355 125.225 129.071 125.225 129.953C125.225 130.835 125.94 131.55 126.822 131.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_815",
    d: "M126.822 144.327C127.704 144.327 128.419 143.612 128.419 142.73C128.419 141.848 127.704 141.133 126.822 141.133C125.94 141.133 125.225 141.848 125.225 142.73C125.225 143.612 125.94 144.327 126.822 144.327Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_816",
    d: "M130.015 29.3339C130.897 29.3339 131.612 28.6188 131.612 27.7368C131.612 26.8547 130.897 26.1396 130.015 26.1396C129.133 26.1396 128.418 26.8547 128.418 27.7368C128.418 28.6188 129.133 29.3339 130.015 29.3339Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_817",
    d: "M130.015 38.9169C130.897 38.9169 131.612 38.2018 131.612 37.3198C131.612 36.4377 130.897 35.7227 130.015 35.7227C129.133 35.7227 128.418 36.4377 128.418 37.3198C128.418 38.2018 129.133 38.9169 130.015 38.9169Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_818",
    d: "M130.015 51.6942C130.897 51.6942 131.612 50.9792 131.612 50.0971C131.612 49.2151 130.897 48.5 130.015 48.5C129.133 48.5 128.418 49.2151 128.418 50.0971C128.418 50.9792 129.133 51.6942 130.015 51.6942Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_819",
    d: "M130.015 61.2763C130.897 61.2763 131.612 60.5612 131.612 59.6792C131.612 58.7971 130.897 58.082 130.015 58.082C129.133 58.082 128.418 58.7971 128.418 59.6792C128.418 60.5612 129.133 61.2763 130.015 61.2763Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_820",
    d: "M130.015 64.4706C130.897 64.4706 131.612 63.7556 131.612 62.8735C131.612 61.9914 130.897 61.2764 130.015 61.2764C129.133 61.2764 128.418 61.9914 128.418 62.8735C128.418 63.7556 129.133 64.4706 130.015 64.4706Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_821",
    d: "M130.015 67.665C130.897 67.665 131.612 66.9499 131.612 66.0678C131.612 65.1858 130.897 64.4707 130.015 64.4707C129.133 64.4707 128.418 65.1858 128.418 66.0678C128.418 66.9499 129.133 67.665 130.015 67.665Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_822",
    d: "M130.015 70.8593C130.897 70.8593 131.612 70.1442 131.612 69.2622C131.612 68.3801 130.897 67.665 130.015 67.665C129.133 67.665 128.418 68.3801 128.418 69.2622C128.418 70.1442 129.133 70.8593 130.015 70.8593Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_823",
    d: "M130.015 74.0536C130.897 74.0536 131.612 73.3386 131.612 72.4565C131.612 71.5744 130.897 70.8594 130.015 70.8594C129.133 70.8594 128.418 71.5744 128.418 72.4565C128.418 73.3386 129.133 74.0536 130.015 74.0536Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_824",
    d: "M130.015 77.248C130.897 77.248 131.612 76.5329 131.612 75.6508C131.612 74.7688 130.897 74.0537 130.015 74.0537C129.133 74.0537 128.418 74.7688 128.418 75.6508C128.418 76.5329 129.133 77.248 130.015 77.248Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_825",
    d: "M130.015 80.4423C130.897 80.4423 131.612 79.7272 131.612 78.8452C131.612 77.9631 130.897 77.248 130.015 77.248C129.133 77.248 128.418 77.9631 128.418 78.8452C128.418 79.7272 129.133 80.4423 130.015 80.4423Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_826",
    d: "M130.015 90.0253C130.897 90.0253 131.612 89.3102 131.612 88.4282C131.612 87.5461 130.897 86.8311 130.015 86.8311C129.133 86.8311 128.418 87.5461 128.418 88.4282C128.418 89.3102 129.133 90.0253 130.015 90.0253Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_827",
    d: "M130.015 99.6073C130.897 99.6073 131.612 98.8923 131.612 98.0102C131.612 97.1281 130.897 96.4131 130.015 96.4131C129.133 96.4131 128.418 97.1281 128.418 98.0102C128.418 98.8923 129.133 99.6073 130.015 99.6073Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_828",
    d: "M130.015 105.996C130.897 105.996 131.612 105.281 131.612 104.399C131.612 103.517 130.897 102.802 130.015 102.802C129.133 102.802 128.418 103.517 128.418 104.399C128.418 105.281 129.133 105.996 130.015 105.996Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_829",
    d: "M130.015 109.19C130.897 109.19 131.612 108.475 131.612 107.593C131.612 106.711 130.897 105.996 130.015 105.996C129.133 105.996 128.418 106.711 128.418 107.593C128.418 108.475 129.133 109.19 130.015 109.19Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_830",
    d: "M130.015 112.385C130.897 112.385 131.612 111.67 131.612 110.788C131.612 109.905 130.897 109.19 130.015 109.19C129.133 109.19 128.418 109.905 128.418 110.788C128.418 111.67 129.133 112.385 130.015 112.385Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_831",
    d: "M130.015 118.773C130.897 118.773 131.612 118.058 131.612 117.176C131.612 116.294 130.897 115.579 130.015 115.579C129.133 115.579 128.418 116.294 128.418 117.176C128.418 118.058 129.133 118.773 130.015 118.773Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_832",
    d: "M130.015 121.968C130.897 121.968 131.612 121.253 131.612 120.371C131.612 119.488 130.897 118.773 130.015 118.773C129.133 118.773 128.418 119.488 128.418 120.371C128.418 121.253 129.133 121.968 130.015 121.968Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_833",
    d: "M130.015 125.162C130.897 125.162 131.612 124.447 131.612 123.565C131.612 122.683 130.897 121.968 130.015 121.968C129.133 121.968 128.418 122.683 128.418 123.565C128.418 124.447 129.133 125.162 130.015 125.162Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_834",
    d: "M130.015 128.356C130.897 128.356 131.612 127.641 131.612 126.759C131.612 125.877 130.897 125.162 130.015 125.162C129.133 125.162 128.418 125.877 128.418 126.759C128.418 127.641 129.133 128.356 130.015 128.356Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_835",
    d: "M130.015 131.55C130.897 131.55 131.612 130.835 131.612 129.953C131.612 129.071 130.897 128.355 130.015 128.355C129.133 128.355 128.418 129.071 128.418 129.953C128.418 130.835 129.133 131.55 130.015 131.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_836",
    d: "M133.208 38.9169C134.091 38.9169 134.806 38.2018 134.806 37.3198C134.806 36.4377 134.091 35.7227 133.208 35.7227C132.326 35.7227 131.611 36.4377 131.611 37.3198C131.611 38.2018 132.326 38.9169 133.208 38.9169Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_837",
    d: "M133.208 42.1112C134.091 42.1112 134.806 41.3962 134.806 40.5141C134.806 39.632 134.091 38.917 133.208 38.917C132.326 38.917 131.611 39.632 131.611 40.5141C131.611 41.3962 132.326 42.1112 133.208 42.1112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_838",
    d: "M133.208 45.3056C134.091 45.3056 134.806 44.5905 134.806 43.7085C134.806 42.8264 134.091 42.1113 133.208 42.1113C132.326 42.1113 131.611 42.8264 131.611 43.7085C131.611 44.5905 132.326 45.3056 133.208 45.3056Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_839",
    d: "M133.208 48.4999C134.091 48.4999 134.806 47.7849 134.806 46.9028C134.806 46.0207 134.091 45.3057 133.208 45.3057C132.326 45.3057 131.611 46.0207 131.611 46.9028C131.611 47.7849 132.326 48.4999 133.208 48.4999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_840",
    d: "M133.208 51.6942C134.091 51.6942 134.806 50.9792 134.806 50.0971C134.806 49.2151 134.091 48.5 133.208 48.5C132.326 48.5 131.611 49.2151 131.611 50.0971C131.611 50.9792 132.326 51.6942 133.208 51.6942Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_841",
    d: "M133.208 54.8886C134.091 54.8886 134.806 54.1735 134.806 53.2915C134.806 52.4094 134.091 51.6943 133.208 51.6943C132.326 51.6943 131.611 52.4094 131.611 53.2915C131.611 54.1735 132.326 54.8886 133.208 54.8886Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_842",
    d: "M133.208 58.0819C134.091 58.0819 134.806 57.3669 134.806 56.4848C134.806 55.6028 134.091 54.8877 133.208 54.8877C132.326 54.8877 131.611 55.6028 131.611 56.4848C131.611 57.3669 132.326 58.0819 133.208 58.0819Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_843",
    d: "M133.208 64.4706C134.091 64.4706 134.806 63.7556 134.806 62.8735C134.806 61.9914 134.091 61.2764 133.208 61.2764C132.326 61.2764 131.611 61.9914 131.611 62.8735C131.611 63.7556 132.326 64.4706 133.208 64.4706Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_844",
    d: "M133.208 70.8593C134.091 70.8593 134.806 70.1442 134.806 69.2622C134.806 68.3801 134.091 67.665 133.208 67.665C132.326 67.665 131.611 68.3801 131.611 69.2622C131.611 70.1442 132.326 70.8593 133.208 70.8593Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_845",
    d: "M133.208 74.0536C134.091 74.0536 134.806 73.3386 134.806 72.4565C134.806 71.5744 134.091 70.8594 133.208 70.8594C132.326 70.8594 131.611 71.5744 131.611 72.4565C131.611 73.3386 132.326 74.0536 133.208 74.0536Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_846",
    d: "M133.208 77.248C134.091 77.248 134.806 76.5329 134.806 75.6508C134.806 74.7688 134.091 74.0537 133.208 74.0537C132.326 74.0537 131.611 74.7688 131.611 75.6508C131.611 76.5329 132.326 77.248 133.208 77.248Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_847",
    d: "M133.208 90.0253C134.091 90.0253 134.806 89.3102 134.806 88.4282C134.806 87.5461 134.091 86.8311 133.208 86.8311C132.326 86.8311 131.611 87.5461 131.611 88.4282C131.611 89.3102 132.326 90.0253 133.208 90.0253Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_848",
    d: "M133.208 96.413C134.091 96.413 134.806 95.6979 134.806 94.8159C134.806 93.9338 134.091 93.2188 133.208 93.2188C132.326 93.2188 131.611 93.9338 131.611 94.8159C131.611 95.6979 132.326 96.413 133.208 96.413Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_849",
    d: "M133.208 99.6073C134.091 99.6073 134.806 98.8923 134.806 98.0102C134.806 97.1281 134.091 96.4131 133.208 96.4131C132.326 96.4131 131.611 97.1281 131.611 98.0102C131.611 98.8923 132.326 99.6073 133.208 99.6073Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_850",
    d: "M133.208 121.968C134.091 121.968 134.806 121.253 134.806 120.371C134.806 119.488 134.091 118.773 133.208 118.773C132.326 118.773 131.611 119.488 131.611 120.371C131.611 121.253 132.326 121.968 133.208 121.968Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_851",
    d: "M133.208 125.162C134.091 125.162 134.806 124.447 134.806 123.565C134.806 122.683 134.091 121.968 133.208 121.968C132.326 121.968 131.611 122.683 131.611 123.565C131.611 124.447 132.326 125.162 133.208 125.162Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_852",
    d: "M133.208 128.356C134.091 128.356 134.806 127.641 134.806 126.759C134.806 125.877 134.091 125.162 133.208 125.162C132.326 125.162 131.611 125.877 131.611 126.759C131.611 127.641 132.326 128.356 133.208 128.356Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_853",
    d: "M133.208 131.55C134.091 131.55 134.806 130.835 134.806 129.953C134.806 129.071 134.091 128.355 133.208 128.355C132.326 128.355 131.611 129.071 131.611 129.953C131.611 130.835 132.326 131.55 133.208 131.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_854",
    d: "M133.208 134.744C134.091 134.744 134.806 134.029 134.806 133.147C134.806 132.265 134.091 131.55 133.208 131.55C132.326 131.55 131.611 132.265 131.611 133.147C131.611 134.029 132.326 134.744 133.208 134.744Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_855",
    d: "M133.208 144.327C134.091 144.327 134.806 143.612 134.806 142.73C134.806 141.848 134.091 141.133 133.208 141.133C132.326 141.133 131.611 141.848 131.611 142.73C131.611 143.612 132.326 144.327 133.208 144.327Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_856",
    d: "M136.404 38.9169C137.286 38.9169 138.001 38.2018 138.001 37.3198C138.001 36.4377 137.286 35.7227 136.404 35.7227C135.522 35.7227 134.807 36.4377 134.807 37.3198C134.807 38.2018 135.522 38.9169 136.404 38.9169Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_857",
    d: "M136.404 42.1112C137.286 42.1112 138.001 41.3962 138.001 40.5141C138.001 39.632 137.286 38.917 136.404 38.917C135.522 38.917 134.807 39.632 134.807 40.5141C134.807 41.3962 135.522 42.1112 136.404 42.1112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_858",
    d: "M136.404 45.3056C137.286 45.3056 138.001 44.5905 138.001 43.7085C138.001 42.8264 137.286 42.1113 136.404 42.1113C135.522 42.1113 134.807 42.8264 134.807 43.7085C134.807 44.5905 135.522 45.3056 136.404 45.3056Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_859",
    d: "M136.404 54.8886C137.286 54.8886 138.001 54.1735 138.001 53.2915C138.001 52.4094 137.286 51.6943 136.404 51.6943C135.522 51.6943 134.807 52.4094 134.807 53.2915C134.807 54.1735 135.522 54.8886 136.404 54.8886Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_860",
    d: "M136.404 70.8593C137.286 70.8593 138.001 70.1442 138.001 69.2622C138.001 68.3801 137.286 67.665 136.404 67.665C135.522 67.665 134.807 68.3801 134.807 69.2622C134.807 70.1442 135.522 70.8593 136.404 70.8593Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_861",
    d: "M136.404 74.0536C137.286 74.0536 138.001 73.3386 138.001 72.4565C138.001 71.5744 137.286 70.8594 136.404 70.8594C135.522 70.8594 134.807 71.5744 134.807 72.4565C134.807 73.3386 135.522 74.0536 136.404 74.0536Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_862",
    d: "M136.404 83.6366C137.286 83.6366 138.001 82.9216 138.001 82.0395C138.001 81.1574 137.286 80.4424 136.404 80.4424C135.522 80.4424 134.807 81.1574 134.807 82.0395C134.807 82.9216 135.522 83.6366 136.404 83.6366Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_863",
    d: "M136.404 90.0253C137.286 90.0253 138.001 89.3102 138.001 88.4282C138.001 87.5461 137.286 86.8311 136.404 86.8311C135.522 86.8311 134.807 87.5461 134.807 88.4282C134.807 89.3102 135.522 90.0253 136.404 90.0253Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_864",
    d: "M136.404 93.2187C137.286 93.2187 138.001 92.5036 138.001 91.6215C138.001 90.7395 137.286 90.0244 136.404 90.0244C135.522 90.0244 134.807 90.7395 134.807 91.6215C134.807 92.5036 135.522 93.2187 136.404 93.2187Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_865",
    d: "M136.404 96.413C137.286 96.413 138.001 95.6979 138.001 94.8159C138.001 93.9338 137.286 93.2188 136.404 93.2188C135.522 93.2188 134.807 93.9338 134.807 94.8159C134.807 95.6979 135.522 96.413 136.404 96.413Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_866",
    d: "M136.404 99.6073C137.286 99.6073 138.001 98.8923 138.001 98.0102C138.001 97.1281 137.286 96.4131 136.404 96.4131C135.522 96.4131 134.807 97.1281 134.807 98.0102C134.807 98.8923 135.522 99.6073 136.404 99.6073Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_867",
    d: "M136.404 102.802C137.286 102.802 138.001 102.087 138.001 101.205C138.001 100.322 137.286 99.6074 136.404 99.6074C135.522 99.6074 134.807 100.322 134.807 101.205C134.807 102.087 135.522 102.802 136.404 102.802Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_868",
    d: "M136.404 105.996C137.286 105.996 138.001 105.281 138.001 104.399C138.001 103.517 137.286 102.802 136.404 102.802C135.522 102.802 134.807 103.517 134.807 104.399C134.807 105.281 135.522 105.996 136.404 105.996Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_869",
    d: "M136.404 109.19C137.286 109.19 138.001 108.475 138.001 107.593C138.001 106.711 137.286 105.996 136.404 105.996C135.522 105.996 134.807 106.711 134.807 107.593C134.807 108.475 135.522 109.19 136.404 109.19Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_870",
    d: "M136.404 131.55C137.286 131.55 138.001 130.835 138.001 129.953C138.001 129.071 137.286 128.355 136.404 128.355C135.522 128.355 134.807 129.071 134.807 129.953C134.807 130.835 135.522 131.55 136.404 131.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_871",
    d: "M136.404 134.744C137.286 134.744 138.001 134.029 138.001 133.147C138.001 132.265 137.286 131.55 136.404 131.55C135.522 131.55 134.807 132.265 134.807 133.147C134.807 134.029 135.522 134.744 136.404 134.744Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_872",
    d: "M136.404 141.133C137.286 141.133 138.001 140.418 138.001 139.536C138.001 138.654 137.286 137.938 136.404 137.938C135.522 137.938 134.807 138.654 134.807 139.536C134.807 140.418 135.522 141.133 136.404 141.133Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_873",
    d: "M139.599 29.3339C140.481 29.3339 141.196 28.6188 141.196 27.7368C141.196 26.8547 140.481 26.1396 139.599 26.1396C138.717 26.1396 138.002 26.8547 138.002 27.7368C138.002 28.6188 138.717 29.3339 139.599 29.3339Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_874",
    d: "M139.599 32.5282C140.481 32.5282 141.196 31.8132 141.196 30.9311C141.196 30.049 140.481 29.334 139.599 29.334C138.717 29.334 138.002 30.049 138.002 30.9311C138.002 31.8132 138.717 32.5282 139.599 32.5282Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_875",
    d: "M139.599 35.7226C140.481 35.7226 141.196 35.0075 141.196 34.1254C141.196 33.2434 140.481 32.5283 139.599 32.5283C138.717 32.5283 138.002 33.2434 138.002 34.1254C138.002 35.0075 138.717 35.7226 139.599 35.7226Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_876",
    d: "M139.599 38.9169C140.481 38.9169 141.196 38.2018 141.196 37.3198C141.196 36.4377 140.481 35.7227 139.599 35.7227C138.717 35.7227 138.002 36.4377 138.002 37.3198C138.002 38.2018 138.717 38.9169 139.599 38.9169Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_877",
    d: "M139.599 42.1112C140.481 42.1112 141.196 41.3962 141.196 40.5141C141.196 39.632 140.481 38.917 139.599 38.917C138.717 38.917 138.002 39.632 138.002 40.5141C138.002 41.3962 138.717 42.1112 139.599 42.1112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_878",
    d: "M139.599 45.3056C140.481 45.3056 141.196 44.5905 141.196 43.7085C141.196 42.8264 140.481 42.1113 139.599 42.1113C138.717 42.1113 138.002 42.8264 138.002 43.7085C138.002 44.5905 138.717 45.3056 139.599 45.3056Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_879",
    d: "M139.599 48.4999C140.481 48.4999 141.196 47.7849 141.196 46.9028C141.196 46.0207 140.481 45.3057 139.599 45.3057C138.717 45.3057 138.002 46.0207 138.002 46.9028C138.002 47.7849 138.717 48.4999 139.599 48.4999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_880",
    d: "M139.599 51.6942C140.481 51.6942 141.196 50.9792 141.196 50.0971C141.196 49.2151 140.481 48.5 139.599 48.5C138.717 48.5 138.002 49.2151 138.002 50.0971C138.002 50.9792 138.717 51.6942 139.599 51.6942Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_881",
    d: "M139.599 54.8886C140.481 54.8886 141.196 54.1735 141.196 53.2915C141.196 52.4094 140.481 51.6943 139.599 51.6943C138.717 51.6943 138.002 52.4094 138.002 53.2915C138.002 54.1735 138.717 54.8886 139.599 54.8886Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_882",
    d: "M139.599 61.2763C140.481 61.2763 141.196 60.5612 141.196 59.6792C141.196 58.7971 140.481 58.082 139.599 58.082C138.717 58.082 138.002 58.7971 138.002 59.6792C138.002 60.5612 138.717 61.2763 139.599 61.2763Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_883",
    d: "M139.599 64.4706C140.481 64.4706 141.196 63.7556 141.196 62.8735C141.196 61.9914 140.481 61.2764 139.599 61.2764C138.717 61.2764 138.002 61.9914 138.002 62.8735C138.002 63.7556 138.717 64.4706 139.599 64.4706Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_884",
    d: "M139.599 67.665C140.481 67.665 141.196 66.9499 141.196 66.0678C141.196 65.1858 140.481 64.4707 139.599 64.4707C138.717 64.4707 138.002 65.1858 138.002 66.0678C138.002 66.9499 138.717 67.665 139.599 67.665Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_885",
    d: "M139.599 70.8593C140.481 70.8593 141.196 70.1442 141.196 69.2622C141.196 68.3801 140.481 67.665 139.599 67.665C138.717 67.665 138.002 68.3801 138.002 69.2622C138.002 70.1442 138.717 70.8593 139.599 70.8593Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_886",
    d: "M139.599 74.0536C140.481 74.0536 141.196 73.3386 141.196 72.4565C141.196 71.5744 140.481 70.8594 139.599 70.8594C138.717 70.8594 138.002 71.5744 138.002 72.4565C138.002 73.3386 138.717 74.0536 139.599 74.0536Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_887",
    d: "M139.599 80.4423C140.481 80.4423 141.196 79.7272 141.196 78.8452C141.196 77.9631 140.481 77.248 139.599 77.248C138.717 77.248 138.002 77.9631 138.002 78.8452C138.002 79.7272 138.717 80.4423 139.599 80.4423Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_888",
    d: "M139.599 99.6073C140.481 99.6073 141.196 98.8923 141.196 98.0102C141.196 97.1281 140.481 96.4131 139.599 96.4131C138.717 96.4131 138.002 97.1281 138.002 98.0102C138.002 98.8923 138.717 99.6073 139.599 99.6073Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_889",
    d: "M139.599 105.996C140.481 105.996 141.196 105.281 141.196 104.399C141.196 103.517 140.481 102.802 139.599 102.802C138.717 102.802 138.002 103.517 138.002 104.399C138.002 105.281 138.717 105.996 139.599 105.996Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_890",
    d: "M139.599 109.19C140.481 109.19 141.196 108.475 141.196 107.593C141.196 106.711 140.481 105.996 139.599 105.996C138.717 105.996 138.002 106.711 138.002 107.593C138.002 108.475 138.717 109.19 139.599 109.19Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_891",
    d: "M139.599 112.385C140.481 112.385 141.196 111.67 141.196 110.788C141.196 109.905 140.481 109.19 139.599 109.19C138.717 109.19 138.002 109.905 138.002 110.788C138.002 111.67 138.717 112.385 139.599 112.385Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_892",
    d: "M139.599 115.579C140.481 115.579 141.196 114.864 141.196 113.982C141.196 113.1 140.481 112.385 139.599 112.385C138.717 112.385 138.002 113.1 138.002 113.982C138.002 114.864 138.717 115.579 139.599 115.579Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_893",
    d: "M139.599 121.968C140.481 121.968 141.196 121.253 141.196 120.371C141.196 119.488 140.481 118.773 139.599 118.773C138.717 118.773 138.002 119.488 138.002 120.371C138.002 121.253 138.717 121.968 139.599 121.968Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_894",
    d: "M139.599 128.356C140.481 128.356 141.196 127.641 141.196 126.759C141.196 125.877 140.481 125.162 139.599 125.162C138.717 125.162 138.002 125.877 138.002 126.759C138.002 127.641 138.717 128.356 139.599 128.356Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_895",
    d: "M139.599 131.55C140.481 131.55 141.196 130.835 141.196 129.953C141.196 129.071 140.481 128.355 139.599 128.355C138.717 128.355 138.002 129.071 138.002 129.953C138.002 130.835 138.717 131.55 139.599 131.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_896",
    d: "M139.599 134.744C140.481 134.744 141.196 134.029 141.196 133.147C141.196 132.265 140.481 131.55 139.599 131.55C138.717 131.55 138.002 132.265 138.002 133.147C138.002 134.029 138.717 134.744 139.599 134.744Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_897",
    d: "M142.792 32.5282C143.675 32.5282 144.39 31.8132 144.39 30.9311C144.39 30.049 143.675 29.334 142.792 29.334C141.91 29.334 141.195 30.049 141.195 30.9311C141.195 31.8132 141.91 32.5282 142.792 32.5282Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_898",
    d: "M142.792 35.7226C143.675 35.7226 144.39 35.0075 144.39 34.1254C144.39 33.2434 143.675 32.5283 142.792 32.5283C141.91 32.5283 141.195 33.2434 141.195 34.1254C141.195 35.0075 141.91 35.7226 142.792 35.7226Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_899",
    d: "M142.792 38.9169C143.675 38.9169 144.39 38.2018 144.39 37.3198C144.39 36.4377 143.675 35.7227 142.792 35.7227C141.91 35.7227 141.195 36.4377 141.195 37.3198C141.195 38.2018 141.91 38.9169 142.792 38.9169Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_900",
    d: "M142.792 58.0819C143.675 58.0819 144.39 57.3669 144.39 56.4848C144.39 55.6028 143.675 54.8877 142.792 54.8877C141.91 54.8877 141.195 55.6028 141.195 56.4848C141.195 57.3669 141.91 58.0819 142.792 58.0819Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_901",
    d: "M142.792 61.2763C143.675 61.2763 144.39 60.5612 144.39 59.6792C144.39 58.7971 143.675 58.082 142.792 58.082C141.91 58.082 141.195 58.7971 141.195 59.6792C141.195 60.5612 141.91 61.2763 142.792 61.2763Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_902",
    d: "M142.792 64.4706C143.675 64.4706 144.39 63.7556 144.39 62.8735C144.39 61.9914 143.675 61.2764 142.792 61.2764C141.91 61.2764 141.195 61.9914 141.195 62.8735C141.195 63.7556 141.91 64.4706 142.792 64.4706Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_903",
    d: "M142.792 67.665C143.675 67.665 144.39 66.9499 144.39 66.0678C144.39 65.1858 143.675 64.4707 142.792 64.4707C141.91 64.4707 141.195 65.1858 141.195 66.0678C141.195 66.9499 141.91 67.665 142.792 67.665Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_904",
    d: "M142.792 74.0536C143.675 74.0536 144.39 73.3386 144.39 72.4565C144.39 71.5744 143.675 70.8594 142.792 70.8594C141.91 70.8594 141.195 71.5744 141.195 72.4565C141.195 73.3386 141.91 74.0536 142.792 74.0536Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_905",
    d: "M142.792 86.831C143.675 86.831 144.39 86.1159 144.39 85.2338C144.39 84.3518 143.675 83.6367 142.792 83.6367C141.91 83.6367 141.195 84.3518 141.195 85.2338C141.195 86.1159 141.91 86.831 142.792 86.831Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_906",
    d: "M142.792 99.6073C143.675 99.6073 144.39 98.8923 144.39 98.0102C144.39 97.1281 143.675 96.4131 142.792 96.4131C141.91 96.4131 141.195 97.1281 141.195 98.0102C141.195 98.8923 141.91 99.6073 142.792 99.6073Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_907",
    d: "M142.792 105.996C143.675 105.996 144.39 105.281 144.39 104.399C144.39 103.517 143.675 102.802 142.792 102.802C141.91 102.802 141.195 103.517 141.195 104.399C141.195 105.281 141.91 105.996 142.792 105.996Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_908",
    d: "M142.792 109.19C143.675 109.19 144.39 108.475 144.39 107.593C144.39 106.711 143.675 105.996 142.792 105.996C141.91 105.996 141.195 106.711 141.195 107.593C141.195 108.475 141.91 109.19 142.792 109.19Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_909",
    d: "M142.792 112.385C143.675 112.385 144.39 111.67 144.39 110.788C144.39 109.905 143.675 109.19 142.792 109.19C141.91 109.19 141.195 109.905 141.195 110.788C141.195 111.67 141.91 112.385 142.792 112.385Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_910",
    d: "M142.792 115.579C143.675 115.579 144.39 114.864 144.39 113.982C144.39 113.1 143.675 112.385 142.792 112.385C141.91 112.385 141.195 113.1 141.195 113.982C141.195 114.864 141.91 115.579 142.792 115.579Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_911",
    d: "M142.792 128.356C143.675 128.356 144.39 127.641 144.39 126.759C144.39 125.877 143.675 125.162 142.792 125.162C141.91 125.162 141.195 125.877 141.195 126.759C141.195 127.641 141.91 128.356 142.792 128.356Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_912",
    d: "M142.792 134.744C143.675 134.744 144.39 134.029 144.39 133.147C144.39 132.265 143.675 131.55 142.792 131.55C141.91 131.55 141.195 132.265 141.195 133.147C141.195 134.029 141.91 134.744 142.792 134.744Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_913",
    d: "M142.792 144.327C143.675 144.327 144.39 143.612 144.39 142.73C144.39 141.848 143.675 141.133 142.792 141.133C141.91 141.133 141.195 141.848 141.195 142.73C141.195 143.612 141.91 144.327 142.792 144.327Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_914",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.648438 8.57156V14.9601C0.648438 17.078 1.48978 19.1092 2.98737 20.6067C4.48497 22.1043 6.51614 22.9457 8.63406 22.9457H15.0226C17.1405 22.9457 19.1717 22.1043 20.6692 20.6067C22.1668 19.1092 23.0082 17.078 23.0082 14.9601V8.57156C23.0082 6.45364 22.1668 4.42247 20.6692 2.92487C19.1717 1.42728 17.1405 0.585938 15.0226 0.585938H8.63406C6.51614 0.585938 4.48497 1.42728 2.98737 2.92487C1.48978 4.42247 0.648438 6.45364 0.648438 8.57156ZM8.63406 3.78019H15.0226C16.2933 3.78019 17.512 4.28499 18.4106 5.18355C19.3091 6.0821 19.8139 7.30081 19.8139 8.57156V14.9601C19.8139 16.2308 19.3091 17.4495 18.4106 18.3481C17.512 19.2466 16.2933 19.7514 15.0226 19.7514H8.63406C7.36331 19.7514 6.1446 19.2466 5.24605 18.3481C4.34749 17.4495 3.84269 16.2308 3.84269 14.9601V8.57156C3.84269 7.30081 4.34749 6.0821 5.24605 5.18355C6.1446 4.28499 7.36331 3.78019 8.63406 3.78019Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_915",
    d: "M8.63423 10.1689C9.5163 10.1689 10.2314 9.4538 10.2314 8.57173C10.2314 7.68967 9.5163 6.97461 8.63423 6.97461C7.75217 6.97461 7.03711 7.68967 7.03711 8.57173C7.03711 9.4538 7.75217 10.1689 8.63423 10.1689Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_916",
    d: "M8.63423 13.3632C9.5163 13.3632 10.2314 12.6481 10.2314 11.7661C10.2314 10.884 9.5163 10.1689 8.63423 10.1689C7.75217 10.1689 7.03711 10.884 7.03711 11.7661C7.03711 12.6481 7.75217 13.3632 8.63423 13.3632Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_917",
    d: "M8.63423 16.5575C9.5163 16.5575 10.2314 15.8425 10.2314 14.9604C10.2314 14.0783 9.5163 13.3633 8.63423 13.3633C7.75217 13.3633 7.03711 14.0783 7.03711 14.9604C7.03711 15.8425 7.75217 16.5575 8.63423 16.5575Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_918",
    d: "M11.8276 10.1689C12.7097 10.1689 13.4247 9.4538 13.4247 8.57173C13.4247 7.68967 12.7097 6.97461 11.8276 6.97461C10.9455 6.97461 10.2305 7.68967 10.2305 8.57173C10.2305 9.4538 10.9455 10.1689 11.8276 10.1689Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_919",
    d: "M11.8276 13.3632C12.7097 13.3632 13.4247 12.6481 13.4247 11.7661C13.4247 10.884 12.7097 10.1689 11.8276 10.1689C10.9455 10.1689 10.2305 10.884 10.2305 11.7661C10.2305 12.6481 10.9455 13.3632 11.8276 13.3632Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_920",
    d: "M11.8276 16.5575C12.7097 16.5575 13.4247 15.8425 13.4247 14.9604C13.4247 14.0783 12.7097 13.3633 11.8276 13.3633C10.9455 13.3633 10.2305 14.0783 10.2305 14.9604C10.2305 15.8425 10.9455 16.5575 11.8276 16.5575Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_921",
    d: "M15.021 10.1689C15.903 10.1689 16.6181 9.4538 16.6181 8.57173C16.6181 7.68967 15.903 6.97461 15.021 6.97461C14.1389 6.97461 13.4238 7.68967 13.4238 8.57173C13.4238 9.4538 14.1389 10.1689 15.021 10.1689Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_922",
    d: "M15.021 13.3632C15.903 13.3632 16.6181 12.6481 16.6181 11.7661C16.6181 10.884 15.903 10.1689 15.021 10.1689C14.1389 10.1689 13.4238 10.884 13.4238 11.7661C13.4238 12.6481 14.1389 13.3632 15.021 13.3632Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_923",
    d: "M15.021 16.5575C15.903 16.5575 16.6181 15.8425 16.6181 14.9604C16.6181 14.0783 15.903 13.3633 15.021 13.3633C14.1389 13.3633 13.4238 14.0783 13.4238 14.9604C13.4238 15.8425 14.1389 16.5575 15.021 16.5575Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_924",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.405 0.585938L130.017 0.585938C127.899 0.585938 125.867 1.42728 124.37 2.92487C122.872 4.42247 122.031 6.45364 122.031 8.57156V14.9601C122.031 17.078 122.872 19.1091 124.37 20.6067C125.867 22.1043 127.899 22.9457 130.017 22.9457H136.405C138.523 22.9457 140.554 22.1043 142.052 20.6067C143.549 19.1091 144.391 17.078 144.391 14.9601V8.57156C144.391 6.45364 143.549 4.42247 142.052 2.92487C140.554 1.42728 138.523 0.585938 136.405 0.585938ZM141.196 8.57156V14.9601C141.196 16.2308 140.692 17.4495 139.793 18.3481C138.894 19.2466 137.676 19.7514 136.405 19.7514H130.017C128.746 19.7514 127.527 19.2466 126.628 18.3481C125.73 17.4495 125.225 16.2308 125.225 14.9601V8.57156C125.225 7.30081 125.73 6.0821 126.628 5.18354C127.527 4.28499 128.746 3.78019 130.017 3.78019L136.405 3.78019C137.676 3.78019 138.894 4.28499 139.793 5.18354C140.692 6.0821 141.196 7.30081 141.196 8.57156Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_925",
    d: "M130.015 10.1689C130.897 10.1689 131.612 9.4538 131.612 8.57173C131.612 7.68967 130.897 6.97461 130.015 6.97461C129.133 6.97461 128.418 7.68967 128.418 8.57173C128.418 9.4538 129.133 10.1689 130.015 10.1689Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_926",
    d: "M130.015 13.3632C130.897 13.3632 131.612 12.6481 131.612 11.7661C131.612 10.884 130.897 10.1689 130.015 10.1689C129.133 10.1689 128.418 10.884 128.418 11.7661C128.418 12.6481 129.133 13.3632 130.015 13.3632Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_927",
    d: "M130.015 16.5575C130.897 16.5575 131.612 15.8425 131.612 14.9604C131.612 14.0783 130.897 13.3633 130.015 13.3633C129.133 13.3633 128.418 14.0783 128.418 14.9604C128.418 15.8425 129.133 16.5575 130.015 16.5575Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_928",
    d: "M133.208 10.1689C134.091 10.1689 134.806 9.4538 134.806 8.57173C134.806 7.68967 134.091 6.97461 133.208 6.97461C132.326 6.97461 131.611 7.68967 131.611 8.57173C131.611 9.4538 132.326 10.1689 133.208 10.1689Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_929",
    d: "M133.208 13.3632C134.091 13.3632 134.806 12.6481 134.806 11.7661C134.806 10.884 134.091 10.1689 133.208 10.1689C132.326 10.1689 131.611 10.884 131.611 11.7661C131.611 12.6481 132.326 13.3632 133.208 13.3632Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_930",
    d: "M133.208 16.5575C134.091 16.5575 134.806 15.8425 134.806 14.9604C134.806 14.0783 134.091 13.3633 133.208 13.3633C132.326 13.3633 131.611 14.0783 131.611 14.9604C131.611 15.8425 132.326 16.5575 133.208 16.5575Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_931",
    d: "M136.404 10.1689C137.286 10.1689 138.001 9.4538 138.001 8.57173C138.001 7.68967 137.286 6.97461 136.404 6.97461C135.522 6.97461 134.807 7.68967 134.807 8.57173C134.807 9.4538 135.522 10.1689 136.404 10.1689Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_932",
    d: "M136.404 13.3632C137.286 13.3632 138.001 12.6481 138.001 11.7661C138.001 10.884 137.286 10.1689 136.404 10.1689C135.522 10.1689 134.807 10.884 134.807 11.7661C134.807 12.6481 135.522 13.3632 136.404 13.3632Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_933",
    d: "M136.404 16.5575C137.286 16.5575 138.001 15.8425 138.001 14.9604C138.001 14.0783 137.286 13.3633 136.404 13.3633C135.522 13.3633 134.807 14.0783 134.807 14.9604C134.807 15.8425 135.522 16.5575 136.404 16.5575Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_934",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.63406 144.327H15.0226C17.1405 144.327 19.1716 143.486 20.6692 141.988C22.1668 140.491 23.0082 138.459 23.0082 136.342V129.953C23.0082 127.835 22.1668 125.804 20.6692 124.306C19.1716 122.809 17.1405 121.967 15.0226 121.967H8.63406C6.51614 121.967 4.48497 122.809 2.98737 124.306C1.48978 125.804 0.648438 127.835 0.648438 129.953L0.648438 136.342C0.648438 138.459 1.48978 140.491 2.98737 141.988C4.48497 143.486 6.51614 144.327 8.63406 144.327ZM3.84269 136.342L3.84269 129.953C3.84269 128.682 4.34749 127.464 5.24604 126.565C6.1446 125.666 7.36331 125.162 8.63406 125.162H15.0226C16.2933 125.162 17.512 125.666 18.4106 126.565C19.3091 127.464 19.8139 128.682 19.8139 129.953V136.342C19.8139 137.612 19.3091 138.831 18.4106 139.73C17.512 140.628 16.2933 141.133 15.0226 141.133H8.63406C7.36331 141.133 6.1446 140.628 5.24604 139.73C4.34749 138.831 3.84269 137.612 3.84269 136.342Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_935",
    d: "M8.63423 131.55C9.5163 131.55 10.2314 130.835 10.2314 129.953C10.2314 129.071 9.5163 128.355 8.63423 128.355C7.75217 128.355 7.03711 129.071 7.03711 129.953C7.03711 130.835 7.75217 131.55 8.63423 131.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_936",
    d: "M8.63423 134.744C9.5163 134.744 10.2314 134.029 10.2314 133.147C10.2314 132.265 9.5163 131.55 8.63423 131.55C7.75217 131.55 7.03711 132.265 7.03711 133.147C7.03711 134.029 7.75217 134.744 8.63423 134.744Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_937",
    d: "M8.63423 137.938C9.5163 137.938 10.2314 137.223 10.2314 136.341C10.2314 135.459 9.5163 134.744 8.63423 134.744C7.75217 134.744 7.03711 135.459 7.03711 136.341C7.03711 137.223 7.75217 137.938 8.63423 137.938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_938",
    d: "M11.8276 131.55C12.7097 131.55 13.4247 130.835 13.4247 129.953C13.4247 129.071 12.7097 128.355 11.8276 128.355C10.9455 128.355 10.2305 129.071 10.2305 129.953C10.2305 130.835 10.9455 131.55 11.8276 131.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_939",
    d: "M11.8276 134.744C12.7097 134.744 13.4247 134.029 13.4247 133.147C13.4247 132.265 12.7097 131.55 11.8276 131.55C10.9455 131.55 10.2305 132.265 10.2305 133.147C10.2305 134.029 10.9455 134.744 11.8276 134.744Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_940",
    d: "M11.8276 137.938C12.7097 137.938 13.4247 137.223 13.4247 136.341C13.4247 135.459 12.7097 134.744 11.8276 134.744C10.9455 134.744 10.2305 135.459 10.2305 136.341C10.2305 137.223 10.9455 137.938 11.8276 137.938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_941",
    d: "M15.021 131.55C15.903 131.55 16.6181 130.835 16.6181 129.953C16.6181 129.071 15.903 128.355 15.021 128.355C14.1389 128.355 13.4238 129.071 13.4238 129.953C13.4238 130.835 14.1389 131.55 15.021 131.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_942",
    d: "M15.021 134.744C15.903 134.744 16.6181 134.029 16.6181 133.147C16.6181 132.265 15.903 131.55 15.021 131.55C14.1389 131.55 13.4238 132.265 13.4238 133.147C13.4238 134.029 14.1389 134.744 15.021 134.744Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_943",
    d: "M15.021 137.938C15.903 137.938 16.6181 137.223 16.6181 136.341C16.6181 135.459 15.903 134.744 15.021 134.744C14.1389 134.744 13.4238 135.459 13.4238 136.341C13.4238 137.223 14.1389 137.938 15.021 137.938Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_795_83251)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_944",
    d: "M152.375 -7.39941H-7.33789V152.313H152.375V-7.39941Z",
    fill: "black"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaystoreQr);
export default __webpack_public_path__ + "static/media/playstore-qr.82a38365b54081940bde12594eeb829c.svg";
export { ForwardRef as ReactComponent };